function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareDataWithCoalition({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1280,
    height: 720,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M0 0L0 176L16 176L16 192L32 192L32 224L36 224L36 240L40 240L40 272L72 272L72 280L48 282L48 304L36 304L33 316L32 316L32 312L31 312L28 320L32 320L32 328L28 328L28 344L26 344L26 328L20 328L20.0231 344.91L24 354L42 358L40 362C48.6418 368.804 56.6679 374.104 68 375C68.592 379.791 81.2846 383.926 86 384C86.0851 379.238 87.9051 371.408 84 368L84 367C89.5184 361.621 98.5459 357.221 99 349L98 349L97 352L98 348L98 347C93.3936 342.609 92.069 334.23 92 328L104 328C104.697 336.765 125.648 340.902 133.275 343.594C136.812 344.843 141.183 347.222 144 344L145 344L146 344L152 348L163.148 367.142L172.852 368.603L178.317 375.397L208 376L206 368C208.294 362.587 206.459 355.056 212 352L222 303L224 304C224.278 295.438 234.547 280.824 239 273L239 272C233.987 264.805 240.896 246.977 240.401 238.004C239.912 229.138 234.396 218.93 231.117 210.845C227.602 202.177 227.228 191.967 224 183L233 164L235 165C241.846 158.839 251.597 159.65 255 150L260 152L265 157L273 148L275 153L277 153L280 146L282 146L288 153L291 145L296 151L312 148L308 152L308 153C315.182 154.465 318.013 161.894 320.971 168C331.089 188.882 319.2 207.432 321 229L320 229L320 227L319 227L317 240L319 240L318 272C322.424 277.322 326.528 285.893 329.971 292.039C332.091 295.825 331.109 300.052 336 301L335 304C340.426 304.414 341.886 306.911 343 312L340 313L341 316L347 324C352.334 325.014 354.603 331.243 356 336L352 335L352 336L356 340L357 340L358 338L360 344L364 344C365.208 348.421 367.371 351.224 372 352L372 376L373 377C377.416 374.474 381.002 371.32 381 366L387 365L389 363L388 360L390 358L393 359L405 352L404 349L416 348L416 344C420.456 345.165 421.694 347.531 422 352L424 352L423 336L430 336L430 332L431 332L435 336L437 347L442 354L426 354L426 353L428 353L428 352L412 353L413 357L414 357L415 354L416 360L413 360C413.103 373.504 407.355 375.029 402 386L401 386L400 386L390 380L392 384C380.797 376.831 372.525 382.143 360 381L361 379L348 381L347 382L348 384C338.679 387.906 333.009 393.829 331.58 404C331.211 406.63 331.12 420.845 336 418L337 418L337 422C332.065 423.735 331.867 434.097 331 439L330 439L329 437L328 441L329 441L329 439L330 439L326 449L319 450L318 450L318 452L317 452L317 448L313 449L316 453L316 454L314 468L315 468L315 464L316 464L316 468L329 468L329 481L314 481C314 488.022 311.971 498.982 315.653 505.28C318.823 510.703 325.494 506.712 329.486 509.773C334.075 513.292 331.505 520.522 326.711 522.193C323.923 523.164 321.606 522.442 319 524L312 524L314 521L309 522L309 521L311 520L308 519L309 521L308 521L306 517L305 517L306 519L305 519L304 515L302 512L300 513L301 510L299 510L300 481L299 481L299 486L298 486L298 482C283.465 479.358 293.292 470.689 298 465L299 465L299 468L300 468C300 462.512 298.744 455.088 303 451L303 450L296 456L298 452C280.555 458.921 270.628 475.295 266 493L262 492L266 507L265 507L265 505L264 505C264.232 511.978 276.513 516.965 283 519L288 526L305 528L304 525L306 526L304 523L308 524L307 528L310 527L309 524L324 531L336 530L344 534L369.054 535.183L396 530L394 527L399 526C403.523 517.999 416.779 509.297 425 517C430.791 518.56 433.785 525.515 437.847 529.542C442.151 533.81 451.209 539.085 457.004 540.621C478.063 546.204 502.38 544.246 523.999 545.036C567.693 546.634 613.713 548.351 657 541.59C666.929 540.039 676.961 536.807 687 536.149C699.756 535.312 721.368 540.509 727 524L729 526L729 524L730 524L731 526L731 522L733 517L740 494L744 488L744 482L738 482C738 475.845 736.328 468.224 744 467L744 456L745 456L745 467L746 467L746 453L763 452L763 451C758.778 451 761.619 442.952 762 440L760 436L747.089 437.962L732 430L733 433L736 431C732.907 436.294 726.596 435.058 721.286 436.452C707.394 440.098 694.416 445.019 680 447L681 449L674 449L674 450L676 450L676 451L670 449C663.295 470.33 668 498.739 668 521L653 521L653 470L653.743 452.603L668 451L668 450L660 450L660 449L665 449L665 448L650 441L651 439L648 438C648 441.992 644 437.221 644 435L625 425L616 425L616 424L619 423C612.466 420.822 603.73 424.577 593 421C589.755 419.918 588.639 415.91 585 415C572.792 411.948 560.479 407.12 548 404C542.731 402.683 521.491 409.035 523 403L517 405L495 400L500.897 381.019L493 369L491 370L491 369L492 366C486.328 362.773 483.074 355.785 490 352L496 333L495 333L495 336L494 336C493.97 325.135 489.644 322.494 485.028 313.91C482.913 309.978 484.453 306.382 481 303L481 302C487.355 294.971 499.994 280.747 500 271L505 267L501 270L500 264L500 263C496.768 263.539 495.275 264.898 496 262L493 263L494 261L486 253L484 253C484.254 249.199 481.992 244.703 483.468 241.059C485.694 235.564 498.776 235.126 504 235L503 233L506 234L507 229L510 229L510 228L508 229L508 228L511 227L510 224L514 219C510.911 215.028 515.619 207.559 519.133 204.969C531.284 196.015 549.039 196.869 558.195 182.281C562.15 175.979 556.98 166.624 562 160L562 159L556 157L556 155L560 154L560 144L552 138L554 136C550.171 124.205 543.886 116.978 548 104L549 93L550 97C556.487 96.1417 554.708 92.335 558 88L558 87L558 86L556 84L560 84L558 99C571.219 97.3278 591.261 98.9064 592 82L608 84L621 80L621 79L616 79L616 78L636 66L634 56L639 56C639 40.9702 641.721 31.8721 626 26L628 22C618.505 19.5425 616.001 18.1956 616 8C612.489 8 608.854 7.01294 608 11L607 11L606 7C610.228 5.78192 614.499 4.39435 616 0L0 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M616 0L606 7L607 11L608 11L608 8L616 8C616 18.3963 617.859 20.0334 628 22L626 26C629.801 27.9211 634.647 28.9562 637.397 32.4684C641.355 37.5258 639 49.8289 639 56L634 56L636 66C626.37 68.1672 623.675 72.5402 616 78L616 79L621 79L621 80L608 84L592 82C590.616 98.7801 570.992 96.5776 558 99L560 84L556 84L558 86L558 87L558 88L550 97L549 93C547.334 95.84 545.496 101.52 548 104C543.008 115.829 549.18 125.445 554 136C552.469 135.99 551.451 136.574 552.722 138.583C556.983 145.316 560 145.044 560 154L556 155L556 157L562 159L562 160C560.607 160.279 556.864 172.273 558 175C558.675 176.621 561.193 177.615 560 180C555.475 189.05 538.135 198.955 529 202C527.932 202.356 520.836 201.59 517 205C513.345 208.249 510.333 218.267 514 219L510 225C514.77 225.108 524.752 223.17 527.442 218.772C529.571 215.294 530.7 203.485 536.069 203.485C542.223 203.485 547.565 216.466 549.892 221C559.062 238.863 560.08 262.063 579 273L590.468 247.015L613 226L606 230L607 228L606 228L605 232L602 232L605 228L605 227L602 228L603 226C601.357 226.847 599.789 227.753 597.976 228.196C584.667 231.447 592.619 213.89 583 212C578.703 201.003 579.685 185.508 592 180L592 176L597 176L597 175L592 173L600 171C602.644 178.375 617.45 174 624 174C623.604 178.882 625.586 180.41 630 182L645 167L649 167L655 161L653 162L653 161L666 160L666 163C672.596 164.277 683.385 174.256 681.507 181.83C680.463 186.044 671.063 193.825 667 191L666 191L666 193L665 193L660 192L660 198L663 196L664 196L665 198L666 198L666 196L668 196L672 203L672 192C681.968 199.746 673.81 214.208 677 225L680 224C674.651 229.525 663.91 229.618 657 228L656 231C649.622 229.645 633.776 239.904 632 246L624 244L617 244L620 242C614.863 238.5 614.051 235.029 614 229L613 229C613 243.162 616.303 241.884 625.674 250.529C631.504 255.907 633.439 260.717 642 262C641.622 279.674 621.52 279.255 618.62 295C617.335 301.974 624.95 318.276 619.48 323.262C617.052 325.474 613.021 324.995 610 325C602.777 325.012 588.246 327.74 582.225 323.258C577.251 319.555 576.97 311.923 571.826 307.789C568.544 305.15 557.611 302.749 556.461 298.723C555.343 294.804 561.64 291.355 563.721 288.91C567.054 284.996 568.5 279.012 569 274C561.418 275.53 558.19 282.029 553 287L549 272L544 290C532.26 291.318 528.445 303.14 540 308C538.46 311.02 531.497 325.14 527.39 323.654C523.313 322.18 523.283 310.592 522.611 307C519.679 291.325 518.055 264.055 498 264L501 270L505 267L500 271C499.232 281.754 486.635 293.156 481 302L481 303C483.806 306.901 482.854 310.932 485.028 314.826C489.557 322.941 493.913 325.622 494 336L495 336L495 333L496 333L490 352C482.167 354.575 485.91 363.73 492 366L491 370L493 369L492 372C505.068 381.31 496.984 387.496 495 400L517 405L523 403C524.016 409.423 542.229 403.56 547 404.431C563.665 407.472 577.376 416.498 593.06 420.662C601.717 422.961 610.21 421.67 619 423L616 424L616 425L625 425C627.607 428.806 639.445 435.002 644 435C644.202 437.012 647.32 441.774 648 438L651 439L650 441L665 448L665 449L660 449L660 450L668 450L668 454L669 454L670 449L676 451L676 450L674 450L674 449L681 449L680 447C694.294 445.823 707.759 440.868 721.286 436.714C726.27 435.183 733.97 436.775 736 431L733 433L732 430L750 439.152L760 436L762 440C761.322 443.096 758.809 450.334 763 451L763 452L746 453L761 455L761 468L776 469L775 481L761 481C761 496.004 757.401 510.464 777 508L777 521C771.452 521.701 765.552 522.816 760 521.467C742.716 517.266 744.934 494.653 746 481L738 481L738 482L744 482L744 488C739.524 489.031 739.569 494.213 738.925 498.17C737.604 506.292 736.188 515.371 731 522L730 524L729 524L729 526L727 524C718.202 540.899 698.326 534.866 683.424 536.245C674.582 537.063 665.821 540.151 657 541.428C618.29 547.034 578.36 545.938 539.348 545.337C513.83 544.944 486.067 546.475 461 541.334C453.95 539.888 443.51 534.707 438.424 529.492C434.265 525.228 431.291 518.028 425 517C418.595 507.934 401.887 518.233 399 526L394 527L396 530L369.389 534.944L344 534L336 530L324 531L309 524L307 528L308 524L304 523L306 526L304 525L305 528L288 526L283 519C276.942 516.273 264.524 511.783 264 505L265 505L265 507L266 507L263 504L262 492L266 493C273.047 474.457 280.372 461.801 298 452L296 456L303 450L303 451L300 454L316 454L313 449L317 448L317 452L319 450L326 449L330 439L329 439L329 441L328 441L330 439L331 439L337 422L337 418L336 418L335 420C329.91 410.758 330.079 399.44 337.459 391.301C340.509 387.938 346.054 386.555 347 382L348 381L350 382L361 379L360 381L381.718 379.069L392 384L390 380L400 386L401 386L402 386C409.533 375.655 413.275 373.412 413 360L416 360L415 354L414 357L413 357L412 353L428 352L428 353L426 353L426 354L442 354L437 347L435 336L431 332L430 332L430 336L423 336L424 352L422 352C421.857 347.289 420.942 344.726 416 344L416 348L404 349L405 352L393 359L390 358L389 363L387 365L381 366C380.697 371.072 376.712 373.936 373 377L372 376L372 352L364 344L360 344L358 338L357 340L356 340L352 336L352 335L356 336C355.071 330.849 352.734 324.563 347 324L341 316L340 313L343 312C342.228 306.435 340.787 304.19 335 304L336 301L330.536 292.025L318 272L319 240L317 240L319 227L320 227L320 229L321 229C320.203 207.795 331.033 188.445 321.445 168C318.468 161.653 315.665 153.863 308 153L308 152L312 148C305.548 147.495 301.667 147.44 296 151L291 145L288 153L282 146L280 146L277 153L275 153L273 148L265 157L260 152L255 150L235 165L233 164L224 183C226.226 191.933 227.524 202.38 230.638 210.924C234.019 220.199 240.328 230.806 240.116 241C239.979 247.592 234.216 267.754 239 272L239 273C233.862 279.36 224.094 296.072 224 304L222 303L212 352C206.492 353.828 207.584 362.925 206 368L208 376L179.148 375.397L173.683 368.603L163.148 366.682L152 348L146 344L145 344L144 344C138.597 347.917 115.407 337.528 109.019 334.633C105.776 333.163 104.55 331.378 104 328L92 328C92.02 333.828 92.7564 343.691 98 347L98 348L97 352L98 349L99 349C98.0595 357.37 88.6805 360.566 84 367L84 368L86 384C81.887 383.913 68.5917 379.039 68 375C56.3304 373.516 49.7848 367.276 40 362L42 358C34.2134 353.432 32.7612 353.903 24 354L20.162 344.385L20 328L26 328L26 344L28 344L28 328L32 328L32 320L28 320L31 312L32 312L32 316L33 316L36 304L48 304L48 282L72 280L72 272L40 272L40 240L36 240L36 224L32 224L32 192L16 192L16 176L0 176L0 402L13.1296 389.728L32 387C33.7673 392.827 40.3837 392.16 43.1813 397.326C48.0136 406.248 44.6109 416.687 45.1736 426.17C45.6698 434.531 48.171 440.724 45 449L42 448L36.8534 465L41 512C35.5028 512.004 28.9461 517.8 24.9414 517.133C19.1414 516.168 23.5114 509.405 24.436 506.166C27.0462 497.021 32.5927 480.742 28 472L32 472L32 471C23.6907 470.377 12.9478 457.05 9 450L7 451L0 444L0 720L1280 720L1280 448L1280 384C1280 380.187 1281.85 364.641 1278 364C1282.52 355.306 1280 341.629 1280 332L1280 261L1280 0L1179 0C1171.19 0 1149.81 -3.66772 1145 3L1144 0L1126 0C1130.09 17.1876 1135.33 34.1959 1141.53 50.9105C1144.62 59.2278 1150.75 68.9256 1149 78L1147 78L1147 72L1145 74L1144 74L1142 70L1144 71L1140 66L1147 96L1149 97L1150 97L1150 91L1152 91L1155 120C1155.93 124.944 1156.14 129.52 1161 132L1157 120L1158 120L1162 127L1161 129C1165.09 132.742 1178.32 152.666 1172 155L1175 159L1177 164L1174 165L1175 169L1178 168L1183 176L1182 171L1184 171L1190 177L1187 168L1190 167L1196 192L1199 199L1204 197L1208 211L1211 209L1209 213L1211 215L1212 215L1215 214L1211 216L1211 217L1215 216C1215.46 222.3 1223.21 233.591 1229 236L1229 232L1232 231L1233 231L1241 240L1232 236L1237 244L1235 244L1236 248L1240 248L1246 272L1232 268L1232 272L1235 272L1235 280L1242 280C1243.15 288.301 1248.25 289.973 1256 290L1256 296L1262 296L1261 305L1255 304L1249 325L1243 320C1234.34 319.064 1232.07 310.284 1226 307C1223.55 305.675 1220.51 306.088 1218 304.833C1209.37 300.517 1198.35 291.417 1188 292C1184.47 292.199 1185.13 295.596 1182 296C1183.88 287.651 1175.65 290.943 1173.18 285.698C1171.35 281.828 1181.02 274.555 1184 273L1184 281L1187 277L1191 277L1192 264L1187 262C1178.16 267.866 1164.31 246.288 1155 245L1152 242L1150 254L1143 255L1142 245L1143 244L1146 244L1137 240L1120 222L1112 215C1096.56 211.644 1075.58 196.472 1060 201L1053 196.588L1028 187L1029 183C1021.48 185.493 1018.36 188.996 1010 187L1019 181L1020 171L1039 176L1036 179L1040 181C1046.47 189.037 1062.85 188.722 1072 188L1077 196L1094 197.867L1133 192L1130 179C1137.49 188.461 1138.1 198.076 1152 201L1160 198L1160 200L1155 200C1158.24 204.87 1162.75 204.398 1168 204L1169 200L1165 200L1165 199L1168 193L1169 193L1169 196L1176 196L1177 205L1178 205L1179 203L1180 206L1181 206L1181 200L1183 200L1183 208L1186 208L1188 189L1184 200L1183 200L1184 184L1180 184L1182 181C1174.23 181.738 1172.44 176.953 1169 171L1168 171L1169 185C1160.74 177.484 1164.93 156.622 1160 146C1162.5 143.459 1159.63 140.603 1158 138L1157 138L1158 143L1157 143L1157 141L1156 141C1156.24 146.661 1156.1 155.391 1161 159L1158 168L1151 156L1149 158L1148 158L1137 129C1130.52 123.163 1131.04 109.348 1129.7 101C1127.92 89.7999 1120.29 81.2615 1114.17 72.3348C1110.55 67.0472 1109.61 61.2998 1103 59L1103 67L1102 67C1101.31 51.0936 1086.17 31.4851 1078 18C1074.04 17.0226 1073.3 14.9315 1073 11L1074 11L1075 14L1076 14L1075 7L1072 8L1070 0L970 0C957.022 0 938.965 -3.48859 928 4L928 0C920.599 0.491028 908.066 4.73407 907 13L904 14C899.459 9.85797 888.585 27.6663 892 33L876.036 42.4691L848 43L848 40C844.291 39.1759 838.965 39.5394 835.754 37.8325C828.196 33.8152 825.358 28.0321 816 28C815.723 19.5172 809.195 14.0921 801 14L799 10L800 5L792 4L792 0L785 2L770 0L739 0L616 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M784.333 0.666687L784.667 1.33331L784.333 0.666687M792 0L792 4L800 5L799 10L801 14C808.633 14.2286 815.414 20.2217 816 28L836.555 38.757L848 40L848 43C865.86 43 877.056 43.631 892 33C889.62 27.5999 897.76 12.2566 904 14L905 14L907 13C908.731 5.41895 917.009 4.15759 923 1C912.496 -3.40765 894.42 0 883 0L792 0M928 0L928 4L932 0L928 0M1070 0L1072 8L1075 7L1074 10L1076 14L1075 14L1074 11L1073 11C1073.13 15.0336 1073.48 18.0729 1078 18C1084.76 33.7758 1100.59 49.7629 1102 67L1103 67L1103 59C1109.2 62.2939 1110.22 67.7777 1114.03 73.1157C1120.15 81.6838 1127.45 90.2406 1129.53 101C1131 108.586 1130.04 124.734 1137 129L1148 158L1149 158L1151 156L1153 158L1158 168L1161 159C1156.69 154.211 1156.49 147.197 1156 141L1157 141L1157 143L1158 143L1157 138L1158 138L1160 146C1161.18 149.723 1163.5 153.079 1164.01 157C1165 164.667 1161.72 180.53 1169 185L1168 171L1169 171C1171.66 177.493 1174.18 182.499 1182 181L1180 184L1184 184L1183 200L1184 200L1188 189L1186 208L1183 208L1183 200L1181 200L1181 206L1180 206C1179.42 204.09 1179.01 202.666 1178 205L1177 205L1176 196L1169 193L1168 193L1165 199L1165 200L1169 200L1168 204C1162.62 204.172 1158.96 203.989 1155 200L1160 200L1160 198C1156.49 198 1152.85 197.013 1152 201C1138.28 196.98 1138.88 186.948 1130 179L1133 192C1117.64 189.073 1108.47 195.619 1094 197.725C1088.2 198.57 1082.69 195.282 1077 196L1072 188C1061.51 188.45 1048.64 188.111 1040 181L1036 179L1039 176L1020 171L1019 181L1010 187C1018.03 189.394 1022.01 186.474 1029 183L1028 187L1052 196.611L1060 201C1077.69 198.188 1094.64 212.603 1112 215L1120.33 223.68L1137.38 239.952L1146 244L1143 244L1142 245L1143 255L1150 254L1152 242L1155 245C1164.26 247.02 1169.19 255.667 1177 260.515C1180.14 262.463 1184.1 265.254 1187 262L1192 264L1191 277L1187 277L1184 281L1184 273C1180.49 274.11 1169.87 281.981 1173.05 286.405C1176.27 290.893 1182.65 288.399 1182 296L1185 295C1188.6 289.836 1197.62 294.712 1202 296.895C1209.25 300.503 1219.34 303.19 1225.7 307.843C1231.69 312.217 1234.69 318.639 1243 320L1249 325L1255 304L1257 306L1261 305L1262 296L1256 296L1256 290C1248.47 289.917 1243.68 287.693 1242 280L1235 280L1235 272L1232 272L1232 268L1246 272L1244 270L1240 248L1236 248L1235 244L1237 244L1232 236L1241 240L1233 231L1232 231L1229 232L1229 236C1223.69 232.779 1215.9 222.19 1215 216L1211 217L1211 216L1215 214L1212 215L1211 215L1209 213L1211 209L1208 211L1204 197L1199 199L1196 192L1190 167L1187 168L1190 177L1184 171L1182 171L1183 176L1178 168L1175 169L1174 165L1177 164L1175 159L1172 155C1178.81 153.059 1165.82 132.043 1161 129L1162 127L1158 120L1157 120L1161 132L1155 120C1159.11 116.094 1152.48 97.0619 1152 91L1150 91L1150 97L1149 97L1147 96L1140 66L1144 71L1142 70L1142 71L1144 74L1145 74L1147 72L1147 78L1149 78C1150.82 71.3752 1147.22 64.2313 1144.85 58.0394C1139.8 44.8795 1136.26 30.9732 1130.85 18C1129.04 13.6725 1128.64 4.96149 1125.97 1.60339C1123.73 -1.21661 1117.18 0 1114 0L1122 22L1121 22L1120 19L1119 19L1123 34L1125 33L1135.17 60L1148 109L1145 110L1142 106L1143 110L1142 110L1131 70L1130 70L1130 72L1129 72L1129 66L1128 66L1127 68C1126.48 64.894 1122.94 60.9844 1127 62L1126 58L1125 58L1125 61L1124 61L1122 57L1122 56L1124 53L1121 54C1124.26 47.4061 1119.58 42.9124 1116.9 37C1112.74 27.7836 1110.38 17.5126 1107 8L1106 8L1107 18L1106 18L1104 12L1103 12L1113 45L1116 57L1120 56L1130 82L1129 82L1120 61L1119 61L1117 66L1117 62L1103 48L1104 44C1095.41 37.0142 1094.09 10.8533 1094 0L1092 0L1095 24L1086 0L1070 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1086 0C1087.51 7.37268 1088.55 19.209 1095 24L1092 0L1086 0M1094 0C1094.03 9.22107 1097.23 17.8809 1097.91 27C1098.38 33.2485 1097.76 40.6395 1104 44L1103 48L1117 62L1117 66L1119 61L1120 61L1129 82L1130 82L1120 56L1116 57L1113.05 44L1103 12L1104 12L1106 18L1107 18L1106 8L1107 8C1109.16 17.5514 1112.75 27.9017 1116.48 37C1119.03 43.2372 1123.31 46.9977 1121 54L1124 53L1122 56L1122 57L1124 61L1125 61L1125 58L1126 58L1127 62C1123.98 62.5168 1126.04 65.8181 1127 68L1128 66L1129 66L1129 72L1130 72L1130 70L1131 70L1142 110L1143 110L1142 106L1145 110L1148 109L1135.17 59L1125 33L1123 34L1119 19L1120 19L1121 22L1122 22C1121.4 18.0148 1115.43 -3.94714 1110 2L1094 0z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1096 0L1097 1L1096 0M1100 0L1101 1L1100 0M1103 0L1104 1L1103 0M1109.33 0.666687L1109.67 1.33331L1109.33 0.666687M1144 0L1144 3L1146 0L1144 0M1097 1L1097 4L1098 4L1097 1M1112 1L1112 4L1111 4L1111 2L1110 2L1111 7L1112 7L1114 5L1112 1M1101 2L1102 3L1101 2M1145 7L1145 8L1148 16L1151 16C1149.83 11.9067 1149.34 8.40588 1145 7M908 10L909 11L908 10M1116.33 12.6667L1116.67 13.3333L1116.33 12.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M556 16C556.457 24.7032 559.979 32.4348 560 41C560.009 44.5477 559.26 49.7891 563.148 51.6512C569.774 54.8248 575.86 48.1583 582 48C581.872 43.7825 581.31 41.218 577 40L577 15L556 16M580 15L580 16L584 16L580 15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1117 15L1118 16L1117 15z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M896 16L897 17L896 16z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1115 16L1116 17L1115 16M702 32L702 33L708 45L708 43L714 48L707 48C709.034 50.4035 711.459 52.8736 714 50L715 50C726.207 58.3395 738.209 52.3455 741 40C751.092 39.6686 747.888 30.9354 746 24C742.338 23.0662 739.653 20.327 735.996 19.4189C720.657 15.61 710.978 20.7866 702 32z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1108 18L1108 22L1109 22L1108 18z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1117 20L1118 21L1117 20z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1123 21L1124 22L1123 21z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1152 21L1153 24L1152 21M1118 22L1119 28L1120 28L1118 22M1103 23L1104 24L1103 23M630 24L630 26L632 26L632 24L630 24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1109 24L1110 25L1109 24z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M892 28L892 31L893 31L892 28M639 29L644 40L639 29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1095 29L1094 33L1095 29z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1080.33 32.6667L1080.67 33.3333L1080.33 32.6667M1084.33 36.6667L1084.67 37.3333L1084.33 36.6667M1120 36L1121 37L1120 36M1037 37L1036 41L1036 42C1040.03 41.2952 1040.64 39.0944 1037 37M1032 40L1033 41L1032 40M1123 42L1123 45L1124 45L1123 42z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1114 43L1116 50L1117 50L1114 43z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1011 50L1011 51L1013 51L1013 53L1008 49L1006 54L1003 53L1004 58C1010.41 55.9261 1021.48 52.6481 1024 46C1018.59 44.7712 1015.18 46.585 1011 50M640.333 48.6667L640.667 49.3333L640.333 48.6667M1082 74L1083 67L1081 64L1082 64L1083 66L1083 48C1075.38 49.9624 1076.43 70.0621 1082 74M1125 48L1126 49L1125 48z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M712 49L713 50L712 49z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M715 52L716 53L715 52z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1118.33 52.6667L1118.67 53.3333L1118.33 52.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1114 53L1115 54L1114 53M642 54L643 55L642 54M719 54L719 55L736 56L736 54L719 54z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1135 55L1136 59L1137 59L1135 55z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M642 56L641 59L642 56M1124 56L1125 57L1124 56M1128 56L1130 63L1131 63L1128 56z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1138 61L1139 65L1140 65L1140 61L1138 61M1080 63L1081 64L1080 63z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1127.33 63.6667L1127.67 64.3333L1127.33 63.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M633 64L634 65L633 64z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1131 64L1131 68L1132 68L1131 64M1103 67L1103 72L1104 72L1103 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1119 67L1120 68L1119 67z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1133 69L1134 70L1133 69z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1080 71L1081 72L1080 71M1121 71L1122 72L1121 71z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1104 74L1104 78L1105 78L1104 74M1105 80L1105 84L1106 84L1105 80z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M611 81L612 82L611 81M1130 82L1130 85L1131 85L1130 82z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1106 85L1106 88L1107 88L1106 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1132 85L1134 88L1132 85z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1151.67 88.3333L1152.33 88.6667L1151.67 88.3333M1155.33 88.6667L1155.67 89.3333L1155.33 88.6667M1086 89L1088 98L1089 98L1086 89M1157 90L1157 95L1158 95L1157 90M1107.33 91.6667L1107.67 92.3333L1107.33 91.6667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1136 91L1136 94L1137 94L1136 91M1137 95L1138 98L1139 98L1137 95z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1108 96L1109 97L1108 96M1158 96L1159 97L1158 96z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1149 102L1149 107L1150 107L1149 102z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1111 109L1112 110L1111 109z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1140 111L1142 115L1143 115L1140 111M1146 111L1145 121L1139 112L1138 112L1147 139L1148 139L1147 121L1149 124L1150 124L1146 111M1151 111L1151 114L1152 114L1151 111z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M907 116L912 120L911 116L907 116z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1151.33 116.667L1151.67 117.333L1151.33 116.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M793 236L797 243L792 250L794 249L793 252L798 257L790 257L789 252L786 257L782 257L782 258L785 258L785 259L781 257L774 259L775 263L772 263L772 268L770 267L770 268L773 268L773 283L779 287L784 284L783 286L784 286L785 284L783 283L783 282L787 280L784 280L789 268C789.49 270.935 792.625 269.768 795 269C795.294 270.761 797.829 273.343 797 275C795.252 278.496 792.518 275.929 793 274L792 274L791 278L795 278L800 281L799 288L796 291L793 290C791.33 292.784 787.249 293.002 788 290C781.812 291.022 769.108 286.929 765 292C769.664 290.89 775.007 289.975 779 293L768 292L768 293L778 293L778 294L777 296L775 298L774 298L770 296L770 297L773 298L771 302C765.059 302 754.26 299.447 753 307L754 307L754 303L775 304L772 308L772 311L768 310L768 311L770 311L770 312C765.587 312.946 767 318.233 767 322L765 322L765 307L764 307L764 323L760 323L760 312L759 312C759 316.69 757.763 322.262 763 324L762 328L758 322L757 322L757 324L756 324L756 320L755 320L755 328L758 333L752 335L752 336L759 336L756 342L762 353L769 355L769 354L767 351L765 350L763 351L762 350L767 348L767 344L775 346L773 345L773 346L773 349L777 349L777 354L775 354L776 359L775 359L775 356L774 356L774 360L766 360L768 358L768 357L765 355C761.604 359.91 763.1 362.72 765 368L771 366L771 370L786 372L787 372L780.759 388.039L776 412L780 412L780 416C783.493 416 788.634 415.092 791.722 417.028C796.68 420.135 801.707 436.358 802 442L812 439L812 444L820 443L816 439L816 435L819 438L820 438L823 435L821 431L825 433L824 429L827 430L829 437L827 432L830 433L827 430L827 429L837 436L830 427L833 429C835.66 428.772 837.901 429.285 836 432L842 433L843 438L844 438L851 437C849.718 433.144 846.821 431.104 843 433L843 429L842 428L837 426C842.066 424.909 838.304 419.275 836.833 416C832.275 405.85 828.412 402.686 818 399C822.481 385.966 810.472 378.401 807.179 366.985C805.635 361.633 808.1 356.904 810 352L824 354L824 352L849 352L840 383C852.348 382.71 865.011 370.755 870.25 360C873.334 353.669 873.111 345.443 880 342L873 366C882.083 367.167 886.779 355.715 886 348L888 338C896.99 336.546 904.775 351.253 912 342L916 343L918 338L912 339L902 326C896.319 325.815 896.019 323.01 891.716 320.453C878.686 312.708 869.327 302.837 869 287L868 287C866.728 298.376 861.289 301.917 861 288L860 288L856 292L851 280L850 284L848 284L846 276L844 278L835 275L824 262L831 264L832 264L833 258L827 259L827 251L823 251L823 256C819.957 252.485 821.706 241.224 815 245C813.972 240.9 813.026 235.363 808 239L807 239L802 239L801 233L795 234L794 223L791 223L787 225L790 216L786 217L786 216L794 215L794 216L792 216L792 217L800 217C801.605 222.817 806.563 223.567 812 224L808 221L810 219L810 218L802 216L802 215L805 212L798 208L802 210L804 205C799.09 203.001 797.232 205.801 793 208L796 203L794 200L789 205L785 203L788 198L783 198L782 193L784 195L785 195L786 191L775 182L781 177L785 170L788 170L789 174L797 165L798 165L806 165L805 162C812.344 162.424 826.813 151.994 832 160L833 160L833 157L834 157L840 160L842 156L848 157C847.038 154.186 842.345 146.852 841 153L838 152L853 140L851 144L855 145L856 145L858 142L857 138L854 139L854 138C866.616 134.158 880.645 123.993 886 141C889.877 140.053 890.782 135.416 894.157 134.759C898.54 133.907 913.054 149.252 914 143C919.668 142.821 923.109 140.215 928 144L920 144L920 145L927 149C942.695 149.002 958.263 148.097 972.871 153.639C981.097 156.76 989.183 168.325 999 165C999.917 169.281 1006.07 169.873 1008 166L1009 166C1011.27 173.988 1024.82 163.943 1024 157L1008 164L1016 149L999 153C1004.91 145.838 1003.19 142.093 994 145C990.96 136.732 979.947 141.673 973 140.448C968.079 139.58 964.171 134.616 959 133.414C951.308 131.627 941.931 132.67 934 132L934 128L928 131L925 128C925 131.934 921.053 127.88 919 127L920 129C905.676 121.877 888.291 125.358 873 123.829C854.033 121.933 828.94 110.413 811 120.823C800.662 126.822 796.284 138.432 786.911 144.867C776.977 151.688 767.478 153.896 760.562 165C749.385 182.948 759.454 203.523 769.576 219.285C776.064 229.391 780.573 236 793 236M1158 119L1159 120L1158 119M1114.33 120.667L1114.67 121.333L1114.33 120.667M1145 121L1146 122L1145 121M1164 121L1166 133L1167 133L1168 128L1164 121M1115 124L1116 125L1115 124M1171 128L1172 132L1173 132L1171 128M1145 132L1146 136L1149 135L1148 131L1145 132M1117.33 132.667L1117.67 133.333L1117.33 132.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1147 133L1148 134L1147 133M459 134L457 153C454.482 154.812 453.435 156.753 456 159L456 160L451 146C446.157 152.797 451.046 156.145 451.631 163.001C452.648 174.903 450.804 191.583 468 192L474.621 167L474 144L479 144L479 140L480 140L480 155L481 155L480 136L472 135L463 141L462 134L459 134M887 134C888.459 136.455 889.43 136.289 891 134L887 134z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1172 134L1172 137L1173 137L1172 134M871 135L872 136L871 135M1118 135L1118 138L1119 138L1118 135z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1151 136L1152 143L1153 143L1151 136M1160 136L1161 140L1162 140L1160 136M853 139L854 140L853 139z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1119 140L1120 141L1119 140M1173.33 140.667L1173.67 141.333L1173.33 140.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M291 143L292 144L291 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1120 143L1121 144L1120 143M1158 143L1159 146L1160 146L1158 143z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M935 146L938 144L935 146M1151 144L1152 145L1151 144z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M879 145L880 146L879 145M881 146L882 147L881 146z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1168.33 146.667L1168.67 147.333L1168.33 146.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M872.667 147.333L873.333 147.667L872.667 147.333M876 147L879 149L876 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M936 147L937 148L936 147z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M866 148L869 150L866 148M864 149L865 150L864 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1170 149L1172 152L1170 149z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M862 150L863 151L862 150z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M312 151L313 152L312 151z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1122.33 151.667L1122.67 152.333L1122.33 151.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M836.333 153.667L836.667 154.333L836.333 153.667M1167 153L1171 161L1167 153M841 154L840 156L841 154z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1123 154L1124 155L1123 154M1176.33 154.667L1176.67 155.333L1176.33 154.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M833 155L834 156L833 155M319 158L318 160L320 160L319 158z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1124 158L1125 159L1124 158M653 162L655 161L649 167L645 167L647 169C640.435 172.219 633.905 175.547 630 182C626.151 180.028 623.848 178.573 624 174C617.01 174 603.979 177.675 600 171L592 173L597 175L597 176L592 176L592 180C579.645 183.378 577.74 202.327 583 212C592.424 214.876 586.804 237.691 603 226L602 228L605 227L605 228L602 232L605 232L606 228L607 228L606 230L607 230L613 226L609 229L609 230L614 229C614.017 234.99 614.131 239.233 620 242L617 244L624 244L632 246C635.847 239.635 648.393 231.219 656 231L657 228C662.943 230.122 676.222 229.894 680 224L677 225C674.69 215.298 682.253 197.259 672 192L672 203L668 196L664 196L663 196L660 198L660 192L665 193L666 193L666 191L667 191C670.65 194.156 679.663 187.332 681.232 183.532C684.745 175.023 673.8 163.848 666 163L666 160L653 162M943 160L944 161L943 160M947.667 160.333L948.333 160.667L947.667 160.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1167 160L1167 164L1168 164L1167 160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M938.333 161.667L938.667 162.333L938.333 161.667M955 161L955 163L957 161L955 161M1179 161L1181 164L1179 161M953 162L954 163L953 162M961 162L961 163L965 163L961 162M970 162L970 164L972 164L970 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1171 162L1173 164L1173 162L1171 162z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M899.667 163.333L900.333 163.667L899.667 163.333M1146.67 163.333L1147.33 163.667L1146.67 163.333M904.333 164.667L904.667 165.333L904.333 164.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M791 165L792 166L791 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M971 166L971 167L975 165L971 166z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1169 165L1176 176L1169 165z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M904 167L905 168L904 167M984 167L985 172L990 172L982 179L983 180L992 180L998 176C995.071 189.901 1012.92 177.897 1016 172L1000 176L1000 172L995 173C992.904 169.777 990.549 170.193 987 171L987 167L984 167M1140.33 167.667L1140.67 168.333L1140.33 167.667M1180 167L1182 169L1182 167L1180 167M1186 167L1187 168L1186 167M976 168L977 169L976 168M927 169L916 174L916 175L927 177L926 173L932 170L927 169M914 170L914 173L916 170L914 170M830 171L831 172L830 171M834 174L833 174L833 172L832 172L836 184L837 184L839 182L839 185L840 185C844.01 184.196 847.618 183.182 850 187L854 187L846 180C840.815 183.431 837.544 174.711 835 171L834 174M943 175L944 175L950 174L950 175L943 180L949 180L950 179L951 172C947.306 171.185 944.183 170.955 943 175M957.333 171.667L957.667 172.333L957.333 171.667M954 181L964 179L963 175L967 172L964 171L954 181M928 177L942 176L942 174C936.38 171.915 932.111 172.432 928 177M969 172L970 173L969 172M796.667 173.333L797.333 173.667L796.667 173.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M961 173L960 176L963 174L961 173z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M965 180L979 177C976.415 169.674 967.359 175.217 965 180z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M992 173L992 174L995 174L992 173M833 175L835 178L833 175M836.333 176.667L836.667 177.333L836.333 176.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1129 176L1130 177L1129 176M1168 176L1169 177L1168 176z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1184 177L1188 187L1191 190L1192 190C1191.46 184.003 1188.36 180.881 1184 177M1191 178L1190 181L1191 178M775 184L776 185L775 184z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1176 184L1177 185L1176 184M847 185L848 186L847 185z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M771 186L771 188L773 186L771 186M774 190L774 191L781 193L781 188L774 190z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1175 188L1177 200L1180 200L1180 192L1175 188z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M770 189L773 192L770 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M832 189L840 194C838.67 190.178 835.8 189.574 832 189z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M56.6667 191.333L57.3333 191.667L56.6667 191.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M827 191L828 192L827 191M1168.67 191.333L1169.33 191.667L1168.67 191.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M48 192L48 193L54 196L54 192L48 192M64 192L64 195L65 195L64 192M68.3333 192.667L68.6667 193.333L68.3333 192.667M74 192L77 195L74 192z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1108 192L1109 193L1108 192M794 193L793 195L795 195L794 193M790.667 194.333L791.333 194.667L790.667 194.333M842 197L851 198L851 194L842 197M796 195L797 196L796 195z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M847 196L848 197L847 196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M789.333 197.667L789.667 198.333L789.333 197.667M812 197L812 198L816 199L812 197M826 200L828 197L826 200M854 197L854 199L856 197L854 197M1148 197L1149 198L1148 197M823 198L821 201L823 198z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1192.33 198.667L1192.67 199.333L1192.33 198.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M859 199L860 201L861 201L862 199L859 199z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M529 200L530 201L529 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M819 200L820 201L819 200M879 203L878 203L877 203L875 201C876.006 205.695 884.905 204 889 204L888 206L892 206L891 203L902 205L900 200L891 200L879 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1201 200L1203 202L1203 200L1201 200z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M825 202L825 203L838 206C835.308 201.071 830.078 200.541 825 202M864.333 201.667L864.667 202.333L864.333 201.667M535.667 202.333L536.333 202.667L535.667 202.333M843 202L844 203L843 202M533 203L534 204L533 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M534 203L533 205L534 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M526 324C532.282 322.194 536.989 313.966 539 308C528.176 302.175 532.775 291.271 544 289L548 272L550 272L554 285L555 285C559.083 279.642 563.401 274.96 570 273C569.185 278.52 567.496 284.664 563.775 288.961C561.731 291.322 555.658 294.783 556.752 298.585C557.794 302.207 567.938 304.61 570.96 306.927C576.38 311.083 576.944 318.104 581.649 322.258C587.094 327.065 604.03 324.014 611 324C613.799 323.994 618.218 324.575 619.883 321.682C623.699 315.05 616.416 301.164 618.558 293C621.068 283.434 629.686 282.651 635.892 276.786C638.784 274.054 642.213 268.468 640.382 264.302C639.092 261.368 634.496 260.634 632.184 258.606C621.458 249.191 612 243.999 612 229C595.333 236.635 581.598 255.694 580 274C563.748 262.9 560.444 248.443 554.047 231C551.112 222.995 546.122 208.879 538.004 204.752C534.604 203.023 532.965 206.341 531.826 209.005C530.232 212.737 529.45 217.595 526.501 220.567C523.327 223.765 517.904 223.558 514.015 225.558C510.281 227.478 508.211 231.066 504.961 233.57C499.981 237.407 485.288 234.833 483.448 241.147C477.733 260.766 504.404 259.075 511.2 268.055C522.289 282.706 522.758 306.599 526 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M537 203L540 206L537 203z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M538 203L539 204L538 203M539 204L540 205L539 204M823 204L823 207L824 207L823 204M848 204L848 205L851 207L841 205C842.835 207.086 844.628 209.168 847 207L848 207C850.328 210.271 853.193 210.881 857 210C854.491 205.943 852.933 204.273 848 204M898 208L903 212L906 210L906 211L904 211L904 212L907 211L904 208L907 205L910 209L916 214L916 213L913 212L913 211L916 212L910 209C907.159 202.225 903.173 205.756 898 208M532 205L533 206L532 205z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M770.667 205.333L771.333 205.667L770.667 205.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M872 206L872 207L878 208L878 209L872 209L872 210L897 210C893.772 205.531 883.736 206.101 879 208L872 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M532 206L533 207L532 206z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M540 206L541 207L540 206M532 207L533 208L532 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M541 207L542 208L541 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M791 207L792 208L791 207z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M810 207L811 212L813 212L814 208L810 207M856.667 207.333L857.333 207.667L856.667 207.333M1210 207L1213 209L1213 208L1210 207M531 208L532 209L531 208M542 208L543 209L542 208z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M531 209L532 210L531 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M543 209L544 210L543 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M895 209L896 210L895 209z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M530 210L531 211L530 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M543 210L544 211L543 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M866 210L866 211L870 211L866 210M879 210L881 212L881 210L879 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1200 210L1203 214L1202 210L1200 210z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M530 211L531 212L530 211M544 211L545 212L544 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M779.667 211.333L780.333 211.667L779.667 211.333M793 212L793 213L800 213L793 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M821 211L822 212L821 211M857 211L857 212C860.408 213.207 862.805 214.278 865 211L857 211z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M530 212L531 213L530 212z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M545 212L546 213L545 212M827.333 212.667L827.667 213.333L827.333 212.667M844 212L844 214L846 214L846 212L844 212M867 213L877 215L867 213M529 213L530 214L529 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M545 213L546 214L545 213z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M529 214L530 215L529 214M546 214L547 215L546 214z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M831 214L831 216L833 214L831 214M903 214L903 215L910 215L903 214M918 214L917 215L920 217L918 214M1049 226L1040 230L1039 232L1039 233L1051 231L1053 238C1060.7 237.962 1066.62 240.121 1073 235L1073 237L1091 226L1091 225L1073 226L1077 230L1077 231L1057 234L1059 228C1055.86 228.946 1054.93 229.708 1055 233L1050 223L1064 225L1064 220L1070 217L1070 215L1057 217C1056.24 211.522 1042.58 217.554 1049 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M529 215L530 216L529 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M835 215L839 217L835 215M878 216L878 217L885 217L878 216M921 215L922 218L923 218L923 215L921 215M1215 215L1216 216L1215 215M1218 215L1219 216L1218 215z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M232 216L233 217L232 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M528 216L529 217L528 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M547 216L548 217L547 216z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M811 216L811 217L814 217L811 216M817 216L819 218L819 216L817 216M888 216L888 217L893 217L888 216M910 216L910 217L916 218L910 216M926.333 216.667L926.667 217.333L926.333 216.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M528 217L529 218L528 217M548 218L549 219L548 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M827 218L827 220L829 220L829 218L827 218M841 218L841 220L848 219L841 218M952 218L952 221L953 221L952 218z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M527 219L528 220L527 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M850 219L851 220L850 219M879 219L880 220L879 219M891 219L892 220L891 219M1218 219L1217 222L1231 231L1218 219z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M527 220L528 221L527 220M549 220L550 221L549 220z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M875 220L875 221L878 221L875 220M883.667 220.333L884.333 220.667L883.667 220.333M525 221L526 222L525 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M526 221L527 222L526 221z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M550 221L551 222L550 221M813 222L813 223L818 222L813 222M855 221L856 222L855 221M1074 222L1074 223L1078 222L1074 222M521 222L522 223L521 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M522 222L523 223L522 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M523.667 222.333L524.333 222.667L523.667 222.333M550 222L551 223L550 222z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M857.667 222.333L858.333 222.667L857.667 222.333M917.667 222.333L918.333 222.667L917.667 222.333M517 223L518 224L517 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M518 223L519 224L518 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M519 223L520 224L519 223z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M923 223L924 224L923 223M514 224L515 225L514 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M515 224L516 225L515 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M516 224L517 225L516 224M551 224L552 225L551 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M592 224L593 225L592 224M605 224L606 225L605 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M799 224L800 225L799 224M866 224L867 225L866 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1049 224L1050 225L1049 224z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M512 225L513 226L512 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M513 225L514 226L513 225z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M811 225L815 229L811 225M910.667 225.333L911.333 225.667L910.667 225.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M509 226L508 229L509 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M511 226L512 227L511 226M552 226L553 227L552 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M608 226L609 227L608 226M792 226L793 227L792 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M919 226L920 227L919 226M928 226L929 227L928 226z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M510 227L511 228L510 227z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M553 228L554 229L553 228M888.667 228.333L889.333 228.667L888.667 228.333M939 228L940 229L939 228z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M507 229L506 232L507 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M553 229L554 230L553 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M600 229L601 230L600 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M612 229L613 230L612 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M672 229L673 230L672 229M803 229L805 231L805 229L803 229z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M508 230L509 231L508 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M608 230L609 231L608 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M612 230L612 241L613 241L612 230z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M812 231L812 232L818 234L817 230L812 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M507 231L508 232L507 231M554 231L555 232L554 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M600 231L601 232L600 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M607 231L608 232L607 231z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M819 231L820 232L819 231M822 231L823 232L822 231M1036 231L1037 232L1036 231M16 232L16 240L18 240L18 232L16 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M48 232L48 237L72 237L72 234L48 232M505 232L506 233L505 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M554 232L555 233L554 232M606 232L607 233L606 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M658 232L660 234L658 232M661 232L662 233L661 232M804 232L803 233L803 234L803 235L806 232L804 232M825 232L825 234L827 234L827 232L825 232M831 232L823 240L828 239L828 240L825 240L829 243L830 238L836 240L836 241L832 241L833 248L840 243L839 241L839 240L843 245L839 245C840.223 248.687 842.308 248.88 846 249L853 243L853 242L846 241L846 240L849 240L845 237L846 240L844 237L835 239L835 238L840 234L832 235L834 232L831 232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M503.667 233.333L504.333 233.667L503.667 233.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M555 233L556 234L555 233M604 233L605 234L604 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M605 233L606 234L605 233z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M663.667 233.333L664.333 233.667L663.667 233.333M672.667 233.333L673.333 233.667L672.667 233.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M501 234L502 235L501 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M504 234L505 235L504 234M555 234L556 235L555 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M603 234L604 235L603 234z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M500.667 235.333L501.333 235.667L500.667 235.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M502 235L503 236L502 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M602 235L603 236L602 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M915 235L916 236L915 235z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M493 236L493 237L496 237L493 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M496 236L496 237L499 237L496 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M556 236L557 237L556 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M601 236L602 237L601 236z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M667.667 236.333L668.333 236.667L667.667 236.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M485 237L486 238L485 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M486 237L486 238L489 238L486 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M556 237L557 238L556 237M600 237L601 238L600 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M657 237L658 238L657 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M664 237L665 238L664 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M665 237L666 238L665 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M671 250C668.702 254.113 666.094 253.23 662 252L661 253L661 255C665.11 256.978 676.39 258.395 673.377 250.104C671.953 246.184 666.97 244.793 665 241L674 241C665.622 231.942 656.465 245.8 671 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M669 237L670 238L669 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M670 237L671 238L670 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M671 237L672 238L671 237M681 237L682 238L681 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M681 257L682 257L682 238L685 240C685.526 236.853 681.967 237.218 681.218 240.083C679.893 245.147 681 251.771 681 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M685 237L686 238L685 237M694 237L695 238L694 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M694 245L695 245L698 238C693.758 237.047 694.037 241.85 694 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M698 237L699 238L698 237M705 237L706 238L705 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M706 237L706 238L718 238L706 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M718 237L719 238L718 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M725 237L726 258L727 258L725 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M726 237L726 238L729 238L729 254L730 254C730 248.611 732.177 239.05 726 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M729 237L730 238L729 237M738 237L739 238L738 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M738 240L739 240L755 238C750.426 236.081 740.912 235.509 738 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M755 237L756 238L755 237M760 237L761 238L760 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M760 256L761 256L761 238L773 238C758.437 231.889 760 246.292 760 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M773 237L774 238L773 237M780 237L781 238L780 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M780 257L781 257L781 238L790 238C777.173 232.619 780 249.34 780 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M790 237L791 238L790 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M791 237L792 238L791 237z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M556 238L557 239L556 238M599 238L600 239L599 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M662 238L663 239L662 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M663 238L664 239L663 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M672 238L673 239L672 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M682 238L682 257L685 257C685.128 246.19 694.872 246.19 695 257L698 257L698 238L695 238L695 245L685 245L685 238L682 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M698 238L698 257L699 257L698 238M705 238L705 257L706 257L705 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M706 238L706 257L719 257L719 254C712.233 253.976 706.094 248.756 716 248L716 245L709 245L709 241C712.987 240.997 716.668 241.598 719 238L706 238M726 238L726 257L738 257L738 254L729 254L729 238L726 238M739 238L739 241L745 241L745 257L748 257L748 242L755 241L755 238L739 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M755.333 238.667L755.667 239.333L755.333 238.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M761 238L761 257L774 257L774 254L764 254C764.709 249.556 766.606 248.335 771 248L764 245L764 241C767.987 240.997 771.668 241.598 774 238L761 238M781 238L781 257L784 257L784 250L796 257C791.29 245.239 797.451 238 781 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M792 238L793 239L792 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M817 238L820 241L817 238M885 238L884 240L885 238z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M483 239L484 240L483 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M557 239L558 240L557 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M598 239L599 240L598 239M662 239L663 240L662 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M673 239L674 240L673 239M793 239L794 240L793 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M808 239L809 248L805 248L805 249L811 255L814 253L818 259L817 250L813 251L812 242L808 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M891.667 239.333L892.333 239.667L891.667 239.333M894 239L895 240L894 239M897 239L898 240L897 239M923 239L924 242L926 239L923 239z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M557 240L558 241L557 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M597 240L598 241L597 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M661 240L662 241L661 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M667.667 240.333L668.333 240.667L667.667 240.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M674 240L675 241L674 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M685 240L685 244L686 244L685 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M718 240L719 241L718 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M738 240L739 241L738 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M755 240L756 241L755 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M773 240L774 241L773 240z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M861 240L861 242L863 242L861 240M888 240L888 242L890 242L888 240M895 241L896 245L902 243L903 247L908 245L902 243L901 240L895 241M1241.33 240.667L1241.67 241.333L1241.33 240.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M482.333 241.667L482.667 242.333L482.333 241.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M557 241L558 242L557 241M596 241L597 242L596 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M616 241L618 243L616 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M633 241L634 242L633 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M661 241L661 244L662 244L661 241M665 241L666 242L665 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M669 241L670 242L669 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M670 241L671 242L670 241M673 241L674 242L673 241M709 241L709 245L710 245L709 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M711 241L711 242L719 242L711 241M739 241L739 242L743 242L739 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M744 241L745 242L744 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M749 241L750 242L749 241M753 241L754 242L753 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M764 241L765 242L764 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M765 241L765 242L774 242L765 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M784 241C784.3 244.864 785.089 246.348 789 247L789 246L785 246L784 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M785 241L785 246L790 246L790 242L785 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M786 241L786 242L789 242L786 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M789 241L790 242L789 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M794 241L795 242L794 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M795 241L797 243L797 241L795 241M802 241L807 247L802 241z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M855 244L859 241L855 244M908 241L909 242L908 241M927 241L934 247C933.09 242.793 931.147 241.675 927 241M558 242L559 243L558 242M594 242L595 243L594 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M613 242L614 243L613 242M665 242L666 243L665 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M671 242L672 243L671 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M672 242L673 243L672 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M744 242L745 243L744 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M748.333 242.667L748.667 243.333L748.333 242.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M764 242L765 243L764 242M790 242L791 243L790 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M892 242L894 244L892 242z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M558 243L559 244L558 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M593 243L594 244L593 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M613 243L614 244L613 243M665 243L666 244L665 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M744 243L744 246L745 246L744 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M764.333 243.667L764.667 244.333L764.333 243.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M788 243L789 244L788 243M790.333 243.667L790.667 244.333L790.333 243.667M872.667 243.333L873.333 243.667L872.667 243.333M875.667 243.333L876.333 243.667L875.667 243.333M1243 243L1245 246L1243 243z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M558 244L559 245L558 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M592 244L593 245L592 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M614 244L615 245L614 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M661 244L662 245L661 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M666 244L667 245L666 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M667 244L668 245L667 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M685 244L686 245L685 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M769 244L770 245L769 244M786 244L787 245L786 244M861 244L854 246L865 248L861 244M867 244L870 246L870 245L867 244M886 244L887 245L886 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M903 244L904 245L903 244z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M911 244L910 247L907 246L908 250L914 247L914 245L913 244L911 244M559 245L560 246L559 245M591 245L592 246L591 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M615 245L616 246L615 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M616 245L617 246L616 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M622 245L623 246L622 245M661 245L662 246L661 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M668 245L669 246L668 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M669 245L670 246L669 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M716 245L717 246L716 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M748 245L748 257L749 257L748 245M770 245L771 246L770 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M771 245L771 248L772 248L771 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M790 245L791 246L790 245z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M825 245L828 248L825 245M879 245L883 251L875 252L880 256L879 252L886 253C884.631 248.812 883.517 246.013 879 245M890.333 245.667L890.667 246.333L890.333 245.667M937 247L940 248L946 248C943.756 245.053 939.602 244.037 937 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M483 246L484 247L483 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M559 246L560 247L559 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M590 246L591 247L590 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M618 246L619 247L618 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M619 246L620 247L619 246M662 246L663 247L662 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M670 246L671 247L670 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M671 246L672 247L671 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M716 246L713 248L713 249L716 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M744 246L745 247L744 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M784 246L785 247L784 246M789 246L790 247L789 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M794 246L795 247L794 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M848 246L849 247L848 246M851 246L851 250L852 250L851 246M873 247L879 249L873 247M918 246L918 249L915 248L914 251L918 252L921 248L918 246z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M483 247L484 248L483 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M620 247L621 248L620 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M621 247L622 248L621 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M663 247L664 248L663 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M664 247L665 248L664 247M672 247L673 248L672 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M744 247L744 256L745 256L744 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M775 247L776 248L775 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M842 247L843 248L842 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M867 248L873 251L871 247L867 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M910 247L911 248L910 247z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1240 247L1241 248L1240 247M560 248L561 249L560 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M589 248L590 249L589 248M622 248L623 249L622 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M623 248L624 249L623 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M665 248L666 249L665 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M666 248L667 249L666 248M673 248L674 249L673 248M686 248L686 249L694 249L686 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M710 248L710 249L713 249L710 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M716 248L717 249L716 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M765 248L766 249L765 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M766 248L766 249L771 249L766 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M771 248L772 249L771 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M794 248L795 249L794 248M816 248L817 249L816 248M870 248L871 249L870 248z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M886 248L887 249L886 248M888 251L893 251L892 248L888 251M896 248L897 249L896 248M925 250L922 249L921 253L926 253L925 250L928 249L925 250M930.667 248.333L931.333 248.667L930.667 248.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M484 249L485 250L484 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M560 249L561 250L560 249M588 249L589 250L588 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M624 249L625 250L624 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M667 249L668 250L667 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M668 249L669 250L668 249M674 249L675 250L674 249M685 249L685 257L686 257L685 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M694 249L694 257L695 257L694 249M709 249L709 253L710 253L709 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M764 249L765 250L764 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M775 249L774 252L776 254L777 254L775 249z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M793.333 249.667L793.667 250.333L793.333 249.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M935 250L935 251L940 252L935 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M484 250L485 251L484 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M560 250L561 251L560 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M587 250L588 251L587 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M625 250L627 252L625 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M626 250L627 251L626 250M669 250L670 251L669 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M670 250L671 251L670 250M674 250L674 254L675 254L674 250M764.333 250.667L764.667 251.333L764.333 250.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M772 250L773 251L772 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M784 250L785 251L784 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M784 257L785 257L788 251C784.14 250.133 784.1 253.939 784 257M792 250L793 251L792 250z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M844 250L848 254L844 250M864 250L864 253L865 253L864 250M561 251L562 252L561 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M587 251L588 252L587 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M662.667 251.333L663.333 251.667L662.667 251.333M670.333 251.667L670.667 252.333L670.333 251.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M785 251L785 257L786 257L788 251L785 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M788 251L789 252L788 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M794 251L795 252L794 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M978 251L979 252L978 251z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M484 252L485 253L484 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M485 252L486 253L485 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M561 252L562 253L561 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M586 252L587 253L586 252M627 252L628 253L627 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M660 252L661 253L660 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M661 252L662 253L661 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M664 252L665 253L664 252M764 252L764 253L774 254L774 253L764 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M793 252L794 253L793 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M840 252L841 253L840 252M895 252L897 256L899 256L900 252L895 252M932 252L928 254L928 255L936 256L932 252z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M486 253L487 254L486 253M586 253L587 254L586 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M628 253L629 254L628 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M660 253L661 254L660 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M665 253L666 254L665 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M666 253L666 254L669 254L666 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M669 253L670 254L669 253M710 253L710 254L719 257C720.099 252.107 713.295 253.003 710 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M719 253L720 254L719 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M730 253L730 254L738 257C739.031 252.412 733.225 253.011 730 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M738 253L739 254L738 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M764 253L765 254L764 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M788 253L789 254L788 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M794 253L795 254L794 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M795 253L797 255L795 253z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M891 253L889 255L889 256L894 258L891 253M946.667 253.333L947.333 253.667L946.667 253.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M485 254L487 256L485 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M486 254L487 255L486 254M562 254L563 255L562 254M585 254L586 255L585 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M628 254L629 255L628 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M660 254L661 255L660 254M674 254L675 255L674 254M774 254L774 257L775 257L774 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M789 254L790 257L791 257L789 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M790 254L791 255L790 254M795 254L796 255L795 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M989 254L990 255L989 254z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M487 255L488 256L487 255M562 255L563 256L562 255M585 255L586 256L585 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M629 255L630 256L629 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M661 255L662 256L661 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M673 255L674 256L673 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M791 255L792 256L791 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M845 255L847 261L845 255M850 255L849 259L854 259L850 255M870 255L870 256L872 258L873 258L870 255M995 255L996 256L995 255z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M488 256L489 257L488 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M563 256L564 257L563 256M584 256L585 257L584 256M630 256L631 257L630 256M662 256L663 257L662 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M663 256L664 257L663 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M672 256L673 257L672 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M744 256L745 257L744 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M760 256L760 257L764 258L764 257L760 256M796 256L797 257L796 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M797 256L798 257L797 256M823 256L824 257L823 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M864 256L865 257L864 256z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M489 257L490 258L489 257M563 257L564 258L563 257M584 257L585 258L584 257M630 257L631 258L630 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M664 257L665 258L664 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M665 257L666 258L665 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M666 257L666 258L670 258L666 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M670 257L671 258L670 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M671 257L672 258L671 257M682 257L682 258L685 258L682 257M695 257L695 258L698 258L695 257M706 257L706 258L719 258L706 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M727 257L727 258L737 258L727 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M737 257L738 258L737 257M745 257L745 258L749 258L745 257M760 257L761 258L760 257M764 257L765 258L764 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M765 257L766 258L765 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M766 257L767 258L766 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M767 257L767 258L773 258L767 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M773 257L774 258L773 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M781 257L782 258L781 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M791 257L792 258L791 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M793 257L793 258L796 258L793 257z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M858 257L858 258L861 258L858 257M883 260L887 257L883 260M907 257L907 259L909 257L907 257M1054 263L1071 258C1065.67 255.766 1055.17 256.274 1054 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M488 258L489 259L488 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M490 258L491 259L490 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M564 258L565 259L564 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M631 258L632 259L631 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M780 258L780 259L785 259L780 258M821 258L820 261L821 258z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M491 259L492 260L491 259M564 259L565 260L564 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M583 259L584 260L583 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M632 259L633 260L632 259z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M633 259L634 260L633 259M876 260L876 261L881 260L876 260M901 259L898 260L898 261L899 263L901 259M937 259L937 260L947 263L947 260L937 259M240 260L241 261L240 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M492 260L493 261L492 260M565 260L566 261L565 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M583 260L584 261L583 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M634 260L635 261L634 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M635 260L636 261L635 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M879 260L880 261L879 260z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M997 260L998 261L997 260M1017 260L1015 263L1018 264L1019 263L1017 260M1036.67 260.333L1037.33 260.667L1036.67 260.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M492 261L493 262L492 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M494 261L495 262L494 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M582 261L583 262L582 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M636 261L637 262L636 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M637 261L638 262L637 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M638 261L639 262L638 261M866 261L865 262L868 264L866 261M872 261L874 263L874 261L872 261M916 261L917 264L916 261M1001 261L1001 262L1005 262L1001 261z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M493.667 262.333L494.333 262.667L493.667 262.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M496 262L497 263L496 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M497 262L498 263L497 262M566 262L567 263L566 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M582 262L583 263L582 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M640 262L641 263L640 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M641 262L642 263L641 262M851 262L852 268L853 268L853 262L851 262M855 266L861 265L861 263C857.57 262.216 856.136 262.578 855 266M1032 262L1034 266L1034 262L1032 262z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M495 263L495 264L498 264L495 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M500.667 263.333L501.333 263.667L500.667 263.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M502 263L502 264L506 264L502 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M567 263L568 264L567 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M582 263L583 264L582 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M641 263L641 266L642 266L641 263z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M887 263L888 264L887 263M894 263L896 266L894 263M977.667 263.333L978.333 263.667L977.667 263.333M506 264L507 265L506 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M507 264L508 265L507 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M508 264L509 265L508 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M568 264L569 265L568 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M892 264L893 265L892 264M936 264L937 265L936 264M1002.33 264.667L1002.67 265.333L1002.33 264.667M1004 264L1004 266L1006 266L1004 264M1008 265L1008 266L1014 265L1008 265M1019 266L1019 271L1025 270L1023 267L1027 264L1019 266M1248 264L1248 269L1251 264L1248 264z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M509 265L510 266L509 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M569 265L570 266L569 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M581 265L582 266L581 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M772 265L774 267L772 265z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M887 265L889 268L887 265M909 265L909 268L912 267L912 266L909 265M951 265L951 267L959 267L959 265L951 265M965 268L965 269L974 265L965 268M1024 273L1011 278L1011 280C1015.31 280.935 1018.4 280.815 1021 277C1029.95 282.728 1050.26 270.587 1059 266C1050.45 262.414 1042.92 267.255 1035.17 270.128C1031.18 271.608 1028.24 275.307 1024 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M445 272L440 272L445 288C448.585 285.676 452.529 272.592 450.4 268.337C448.152 263.842 445.421 269.983 445 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M510 266L511 267L510 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M570 266L571 267L570 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M581 266L582 267L581 266z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M641 266L641 269L642 269L641 266M880 266L882 270L880 266M988 266L989 267L988 266M1000 266L999 270L1000 266M506 267L505 270L506 267M510 267L511 268L510 267M571 267L572 268L571 267M923 267L926 270L923 267z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M511 268L512 269L511 268M572 268L573 269L572 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M580 268L581 269L580 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M787 268L787 270L789 268L787 268M790 268L791 269L790 268z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M872 269L872 270L875 271L875 268L872 269M1011 269L1012 274L1015 273L1013 271L1016 268L1011 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M512 269L513 270L512 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M573 269L574 270L573 269M580 269L581 270L580 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M640 269L641 270L640 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M666 271L669 270L666 271M683 269L684 270L683 269M718 269L718 270L721 271L718 269M735 271L738 270L735 271M750 270L750 271L754 271L750 270M759 270L759 271L761 272L764 270L759 270M767 269L766 271L767 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M794 269L795 270L794 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M861 274L869 272C865.944 267.778 862.59 269.674 861 274M902 271L905 269L902 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1021 269L1022 270L1021 269z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M512 270L513 271L512 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M574 270L575 271L574 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M640 270L641 271L640 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M667 270L659 290L676 290L669 270L667 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M682 270L682 289L683 289L682 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M683 270L683 290L686 290L686 278L699 290L699 270L695 271L695 282L683 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M684 270L685 271L684 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M695 270L696 271L695 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M699 270L700 271L699 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M707 270L708 271L707 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M708 270L707 290L711 290L710 270L708 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M710 270L711 271L710 270M718 270L718 290L719 290L718 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M719 270L719 290L722 290L722 281L727 286L734 281L734 290L737 290L737 270L736 270C728.588 280.307 727.147 277.231 719 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M737 270L737 290L738 290L737 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M751 270L743 290L761 290L753 270L751 270M767 270L767 290L779 290L779 287L771 287C770.642 281.544 773.253 272.075 767 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M770 270L771 271L770 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M774 270L775 271L774 270M785 270L784 272L785 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M787 270L788 271L787 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M784 285C789.169 295.249 803.643 285.868 793.005 279.01C791.42 277.988 789.78 277.529 788 277L797 274C793.873 270.457 784.684 268.182 785.466 275.989C786.114 282.458 799.086 287.501 784 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M793 270L794 271L793 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M794 270L795 271L794 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M859 270L859 272L861 270L859 270M896 270L894 273L898 275L896 270M915 270L919 275L919 271L915 270M946 270L947 271L946 270M1252 270L1252 272L1256 272L1256 270L1252 270z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M513 271L514 272L513 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M576 271L577 272L576 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M640 271L641 272L640 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M666 271L667 272L666 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M669 271L670 272L669 271M685 271L686 272L685 271M699 271L699 290L700 290L699 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M706 271L706 290L707 290L706 271M711 271L712 272L711 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M750 271L751 272L750 271M753 271L754 272L753 271M766 271L767 272L766 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M786 271L787 272L786 271M795 271L796 272L795 271z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M938 271L939 272L938 271M979 275L981 280L989 271L979 275M1002 271L994 276L998 282C1000.36 278.675 1004.02 275.03 1002 271M1007.33 271.667L1007.67 272.333L1007.33 271.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M513 272L514 273L513 272M548 272L549 273L548 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M577 272L578 273L577 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M579 272L580 273L579 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M639 272L640 273L639 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M669 272L670 273L669 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M686 272L687 273L686 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M695 272L696 273L695 272M721 272L722 273L721 272M734 272L735 273L734 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M766 272L766 282L767 282L766 272M771 272L771 282L772 282L771 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M785 272L786 273L785 272M796 272L797 273L796 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M887 272L888 276L890 276L891 273L887 272M929 272L934 277L932 272L929 272z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M550 273L551 274L550 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M567 273L568 274L567 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M568 273L569 276L570 276L568 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M569 273L570 274L569 273M579 273L580 274L579 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M665 273L666 274L665 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M670 273L671 274L670 273M687 273L688 274L687 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M722 273L723 274L722 273M733 273L734 274L733 273M749 273L750 274L749 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M754 273L755 274L754 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M784 273L785 274L784 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M789 273L788 275L789 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M790 273L791 274L790 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M791 273L792 274L791 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M879 274L881 279L882 279L883 273L879 274M909 273L914 280L913 274L909 273z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M514 274L515 275L514 274M547 274L548 275L547 274M565 274L566 275L565 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M638 274L639 275L638 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M670 274L671 275L670 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M688 274L689 275L688 274M723 274L724 275L723 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M732 274L733 275L732 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M749 274L750 275L749 274M754 274L755 275L754 274M784 274L784 277L785 277L784 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M789 274L789 277L792 277L792 274L789 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M793 274L794 275L793 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M796 274L794 275L794 276L796 274z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M870 274C868.413 283.441 882.075 277.35 870 274M943.667 274.333L944.333 274.667L943.667 274.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M80 275L80 277L82 277L82 275L80 275M235 275L236 276L235 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M514 275L515 276L514 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M551 275L552 276L551 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M563 275L564 276L563 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M637 275L638 276L637 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M664 275L665 276L664 275M671 275L672 276L671 275M689 275L690 276L689 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M695.333 275.667L695.667 276.333L695.333 275.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M724 275L725 276L724 275M731 275L732 276L731 275M748 275L749 276L748 275M755 275L756 276L755 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M788 275L789 276L788 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M792.667 275.333L793.333 275.667L792.667 275.333M796 275L797 276L796 275z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M515 276L516 277L515 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M546 276L547 277L546 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M551 276L552 277L551 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M562 276L563 277L562 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M569 276L570 277L569 276M636 276L637 277L636 276M664 276L665 277L664 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M671 276L672 277L671 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M690 276L691 277L690 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M724 276L725 277L724 276M731 276L732 277L731 276M748 276L749 277L748 276M755 276L756 277L755 276M788 276L789 277L788 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M794 276L795 277L794 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M850 276L851 277L850 276M923 276L927 283L928 278L923 276M961 276L961 278L963 278L961 276z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M515 277L516 278L515 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M546 277L547 278L546 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M552 277L553 278L552 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M561 277L562 278L561 277M635 277L636 278L635 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M663 277L664 278L663 277M691 277L692 278L691 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M725 277L726 278L725 277M730 277L731 278L730 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M747 277L748 278L747 277M756 277L757 278L756 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M784 277L785 278L784 277M790 277L791 278L790 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M792 277L793 278L792 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M919 277L920 278L919 277z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M545 278L546 279L545 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M552 278L553 279L552 278M560 278L561 279L560 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M568 278L569 279L568 278M634 278L635 279L634 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M663 278L664 279L663 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M667 278L668 279L667 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M668 278L669 279L668 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M672 278L673 279L672 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M686 278L687 279L686 278M695 278L696 279L695 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M726 278L727 279L726 278M729 278L730 279L729 278M747 278L748 279L747 278M751 278L752 279L751 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M752 278L753 279L752 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M756 278L757 279L756 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M784.333 278.667L784.667 279.333L784.333 278.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M785 278L786 279L785 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M792 278L793 279L792 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M794 278L795 279L794 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M850.667 278.333L851.333 278.667L850.667 278.333M904 278L907 281L907 280L904 278M937 278L939 284L942 283L942 281L937 278z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1200 278C1199.34 280.346 1196.6 282.512 1196.63 284.96C1196.69 288.702 1201.61 288.667 1203.64 286.643C1205.95 284.337 1204.93 280.899 1205 278L1200 278M233 279L234 280L233 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M516 279L517 280L516 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M545 279L546 280L545 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M559 279L560 280L559 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M568 279L569 280L568 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M632 279L633 280L632 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M662 279L663 280L662 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M667 279L666 284L670 284L667 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M668 279L669 280L668 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M672 279L673 280L672 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M686 279L686 290L687 290L686 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M687 279L688 280L687 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M692 279L693 280L692 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M727.667 279.333L728.333 279.667L727.667 279.333M746 279L747 280L746 279M751.667 279.333L752.333 279.667L751.667 279.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M786 279L787 280L786 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M794 279L795 280L794 279z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M897 279L898 280L897 279M933 279L934 285L933 285L931 283L936 291C936.55 286.347 937.415 281.783 933 279M952.667 279.333L953.333 279.667L952.667 279.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M516 280L517 281L516 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M545 280L546 281L545 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M553.333 280.667L553.667 281.333L553.333 280.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M558 280L559 281L558 280M567 280L568 281L567 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M630 280L631 281L630 280M662 280L663 281L662 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M666 280L667 281L666 280M669 280L670 281L669 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M673 280L674 281L673 280M688 280L689 281L688 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M693 280L694 281L693 280M695 280L696 281L695 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M746 280L747 281L746 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M750 280L751 281L750 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M751 280L750 284L754 284L753 280L751 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M753 280L754 281L753 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M757 280L758 281L757 280M787 280L788 281L787 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M795 280L796 281L795 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M797 280L798 281L797 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M917 280L919 289L920 289L920 280L917 280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M544 281L545 282L544 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M557 281L558 282L557 281M567 281L568 282L567 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M627 281L628 282L627 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M628 281L629 282L628 281M666 281L667 282L666 281M669 281L670 282L669 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M673 281L674 282L673 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M689 281L690 282L689 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M694 281L695 282L694 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M722 281L723 282L722 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M723 281L724 282L723 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M733 281L733 290L734 290L733 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M746 281L747 282L746 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M750 281L751 282L750 281M753 281L754 282L753 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M757 281L758 282L757 281M770 281L771 282L770 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M774 281L775 282L774 281M782 281L778 282L778 283L783 282L782 281M783 282L783 283L788 281L783 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M788 281L786 283L786 284L788 286L791 282L788 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M789 281L790 282L789 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M796 281L797 282L796 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M798 281L798 283L800 281L798 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M878 281L876 292L877 292L876 288L885 289L884 282L878 281M897 281L900 284L897 281z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M517 282L518 283L517 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M544 282L545 283L544 282M553 282L554 283L553 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M556 282L557 283L556 282M567 282L568 283L567 282M625 282L626 283L625 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M626 282L627 283L626 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M661 282L662 283L661 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M674 282L675 283L674 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M690 282L691 283L690 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M722 282L722 290L723 290L722 282M724 282L725 283L724 282M731 282L732 283L731 282M745 282L746 283L745 282M758 282L759 283L758 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M766 282L767 283L766 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M785 282L786 283L785 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M789 282L790 283L789 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M791 282L792 283L791 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M792 282L794 284L792 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M797 282L798 283L797 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M889 282L892 287L892 283L889 282z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M517 283L518 284L517 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M544.333 283.667L544.667 284.333L544.333 283.667M553 283L555 287L553 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M624 283L625 284L624 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M661 283L662 284L661 283M665 283L666 284L665 283M670 283L671 284L670 283M674 283L675 284L674 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M691 283L692 284L691 283M725 283L726 284L725 283M730 283L731 284L730 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M745 283L746 284L745 283M749 283L750 284L749 283M754 283L755 284L754 283M758 283L759 284L758 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M763 283L764 284L763 283M766 283L766 286L767 286L766 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M770 283L771 284L770 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M791 283L789 285L789 286L793 283L791 283z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M948 283L946 287L951 286L948 283M961.667 283.333L962.333 283.667L961.667 283.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M231 284L230 288L231 288L231 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M517 284L518 285L517 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M555 284L556 285L555 284M566 284L567 285L566 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M623 284L624 285L623 284M660 284L661 285L660 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M692 284L693 285L692 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M726 284L727 285L726 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M729 284L730 285L729 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M744 284L745 285L744 284M759 284L760 285L759 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M780 291L787 291L787 290L784 284L780 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M785 284L785 285L788 286L785 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M787.667 284.333L788.333 284.667L787.667 284.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M793 284L794 285L793 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M799 284L800 285L799 284z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M860 284L860 287L861 287L860 284M927 284L928 291C924.041 291.506 925.928 295.082 927 298L928 298C928.732 292.927 930.425 288.374 927 284M965 286L965 287L968 291L969 291L972 289L972 285L965 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M518 285L519 286L518 285M554 285L555 286L554 285M566 285L567 286L566 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M622 285L623 286L622 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M660 285L661 286L660 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M675 285L676 286L675 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M693 285L694 286L693 285M728 285L729 286L728 285M744 285L745 286L744 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M759 285L760 286L759 285M793 285L794 286L793 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M976 285L976 286L979 286L976 285z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M518 286L519 287L518 286M621 286L622 287L621 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M659 286L660 287L659 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M694 286L695 287L694 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M743 286L744 287L743 286M760 286L761 287L760 286M764 286L765 287L764 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M766 286L767 287L766 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M771 286L771 287L779 287L771 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M783 286L784 287L783 286M789 286L790 287L789 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M790.667 286.333L791.333 286.667L790.667 286.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M792 286L793 287L792 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M797 286L798 287L797 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M798.333 286.667L798.667 287.333L798.333 286.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M953 286L955 294L962 293L962 292L959 293L961 291L961 290L953 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1232 286L1235 288L1235 296L1230 296L1230 297L1240 297L1240 286L1232 286z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1254 286L1254 288L1256 288L1256 286L1254 286M518 287L519 288L518 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M543 287L544 288L543 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M565 287L566 288L565 287M659 287L660 288L659 287M664 287L664 288L672 288L664 287M676 287L677 288L676 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M695 287L696 288L695 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M743 287L744 288L743 287M748 287L748 288L756 288L748 287M760 287L761 288L760 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M766 287L767 288L766 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M779 287L779 290L780 290L779 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M783 287L786 290L783 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M784 287L785 288L784 287z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M913 287L914 290L915 290L915 287L913 287M925.333 287.667L925.667 288.333L925.333 287.667M564 288L565 289L564 288M620 288L621 289L620 288M658.333 288.667L658.667 289.333L658.333 288.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M663 288L664 289L663 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M672 288L673 289L672 288M676.333 288.667L676.667 289.333L676.333 288.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M747 288L748 289L747 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M756 288L757 289L756 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M761.333 288.667L761.667 289.333L761.333 288.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M766 288L767 289L766 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M781 288L782 289L781 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M785 288L786 289L785 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M796 288L797 289L796 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1266 288L1266 296L1268 296L1268 288L1266 288z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M519 289L520 290L519 289M540 289L541 290L540 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M541.667 289.333L542.333 289.667L541.667 289.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M543 289L544 290L543 289M563 289L564 290L563 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M619 289L620 290L619 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M663 289L664 290L663 289M672 289L673 290L672 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M682 289L683 290L682 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M742 289L743 290L742 289M747 289L748 290L747 289M756 289L757 290L756 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M786 289L787 290L786 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M794 289L795 290L794 289z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M795 289L796 290L795 289M519 290L520 291L519 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M538 290L539 291L538 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M539 290L540 291L539 290M562 290L563 291L562 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M619 290L620 291L619 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M659 290L659 291L663 291L659 290M673 290L673 291L676 291L673 290M685 290L686 291L685 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M698 290L699 291L698 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M708.667 290.333L709.333 290.667L708.667 290.333M719 290L719 291L722 291L719 290M734 290L734 291L737 291L734 290M743 290L743 291L746 291L743 290M757 290L757 291L761 291L757 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M788 290L788 291L793 291L788 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M795 290L796 291L795 290z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M885 290L886 301L887 301L887 297L903 318L899 309L906 312L902 301L885 290M940 290C940.995 294.617 941.959 298.145 947 299L947 298L945 297L947 294L940 290M991 290L992 295L996 291L991 290M519 291L520 292L519 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M537 291L538 292L537 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M561 291L562 292L561 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M787 291L787 292L793 292L787 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M899 291L903 294L903 293L899 291z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M536 292L537 293L536 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M559 292L560 293L559 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M560 292L561 293L560 292M618 292L619 293L618 292z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M936 292L935 298L935 295L932 296L933 306L934 306L938 302L936 292M951 292L951 294L953 294L951 292M974 298L976 296L979 300C983.188 298.712 983.74 295.948 985 292C980.195 292.21 974.987 292.639 974 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M520 293L521 294L520 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M536 293L537 294L536 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M558 293L559 294L558 293M618 293L619 294L618 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M766 293L767 294L766 293z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M520 294L521 295L520 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M535 294L536 295L535 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M557 294L558 295L557 294z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M618.333 294.667L618.667 295.333L618.333 294.667M920 294L921 301L922 301L920 294M520.333 295.667L520.667 296.333L520.333 295.667M534 295L535 296L534 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M556 295L557 296L556 295z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M886.333 295.667L886.667 296.333L886.333 295.667M1219 296L1219 297L1223 296L1219 298L1220 301L1227 304L1228 304L1224 295L1219 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M533 296L534 297L533 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M768 296L769 297L768 296z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M532 297L533 298L532 297M555.333 297.667L555.667 298.333L555.333 297.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M915 297L916 300L912 299L918 302L915 297z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M447 298L445 304C448.331 303.286 448.591 300.762 447 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M521 298L522 299L521 298M531 298L532 299L531 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M962 298L965 305L972 301L962 298z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M521 299L522 300L521 299M531 299L532 300L531 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M555 299L556 300L555 299z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M774.333 299.667L774.667 300.333L774.333 299.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M910 299L911 300L910 299M521 300L522 301L521 300M556 300L557 301L556 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M557 300L558 301L557 300z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M951 300L955 308L958 307L951 300M531 301L532 302L531 301M559 301L560 302L559 301z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M560 301L561 302L560 301M531 302L532 303L531 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M562 302L563 303L562 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M563 302L564 303L563 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M618 302L619 303L618 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M667 302L667 303L671 303L667 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M671 302L672 303L671 302M690 302L691 303L690 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M691 302L691 303L695 303L691 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M695 302L696 303L695 302M722 302L723 303L722 302M731 302L732 303L731 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M732 302L733 303L732 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M745 302L745 303L748 303L745 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M771 302L771 307L765 307L765 322L767 322C767.003 318.013 766.402 314.332 770 312L770 311L768 311L768 310L772 311L772 308L775 304L771 302M773 302L774 303L773 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M929 302L929 306L924 305L925 309L918 307C922.124 311.952 927.117 310.651 933 311L929 302z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M522 303L523 304L522 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M564 303L565 304L564 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M565 303L566 304L565 303M618 303L618 306L619 306L618 303M664 303L665 304L664 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M665 303L666 304L665 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M678 318C674.525 317.425 671.341 319.804 668.044 319.034C662.38 317.711 662.119 309.598 667.109 307.237C670.362 305.697 674.471 308.338 678 308C672.36 300.885 659.082 301.99 659.214 313C659.343 323.848 672.343 324.957 678 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M673 303L674 304L673 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M674 303L675 304L674 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M688 303L689 304L688 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M689 303L690 304L689 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M690.004 303.573C677.657 307.099 683.839 326.042 695.996 322.343C708.354 318.584 702.512 300.002 690.004 303.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M697 303L698 304L697 303M708 303L708 317L709 317L708 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M709 303C709 307.75 707.771 314.613 710.179 318.891C713.32 324.47 721.866 323.826 724.258 317.956C726.017 313.639 725 307.586 725 303L722 303C722 306.973 723.462 318.793 716.975 318.793C710.379 318.793 712 307.042 712 303L709 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M712 303L713 304L712 303M721 303L722 304L721 303M725 303L725 317L726 317L725 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M731 303L732 304L731 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M732 303L732 323L735 323L735 311L748 323L748 303L745 303L745 314L732 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M733 303L734 304L733 303M744 303L744 314L745 314L744 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M748 303L747 324L748 324C749.693 318.273 750.336 308.568 748 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M754 303L754 306L760 306L761 323L763 323L764 306L770 306L770 303L754 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M770 303L771 304L770 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M900 303L901 304L900 303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M971 303L972 304L971 303M1264 303L1265 304L1264 303M23 304L24 305L23 304M28 304L32 307L28 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M522 304L523 305L522 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M532 304L533 305L532 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M566 304L567 305L566 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M567 304L568 305L567 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M662 304L663 305L662 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M663 304L664 305L663 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M675 304L676 305L675 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M686 304L687 305L686 304M699 304L700 305L699 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M712 304L712 317L713 317L712 304M721 304L721 314L722 314L721 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M731.333 304.667L731.667 305.333L731.333 304.667M734 304L735 305L734 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M770 304L764 306L764 307C766.575 306.958 770.542 307.286 770 304z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M880 304L880 305L883 305L880 304M1262 304L1263 305L1262 304M522.333 305.667L522.667 306.333L522.333 305.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M534 305L535 306L534 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M568 305L569 306L568 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M569 305L570 306L569 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M661 305L662 306L661 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M676 305L677 306L676 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M685 305L686 306L685 305M700 305L701 306L700 305M735 305L736 306L735 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M772 305L773 306L772 305M940 305L940 314C944.641 311.79 944.323 307.497 940 305z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M439 306L437 312L432 312C433.988 318.795 442.577 316.108 446 312L440 312L439 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M535 306L536 307L535 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M536 306L537 307L536 306M570 306L571 307L570 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M618.333 306.667L618.667 307.333L618.333 306.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M660 306L661 307L660 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M667 306L668 307L667 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M668 306L668 307L671 307L668 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M671 306L672 307L671 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M677 306L678 307L677 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M684 306L685 307L684 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M690 306L691 307L690 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M691 306L691 307L695 307L691 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M695 306L696 307L695 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M701 306L702 307L701 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M731 306L732 307L731 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M736 306L737 307L736 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M754 306L754 307L760 307L754 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M770 306L771 307L770 306z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M980.667 306.333L981.333 306.667L980.667 306.333M538 307L539 308L538 307M571 307L572 308L571 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M660 307L661 308L660 307M665 307L666 308L665 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M666 307L667 308L666 307M672 307L673 308L672 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M689 307L687 310L689 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M690.228 308.032C684.019 311.696 689.494 321.343 695.852 317.806C702.244 314.25 696.488 304.339 690.228 308.032z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M696 307L697 308L696 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M702 307L703 308L702 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M731 307L731 311L732 311L731 307M737 307L738 308L737 307z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M897 307L898 308L897 307M401 333L402 333L402 328L403 328C403.756 337.256 405.877 343.964 416 344L416 343L414 342L420 338L419 336L422 336L424 319L416 308C403.453 310.639 398.104 320.838 401 333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M523.333 308.667L523.667 309.333L523.333 308.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M539 308L540 309L539 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M573 308L574 309L573 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M659 308L660 309L659 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M664 308L665 309L664 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M673 308L674 309L673 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M676 308L677 309L676 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M677 308L678 309L677 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M683 308L684 309L683 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M697 308L698 309L697 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M702 308L703 309L702 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M738 308L739 309L738 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M769 308L770 309L769 308z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M539 309L540 310L539 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M574 309L575 310L574 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M619 309L620 310L619 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M659 309L660 310L659 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M674 309L675 310L674 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M675 309L676 310L675 309M698 309L699 310L698 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M703 309L704 310L703 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M739 309L740 310L739 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M760.333 309.667L760.667 310.333L760.333 309.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M774 309L775 310L774 309z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M523 310L524 311L523 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M538 310L539 311L538 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M574 310L575 311L574 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M619 310L620 311L619 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M658 310L658 313L659 313L658 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M663 310L664 311L663 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M682 310L683 311L682 310M687 310L688 311L687 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M703 310L704 311L703 310M740 310L741 311L740 310z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M523 311L524 312L523 311M538 311L539 312L538 311M575 311L576 312L575 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M619.333 311.667L619.667 312.333L619.333 311.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M663 311L664 312L663 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M682 311L682 314L683 314L682 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M686 311L686 315L687 315L686 311M699 311L699 315L700 315L699 311M703 311L703 315L704 315L703 311M731 311L731 322L732 322L731 311M735 311L736 312L735 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M741 311L742 312L741 311M908 311L911 319L921 325L918 319L921 320L908 311M966 311L970 316L966 311z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1247 311L1248 312L1247 311M53 312C56.0362 316.488 58.7761 316.982 64 317L64 315L56 312L53 312M80 312L80 320L87 322L97 320L88 317L88 312L80 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M537 312L538 313L537 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M576 312L577 313L576 312M735 312L735 316L736 316L735 312z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M742 312L743 313L742 312M536 313L537 314L536 313M620.333 313.667L620.667 314.333L620.333 313.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M658 313L659 314L658 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M737 313L738 314L737 313M743 313L744 314L743 313z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M524.333 314.667L524.667 315.333L524.333 314.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M535 314L536 315L535 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M577 314L578 315L577 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M658 314L659 315L658 314M663 314L664 315L663 314M682.333 314.667L682.667 315.333L682.333 314.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M721 314L722 315L721 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M738 314L739 315L738 314z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M534 315L535 316L534 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M620 315L621 316L620 315M663 315L664 316L663 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M687 315L688 316L687 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M703 315L704 316L703 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M721 315L722 316L721 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M739 315L740 316L739 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M940 315L943 319L940 315M957 315L961 322L959 315L957 315z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M524 316L525 317L524 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M534 316L535 317L534 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M578 316L579 317L578 316M620 316L620 319L621 319L620 316M659 316L660 317L659 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M674 316L675 317L674 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M675 316L676 317L675 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M683 316L684 317L683 316M687 316L688 317L687 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M698 316L699 317L698 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M703 316L704 317L703 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M735 316L735 322L736 322L735 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M740 316L741 317L740 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M935 316L939 321L935 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M958 316L959 317L958 316z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M524.333 317.667L524.667 318.333L524.333 317.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M533 317L534 318L533 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M578 317L579 318L578 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M621 317L622 318L621 317M659 317L660 318L659 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M664 317L665 318L664 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M673 317L674 318L673 317M677 317L678 318L677 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M683 317L684 318L683 317M688 317L689 318L688 317M697 317L698 318L697 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M702 317L703 318L702 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M708 317L709 318L708 317M713 317L714 318L713 317M720 317L721 318L720 317M725 317L726 318L725 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M741 317L742 318L741 317z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M533 318L534 319L533 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M660 318L661 319L660 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M665 318L666 319L665 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M666 318L667 319L666 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M672 318L673 319L672 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M684 318L685 319L684 318M689 318L690 319L689 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M690 318L691 319L690 318M695 318L696 319L695 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M696 318L697 319L696 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M702 318L703 319L702 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M709 318L710 319L709 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M714 318L715 319L714 318M719 318L720 319L719 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M724 318L725 319L724 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M742 318L743 319L742 318z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M952.333 318.667L952.667 319.333L952.333 318.667M23 319L24 320L23 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M532 319L533 320L532 319M579 319L580 320L579 319M661 319L664 322L661 319M667 319L667 320L671 320L667 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M677 319L678 320L677 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M684 319L685 320L684 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M691 319L691 320L695 320L691 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M701 319L702 320L701 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M709 319L710 320L709 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M715 319L716 320L715 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M716 319L717 320L716 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M717.667 319.333L718.333 319.667L717.667 319.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M724 319L725 320L724 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M743 319L744 320L743 319z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1004 319L1003 321L1004 319M532 320L533 321L532 320M579 320L580 321L579 320M621.333 320.667L621.667 321.333L621.333 320.667M661 320L662 321L661 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M676 320L677 321L676 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M685 320L686 321L685 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M700 320L701 321L700 320M710 320L711 321L710 320M723 320L724 321L723 320M744 320L745 321L744 320z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M525 321L526 322L525 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M531 321L532 322L531 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M580 321L581 322L580 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M662 321L663 322L662 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M675 321L676 322L675 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M686 321L687 322L686 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M687 321L688 322L687 321M698 321L699 322L698 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M699 321L700 322L699 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M711 321L712 322L711 321M722 321L723 322L722 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M745 321L746 322L745 321z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M525 322L526 323L525 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M530 322L529 324L530 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M580 322L581 323L580 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M620 322L619 324L620 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M664 322L665 323L664 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M665 322L666 323L665 322M672 322L673 323L672 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M673 322L674 323L673 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M674 322L675 323L674 322M688 322L689 323L688 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M689 322L690 323L689 322M696 322L697 323L696 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M697 322L698 323L697 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M712 322L713 323L712 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M713 322L714 323L713 322M720 322L721 323L720 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M721 322L722 323L721 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M731 322L732 323L731 322M735 322L736 323L735 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M746 322L747 323L746 322M760 322L761 323L760 322M763 322L764 323L763 322z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M530 323L531 324L530 323M581 323L582 324L581 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M582 323L583 324L582 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M620 323L621 324L620 323M666.667 323.333L667.333 323.667L666.667 323.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M668 323L668 324L671 324L668 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M671 323L672 324L671 323M691 323L692 324L691 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M692.667 323.333L693.333 323.667L692.667 323.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M694 323L695 324L694 323M715 323L716 324L715 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M716.667 323.333L717.333 323.667L716.667 323.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M718 323L719 324L718 323M748 323L749 324L748 323z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M764 323L766 326L764 323M426.333 324.667L426.667 325.333L426.333 324.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M526 324L527 325L526 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M527 324L528 325L527 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M528 324L529 325L528 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M529 324L530 325L529 324M583 324L584 325L583 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M584 324L584 325L599 325L584 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M599 324L599 325L617 325L599 324z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M617.667 324.333L618.333 324.667L617.667 324.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M659 324L660 325L659 324M1250 324L1247 327L1247 328L1252 324L1250 324M656 326L660 328L658 325L656 326M663 326L663 327L666 327L666 326L663 326M648 327L648 328L655 328L648 327M672 327L673 328L672 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M763 327L764 328L763 327z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M496 328L497 329L496 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M760 328L761 329L760 328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M930 328L931 329L930 328M972 328L973 329L972 328M1249 334C1252.65 337.898 1251.78 341.362 1250 346L1264 348L1258 332L1260 332C1255.76 326.914 1251.39 328.023 1249 334M982.333 329.667L982.667 330.333L982.333 329.667M96 330L96 331L100 331L96 330z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1252.33 330.667L1252.67 331.333L1252.33 330.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M637 331L638 332L637 331M640 331L640 336C638.203 338.854 638.849 339.975 642 341L642 337C644.912 338.393 646.143 338.779 648 336L654 336L654 340L649 340L649 341L657 340L656 336L658 340L663 339L664 336L658 336L656 331L640 331M977.333 331.667L977.667 332.333L977.333 331.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1256 331L1257 332L1256 331z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M657.667 332.333L658.333 332.667L657.667 332.333M544 336L554 334L544 336M635 333L636 334L635 333M630 334L630 336L632 334L630 334z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M369 335L370 336L369 335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M980 335L981 339L982 339L980 335M987 335L988 336L987 335z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M356 336L357 337L356 336z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M553 337L553 338L557 338L551 340L553 347L552 347L548 342L550 349C550.702 348.86 555.266 354.846 553 359C551.181 362.335 548.412 361.351 549 359L546 362L538 359L540 364C533.427 366.182 533.711 382.784 541 384L541 385L538 385L538 386L542 386C546.317 394.226 560.944 385.272 568 385L568 384L563 384C567.387 378.461 568 374.983 568 368C572.633 369.171 579.029 368.782 583 366L586 368L587 364L583 366L587 360L584 362L583 362L582 362L577 360L577 356L576 356L576 360L575 360L572 359L572 344L568 345L569 348L570 348L572 345L572 358L567 359L567 355L565 354L564 354L564 360L561 359L562 345L566 348L560 336L553 337M668 336L668 340L670 336L668 336M672 336L672 338L674 338L674 336L672 336M540 337L541 338L540 337M564 337L565 338L564 337M996 337L998 339L998 337L996 337M406 339L407 340L406 339M564.667 339.333L565.333 339.667L564.667 339.333M622 340L622 342L624 340L622 340M983 340L983 344L984 344L985 340L983 340M357 341L358 342L357 341M408 341L408 342L414 342L408 341M562 341L562 342L571 342L571 341L562 341M672 341L673 344L674 344L674 341L672 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M876 341L877 342L876 341z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M572 342L573 343L572 342M640 342L641 343L640 342z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M560 343L560 358L561 358L560 343z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M575 343L574 345L576 345L575 343M642 343L639 344L639 345L643 344L642 343M510 344L511 345L510 344M518 344L519 345L518 344M534 344L535 345L534 344M540 344L541 345L540 344M546.667 344.333L547.333 344.667L546.667 344.333M578 344L577 346L578 344M581 344L581 345L584 346L581 344M591 344L592 345L591 344M605 344L606 345L605 344M617 344L617 345L621 345L617 344M625 344L625 345L625 346L628 345L628 344L625 344M630 344L631 345L630 344M635 344L636 345L635 344M646 344L647 345L646 344M651 344L652 345L651 344M657 344L658 345L657 344M700 344L701 345L700 344M727 344L728 345L727 344M752 344L751 346L752 344M756 344L757 345L756 344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M767.667 344.333L768.333 344.667L767.667 344.333M772 344L772 345L775 346L772 344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M992 344L993 345L992 344z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M26 345L26 352L32 352L26 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M509 345L510 346L509 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M510 345L510 347L514 347L514 357L515 357L515 347L519 347L519 345L510 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M519.333 345.667L519.667 346.333L519.333 345.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M524 345L525 346L524 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M525 345L525 357L526 357L526 352L533 352L535 357L534 345L533 345L533 350L526 350L525 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M526 345L526 350L527 350L526 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M532 345L533 346L532 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M534 345L535 346L534 345M540 345L540 356L541 356L540 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M541 345L540 357L548 357L548 356L542 356L542 352L546 352L546 350L542 350L542 347L548 347L548 345L541 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M548.333 345.667L548.667 346.333L548.333 345.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M562 345L562 357L564 357L564 350L572 357L572 345L571 345L570 353L562 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M570 345L571 346L570 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M581 345L582 346L581 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M582 345L577 357L587 357L582 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M590.333 345.667L590.667 346.333L590.333 345.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M591 345L591 347L595 347L595 357L596 357L596 347L600 345L591 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M595.667 345.333L596.333 345.667L595.667 345.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M600 345L601 346L600 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M605 345L606 358L607 358L605 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M606 345L606 357L607 357L606 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M607 345L608 346L607 345M615 345L616 346L615 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M616 345L617 346L616 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M617.059 345.786C610.069 348.238 613.798 359.336 620.892 356.886C627.917 354.459 624.256 343.262 617.059 345.786z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M621 345L622 346L621 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M622 345L623 346L622 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M630 345L631 358L632 358L630 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M631 345L634 348L631 345M638 345L639 346L638 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M639 345L639 353L631 346L631 357L632 357L632 350L640 357L639 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M640 345L639 358C642.156 355.242 641.53 348.647 640 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M650.667 345.333L651.333 345.667L650.667 345.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M659 345L660 346L659 345M661 345L662 346L661 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M662 345L662 357L669 357L669 356L663 356L662 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M663 345L663 356L664 356L663 345M681 345L682 346L681 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M681 346L682 357C694.842 356.848 692.244 343.199 681 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M686.667 345.333L687.333 345.667L686.667 345.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M688 345L689 346L688 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M700.667 345.333L701.333 345.667L700.667 345.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M708 345L713 348L713 347L708 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M709 345L710 346L709 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M709 346L709 347L713 347L713 357L715 357L715 347L719 347L719 345L709 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M714 345L715 346L714 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M719.333 345.667L719.667 346.333L719.333 345.667M726 345L727 346L726 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M727 345L726 347L727 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M737 345L737 358L738 358L737 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M738 345L739 346L738 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M738 357C740.054 356.993 742.779 357.359 744.679 356.397C751.609 352.887 738.616 337.725 738.019 351C737.93 352.993 738 355.005 738 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M743 345L744 346L743 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M744 345L745 346L744 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M756 345L752 357L762 357L756 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M757 345L758 346L757 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M766 345L767 346L766 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M768 345L767 347L768 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M773 356L767 355L767 356L774 357L769 347L774 348C772.485 345.89 767.274 344.4 767.921 348.85C768.279 351.319 771.824 353.713 773 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M772 345L773 346L772 345M780 345L781 346L780 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M780 357L788 357L788 356L782 356L782 352L786 352L786 350L782 350L782 347L788 347L788 345C779.441 345.101 780 349.62 780 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M788.333 345.667L788.667 346.333L788.333 345.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M789 345L790 346L789 345z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M509 346L510 347L509 346M524 346L525 347L524 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M532 346L532 350L533 350L532 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M575 346L576 347L575 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M581 346L582 347L581 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M583 346L584 347L583 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M588 346L589 347L588 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M600 346L601 347L600 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M607 346L607 357L608 357L607 346M614 346L615 347L614 346M623 346L624 347L623 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M638 346L637 353L638 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M645.333 346.667L645.667 347.333L645.333 346.667M647 346L648 347L647 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M650 346L646 357L656 357L652 346L650 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M652 346L653 347L652 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M661 346L661 357L662 357L661 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M689 346L691 348L689 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M690 346L691 347L690 346M699 346L700 347L699 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M700 346L696 357L706 357L702 346L700 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M702 346L703 347L702 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M727 346L722 357L732 357L727 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M728 346L729 347L728 346M745 346L746 347L745 346M755 346L756 347L755 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M757 346L758 347L757 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M775 346L776 347L775 346z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M506 347L507 348L506 347M509 347L509 348L513 348L509 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M513 347L513 357L514 357L513 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M515 347L514 358L515 358L515 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M516 347L516 348L520 348L516 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M524 347L525 348L524 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M534.333 347.667L534.667 348.333L534.333 347.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M542 347L542 350L543 350L542 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M543 347L543 348L549 349L543 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M564 347L565 348L564 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M577 347L578 348L577 347M580 347L581 348L580 347M590 347L590 348L594 348L590 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M594 347L595 358L596 358L594 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M596 347L596 357L597 357L596 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M597 347L597 348L601 348L597 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M613 347L614 348L613 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M616 347L617 348L616 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M617 347L618 348L617 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M618.185 348.086C613.985 349.076 615.504 355.937 619.892 354.338C623.754 352.931 622.234 347.133 618.185 348.086z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M619.667 347.333L620.333 347.667L619.667 347.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M621 347L622 348L621 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M624 347L625 348L624 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M627 347L628 348L627 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M649 347L650 348L649 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M652 347L653 348L652 347M681 347C681.001 352.023 680.043 357.006 686 358L686 357L682 357L681 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M683 347L683 356L684 356L683 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M684 347L684 348L687 348L684 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M687 347L688 348L687 347M699 347L700 348L699 347M702 347L703 348L702 347M715 347L716 348L715 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M716 347L716 348L720 348L716 347M725 347L726 348L725 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M728 347L729 348L728 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M740 347L740 348L744 349L744 348L740 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M743 347L744 348L743 347M745 347L746 348L745 347M755 347L756 348L755 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M758 347L759 348L758 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M765 347L762 350L765 350L765 352L766 352L767 351L772 355L765 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M769 347L770 348L769 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M769 348L777 354L777 349L775 348L769 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M771 347L772 348L771 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M772 347L773 348L772 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M782 347L783 348L782 347z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M988.333 347.667L988.667 348.333L988.333 347.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M524 348L525 358L526 358L524 348M565 348L566 349L565 348M580 348L581 349L580 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M584 348L585 349L584 348M589 348L590 349L589 348M612 348L613 349L612 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M615 348L616 349L615 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M622 348L623 349L622 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M625.333 348.667L625.667 349.333L625.333 348.667M634 348L635 349L634 348M653 348L654 349L653 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M684 348L684 355C689.714 354.046 689.714 348.954 684 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M688 348L689 349L688 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M691 348L692 349L691 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M703 348L704 349L703 348M715 348L715 358L716 358L715 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M725 348L726 349L725 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M729 348L730 349L729 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M740 348L740 350L743 350L743 348L740 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M750 348L751 349L750 348M754 348L755 349L754 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M758 348L759 349L758 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M766 348L767 349L766 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M782 348L783 349L782 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M783 348L783 350L785 350L785 348L783 348M786 348L787 349L786 348z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M544 349L545 350L544 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M566 349L567 350L566 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M569.333 349.667L569.667 350.333L569.333 349.667M579 349L580 350L579 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M582 349L581 351L582 349M584 349L585 350L584 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M612 349L613 350L612 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M615 349L616 350L615 349M622 349L623 350L622 349M635 349L637 351L635 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M648 349L649 350L648 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M650.667 349.333L651.333 349.667L650.667 349.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M653 349L654 350L653 349M689.333 349.667L689.667 350.333L689.333 349.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M691 349L692 350L691 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M698 349L699 350L698 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M700.667 349.333L701.333 349.667L700.667 349.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M703 349L704 350L703 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M724 349L725 350L724 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M727 349L728 350L727 349M729 349L730 350L729 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M743 349L744 350L743 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M745 349L746 350L745 349M754 349L755 350L754 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M756 349L758 351L756 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M759 349L760 350L759 349M766 349L767 350L766 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M769 349L770 350L769 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M770 349L771 350L770 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M779 349L780 350L779 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M782 349L783 350L782 349z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M408 350L411 352L408 350M518 350L519 351L518 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M534 350L534 356L535 356L534 350M546.333 350.667L546.667 351.333L546.333 350.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M564 350L566 352L564 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M567 350L568 351L567 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M577 350L577 352L579 352L577 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M579 350L580 351L579 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M582 350L581 353L582 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M585 350L586 351L585 350M587 350L589 352L589 350L587 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M612.333 350.667L612.667 351.333L612.333 350.667M614 350L614 353L615 353L614 350M623 350L623 353L624 353L623 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M625 350L625 353L626 353L625 350M632 350L632 357L633 357L632 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M633 350L634 351L633 350M635 350L636 351L635 350M648 350L649 351L648 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M650 350L651 351L650 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M651 350L652 351L651 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M698 350L699 351L698 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M700.667 350.333L701.333 350.667L700.667 350.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M703 350L704 351L703 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M724 350L725 351L724 350M726 350L727 351L726 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M727 350L726 352L727 350M730 350L731 351L730 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M740 350L740 351L743 351L740 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M745 350L746 351L745 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M753 350L754 351L753 350M756 350L758 352L756 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M759 350L760 351L759 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M767 350L768 351L767 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M771 350L772 351L771 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M772 350L773 351L772 350z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M786.333 350.667L786.667 351.333L786.333 350.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M504.667 351.333L505.333 351.667L504.667 351.333M522 351L523 352L522 351M547 351L549 355L543 355L543 356L550 355L547 351M549 351L550 352L549 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M564 351L567 355L567 359C570.673 356.071 566.843 353.087 564 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M568 351L570 353L568 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M569 351L570 352L569 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M581 351L582 352L581 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M583 351L584 352L583 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M585 351L586 352L585 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M634 351L635 352L634 351M636 351L637 352L636 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M647 351L648 352L647 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M650 351L650 353L652 353L652 351L650 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M654 351L655 352L654 351M689 351L690 352L689 351M697 351L698 352L697 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M700 351L700 353L702 353L702 351L700 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M704 351L705 352L704 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M727 351L726 353L728 353L727 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M728 351L729 352L728 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M730 351L731 352L730 351M746 351L747 352L746 351M753 351L754 352L753 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M755 351L756 352L755 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M756 351L756 353L758 353L756 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M760 351L761 352L760 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M768 351L769 352L768 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M769 351L770 352L769 351z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M773 351L774 352L773 351M526 352L526 357L527 357L526 352M532 352L532 357L533 357L532 352M542 352L542 356L543 356L542 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M543 352L543 355L549 355L543 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M566 352L567 353L566 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M574 352L577 354L574 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M578 352L579 353L578 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M580.333 352.667L580.667 353.333L580.333 352.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M583 352L581 353L581 354L583 352M586 352L587 353L586 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M612 352L613 353L612 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M621 352L622 353L621 352M634 352L635 353L634 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M647 352L648 353L647 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M649.333 352.667L649.667 353.333L649.333 352.667M652.333 352.667L652.667 353.333L652.333 352.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M654 352L655 353L654 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M689 352L690 353L689 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M697 352L698 353L697 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M699.333 352.667L699.667 353.333L699.333 352.667M702.333 352.667L702.667 353.333L702.333 352.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M704 352L705 353L704 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M723 352L724 353L723 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M725 352L726 353L725 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M728 352L726 353L726 354L728 352M731 352L732 353L731 352M740 352L741 353L740 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M740 355L745 355C743.228 352.318 741.772 352.318 740 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M744 352L745 353L744 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M747 352L747 355L748 355L747 352M755 352L758 354L758 353L755 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M758.333 352.667L758.667 353.333L758.333 352.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M760 352L761 353L760 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M764 352L765 353L764 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M770 352L771 353L770 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M771 352L772 353L771 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M774 352L775 353L774 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M777 352L778 353L777 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M782 352L783 356L784 356L782 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M783 352L783 355L784 355L783 352z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M546 353L547 354L546 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M567 353L568 354L567 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M578 353L579 354L578 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M586 353L587 354L586 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M612 353L613 354L612 353M615 353L616 354L615 353M622 353L621 355L622 353M625 353L626 354L625 353M635 353L636 354L635 353M646 353L647 354L646 353M650.667 353.333L651.333 353.667L650.667 353.333M655 353L656 354L655 353M669 353L670 354L669 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M689 353L690 354L689 353M691 353L692 354L691 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M696 353L697 354L696 353M700.667 353.333L701.333 353.667L700.667 353.333M705 353L706 354L705 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M725 353L726 354L725 353M728 353L729 354L728 353M731 353L732 354L731 353M752 353L753 354L752 353M755 353L756 354L755 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M760 353L761 354L760 353M772 353L773 354L772 353M774 353L774 356L775 356L774 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M779 353L780 354L779 353z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M518 354L520 356L518 354M521 354L522 355L521 354M551.333 354.667L551.667 355.333L551.333 354.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M568 354L569 355L568 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M577 354L578 355L577 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M586 354L587 355L586 354M613 354L614 355L613 354M615 354L616 355L615 354M622 354L623 355L622 354M624 354L625 355L624 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M636 354L637 355L636 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M646 354L647 355L646 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M655 354L656 355L655 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M688 354L689 355L688 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M691 354L692 355L691 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M696 354L697 355L696 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M705 354L706 355L705 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M722 354L723 355L722 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M731 354L732 355L731 354M752 354L753 355L752 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M761 354L762 355L761 354M766 354L767 355L766 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M767 354L768 355L767 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M772 354L773 355L772 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M785 354L785 355L788 355L785 354z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1272.33 354.667L1272.67 355.333L1272.33 354.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M569 355L570 356L569 355M577 355L578 356L577 355M580 355L580 356L585 356L580 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M587 355L588 356L587 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M589.333 355.667L589.667 356.333L589.333 355.667M613 355L614 356L613 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M617 355L618 356L617 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M618.667 355.333L619.333 355.667L618.667 355.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M620 355L621 356L620 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M624 355L625 356L624 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M637 355L638 356L637 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M648 355L648 356L654 356L648 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M656 355L657 356L656 355M664 355L664 356L670 356L664 355M684.667 355.333L685.333 355.667L684.667 355.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M686 355L687 356L686 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M687 355L688 356L687 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M690 355L691 356L690 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M698 355L698 356L704 356L698 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M706 355L707 356L706 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M722 355L723 356L722 355M724 355L724 356L730 356L724 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M732 355L733 356L732 355M740 355L740 356L744 356L740 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M744 355L745 356L744 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M751 355L752 356L751 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M754 355L754 356L760 356L754 355M761 355L762 356L761 355M766 355L767 356L766 355M768 355L769 356L768 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M769 355L770 356L769 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M770.667 355.333L771.333 355.667L770.667 355.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M772 355L773 356L772 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M775 355L775 359L776 359L775 355M777 355L778 356L777 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M782 355L783 356L782 355M784 355L784 356L788 356L784 355z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M517 356L518 357L517 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M548 356L541 357L541 358L549 357L548 356M570 356L571 357L570 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M574 356L575 357L574 356M579 356L580 357L579 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M585 356L585 357L588 358L588 357L588 356L585 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M614 356L616 358L614 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M615 356L616 357L615 356M622 356L623 357L622 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M623 356L624 357L623 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M638 356L639 357L638 356M645.333 356.667L645.667 357.333L645.333 356.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M654 356L656 358L654 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M656.333 356.667L656.667 357.333L656.333 356.667M669 356L670 357L669 356M689 356L690 357L689 356M695.333 356.667L695.667 357.333L695.333 356.667M706.333 356.667L706.667 357.333L706.333 356.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M721.333 356.667L721.667 357.333L721.333 356.667M724 356L725 357L724 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M730 356L730 357L733 357L733 356L730 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M746 356L747 357L746 356M749 356L750 357L749 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M751 356L751 357L754 357L754 356L751 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M759 356L760 357L759 356M762 356L763 357L762 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M765 356L767 358L765 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M767 356L768 357L767 356M788 356L781 357L781 358L789 357L788 356z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M789.333 356.667L789.667 357.333L789.333 356.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M513 357L514 358L513 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M515 357L516 358L515 357M524 357L525 358L524 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M526 357L527 358L526 357M529 357L530 358L529 357M532 357L533 358L532 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M533 357L534 358L533 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M534 357L535 358L534 357M540 357L541 358L540 357M548 357L549 358L548 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M550 357L552 359L552 357L550 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M562 357L563 358L562 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M563 357L564 358L563 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M571 357L572 358L571 357M577 357L578 358L577 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M578 357L579 358L578 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M585 357L586 358L585 357M590 357L592 359L592 357L590 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M594 357L595 358L594 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M596 357L597 358L596 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M605 357L606 358L605 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M607 357L608 358L607 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M616 357L617 358L616 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M617 357L618 358L617 357M620 357L621 358L620 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M621 357L622 358L621 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M622 357L623 358L622 357M626 357L627 358L626 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M630 357L631 358L630 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M632 357L633 358L632 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M646 357L647 358L646 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M647 357L648 358L647 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M654 357L655 358L654 357M661 357L662 358L661 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M662 357L662 358L669 358L662 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M669 357L670 358L669 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M681 357L682 358L681 357M686.667 357.333L687.333 357.667L686.667 357.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M688 357L689 358L688 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M696 357L697 358L696 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M697 357L698 358L697 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M704 357L705 358L704 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M705 357L706 358L705 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M713 357L714 358L713 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M714 357L715 358L714 357M722 357L723 358L722 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M723 357L724 358L723 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M730 357L731 358L730 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M732 357L733 358L732 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M738 357L738 358L744 358L738 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M744 357L745 358L744 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M745 357L746 358L745 357M750 357L751 358L750 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M751 357L752 358L751 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M753 357L754 358L753 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M760 357L761 358L760 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M761 357L762 358L761 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M762 357L763 358L762 357M768 357L769 358L768 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M769 357L770 358L769 357M771 357L772 358L771 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M772 357L773 358L772 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M778 357L779 358L778 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M780 357L781 358L780 357M788 357L789 358L788 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M806 357L807 358L806 357z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M496 359L496 360L500 368L504 368L504 367L502 362L506 362L505 368L510 362L509 358L506 360L502 360L496 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M561 358L561 359L564 360L561 358M570 358L571 359L570 358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M582.667 358.333L583.333 358.667L582.667 358.333M593 358L594 359L593 358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M766 359L766 360L774 360L774 358L766 359M779 358L779 359L787 359L779 358z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1266 360L1266 361L1268 362L1265 362L1265 365L1262 365L1263 370L1264 370L1264 366L1268 366L1268 362L1272 362L1271 365L1275 366L1277 358L1266 360M513 359L514 360L513 359M516 359L517 360L516 359M522 359L523 360L522 359M531 359L532 360L531 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M566 359L567 360L566 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M589.667 359.333L590.333 359.667L589.667 359.333M592 359L593 360L592 359M595 359L596 360L595 359M760 359L761 360L760 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M805 359L806 360L805 359z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M756 360L758 363L756 360M1278 362L1278 364L1280 362L1278 362M520 363L519 368C529.48 363.68 527.855 378.385 535 384C532.322 372.75 534.067 364.918 520 363M591 364L590 367L591 364M513 365L512 368L513 368L514 368L513 365M384 366L384 368L386 366L384 366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M537 366L538 367L537 366M552 366L552 368L554 368L554 366L552 366z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1277 370L1278 371L1277 370M512 376L512 377L520 377L512 376M576 376L577 377L576 376M16 387L32 385C27.9335 383.297 18.9939 383.57 16 387M87 384L88 385L87 384z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M559 386L562 385L559 386z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M87 386L88 387L87 386M7 451L9 450C12.0857 457.666 23.5329 470.725 32 471L32 472L28 472C31.9579 481.819 26.9069 496.32 24.2014 506.166C23.2719 509.548 18.784 515.52 24.034 517.343C28.0854 518.749 35.5815 512.019 41 512L36.9923 465.17L42 448L45 449C48.9358 441.436 45.9318 433.904 45.3804 426C44.7177 416.501 48.2805 405.37 43.1813 396.519C40.4737 391.819 34.5365 392.033 32 387C26.6202 387.015 17.9035 386.538 13.1296 389.175C-1.42346 397.215 0 411.876 0 426C0 431.027 -1.21717 437.938 0.563272 442.7C1.75302 445.882 5.03026 448.276 7 451M839 388C831.891 391.625 819.435 404.488 836 402L835 398L842 402L840 398C844.254 396.589 844.235 393.042 845 389L839 388M847 410L851 416C850.644 419.333 850.596 421.033 854 422L855 415L863 412L863 406L862 409L865 409L868 393L847 410z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M37 394L38 395L37 394z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M152 395C149.763 399.877 146.01 400.697 141 400L140 408L132 408C132.001 421.423 137.661 417.347 148.039 416.129C151.069 415.773 155.831 417.004 158.397 414.972C165.306 409.5 157.117 397.838 152 395z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M335 395L336 396L335 395M152 398L152 400L154 400L154 398L152 398z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M502.667 399.333L503.333 399.667L502.667 399.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M814 399L815 400L814 399M866 400L867 401L866 400z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M872 403L873 404L872 403M860 416L861 417L860 416z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M835 417L836 418L835 417M826 420L827 421L826 420M834 420L834 421L837 421L834 420M606.667 423.333L607.333 423.667L606.667 423.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M620 423L621 424L620 423z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M828 424L829 425L828 424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M853 424L850 425L852 428L849 427C849.854 430.903 853.027 429.237 856 428L853 427L853 426L855 424L853 424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M823 426L823 429L824 429L823 426M826.667 426.333L827.333 426.667L826.667 426.333M820.667 429.333L821.333 429.667L820.667 429.333M635 431L636 432L635 431M819 431L817 434L821 432L819 431M839 432L840 433L839 432M844 433L844 434L848 435L848 434L844 433z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M831 434L831 436L833 436L831 434M824 435L825 436L824 435z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M808.333 436.667L808.667 437.333L808.333 436.667M814.333 436.667L814.667 437.333L814.333 436.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M852 436L855 442L856 442L852 436M822 438L823 439L822 438M848 438L849 439L848 438z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M715.667 439.333L716.333 439.667L715.667 439.333M814.667 439.333L815.333 439.667L814.667 439.333M390 440C387.289 450.135 387.853 454.028 391 464C399.252 466.47 401.772 480.659 403 488L411 488L413 454C419.498 452.608 413.002 445.621 409.972 443.5C404.024 439.335 396.848 440 390 440M756 440L752 442L752 443L760 443L760 442L758 440L756 440z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M937 441L937 442L951 442L937 441M1099 441L1100 442L1099 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1100.67 441.333L1101.33 441.667L1100.67 441.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M1102 441.627C1090.54 443.439 1093.76 459.63 1105 457.767C1115.69 455.993 1112.35 439.992 1102 441.627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1105 441L1106 442L1105 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1106 441L1107 442L1106 441z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M326 442L327 443L326 442M858 442L859 443L858 442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M937 442L938 443L937 442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M937 443L938 520L951 520C951 510.313 948.709 497.266 951.653 488.004C953.222 483.068 958.685 478.86 963.996 480.758C975.718 484.945 971 510.192 971 520L985 520C985 501.233 990.846 463.653 961 468.213C957.186 468.796 954.076 470.812 951 473L951 442L937 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M951 442L951 472L952 472L951 442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1098 442L1099 443L1098 442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1108 442L1109 443L1108 442z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M810 443L811 444L810 443M1096 443L1097 444L1096 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1109 443L1110 444L1109 443z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M808.333 444.667L808.667 445.333L808.333 444.667M815 444L816 445L815 444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M937 444L938 445L937 444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1095 444L1096 445L1095 444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1110 444L1111 445L1110 444z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1095 445L1096 446L1095 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1111 445L1112 446L1111 445z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M937 446L938 447L937 446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1094 446L1095 447L1094 446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1111 446L1112 447L1111 446z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M319 447L320 448L319 447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1094 447L1095 448L1094 447z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M40 448L41 449L40 448M749 448L748 450L749 448M751 448L752 449L751 448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M762 448L763 449L762 448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M937 448L937 520L938 520L938 471L937 448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1112 448L1112 452L1113 452L1112 448z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M658 449L659 450L658 449z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M43 450L44 451L43 450M45 450L45 451L48 451L45 450M51 450L51 451L54 451L51 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M458 450L459 451L458 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M459 450L459 451L462 451L459 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M462 450.428C429.738 455.009 417.279 497.339 446 516.034C454.261 521.411 464.465 522.086 474 520.819C518.997 514.842 506.402 444.124 462 450.428z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M470 450L470 451L473 451L470 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M473.667 450.333L474.333 450.667L473.667 450.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M680 450L681 451L680 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M804 450L805 451L804 450M894 450L895 451L894 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M895.667 450.333L896.333 450.667L895.667 450.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M897.667 450.333L898.333 450.667L897.667 450.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M875 506C886.552 528.268 933.245 525.738 924.427 495C921.518 484.857 909.284 481.495 901 477.243C897.893 475.648 892.316 472.982 893.238 468.579C896.061 455.095 909.828 468.624 915 468.833C918.123 468.96 921.488 465.562 924 464C914.908 442.585 873.622 447.515 879.39 474C881.869 485.378 894.038 488.54 903 493.263C906.755 495.242 912.621 498.838 910.573 503.956C905.271 517.208 891.42 503.009 885 501.327C881.51 500.413 877.662 504.191 875 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M903 450L903 451L906 451L903 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M906 450L907 451L906 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M907 450L908 451L907 450z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M43 451L44 452L43 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M58 491L88 491L88 490C82.1584 490 61.7881 486.856 58.0278 491.603C53.9713 496.725 57 513.551 57 520L44 520L44 452L57 452L57 478C59.086 473.029 59.8375 458.278 57.3966 453.318C55.6436 449.755 45.3564 449.755 43.6034 453.318C41.7316 457.122 43 463.845 43 468L43 504C43 507.929 41.4562 516.15 44.0278 519.397C46.2343 522.183 55.7536 522.021 57.3966 518.682C60.6695 512.031 58 498.392 58 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M57 451L58 452L57 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M88 451L88 452L102 452L88 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M102 451L102 521L103 521L103 473L102 451M303 454L304 454L306 452L303 454M311 451L312 452L311 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M454 451L455 452L454 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M455 451L456 452L455 451M476 451L477 452L476 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M477.667 451.333L478.333 451.667L477.667 451.333M653 451L653 521L654 521L654 473L653 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M654 451L654 452L668 452L654 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M751 451L752 452L751 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M891 451L892 452L891 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M892 451L893 452L892 451M909 451L910 452L909 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M910 451L911 452L910 451z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M44 452L44 520L57 520C57 513.702 53.9709 496.236 58.6034 491.603C63.3423 486.865 81.5397 490 88 490L88 520L102 520L102 452L88 452L88 478L57 478L57 452L44 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M313 452L312 454L313 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M316 452L317 453L316 452M318 452L319 453L318 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M451 452L452 453L451 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M452 452L453 453L452 452M479 452L480 453L479 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M480 452L481 453L480 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M654 452L654 520L668 520L668 452L654 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M670 452L670 454L672 454L670 452M748 452L749 453L748 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M889 452L890 453L889 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M912 452L913 453L912 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M913 452L914 453L913 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1094 452L1095 453L1094 452z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M40 453L41 454L40 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M449 453L450 454L449 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M450 453L451 454L450 453M482 453L483 454L482 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M652 453L652 460L653 460L652 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M863 453L864 454L863 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M887 453L888 454L887 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M914 453L915 454L914 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1094 453L1095 454L1094 453z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1111 453L1112 454L1111 453M447 454L448 455L447 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M448 454L449 455L448 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M484 454L485 455L484 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M886 454L887 455L886 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M916 454L917 455L916 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1095 454L1096 455L1095 454z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M300 455L300 456L314 456L300 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M315 455L316 456L315 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M446 455L447 456L446 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M486 455L487 456L486 455M582 455L583 456L582 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M582 465L583 465L583 456L596 456L596 468C599.499 459.661 590.092 447.692 583.028 456.603C581.379 458.683 582.002 462.528 582 465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M596 455L597 456L596 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M668 455L669 456L668 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M746 455L746 456L760 456C760 468.721 762.864 469 775 469L775 468L761 468C761 455.279 758.136 455 746 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M760 455L761 456L760 455M884 455L885 456L884 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M917 455L918 456L917 455M1096 455L1097 456L1096 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1110 455L1111 456L1110 455z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M298 456L298 464L299 464L298 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M300 456L300 469L292 469L292 480L300 480C300 492.951 295.651 515.635 312 520.362C317.541 521.964 324.275 521 330 521L330 509C310.531 509 314 495.7 314 480L329 480L329 469L314 469L314 456L300 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M444 456L445 457L444 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M487 456L488 457L487 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M583 456L583 469L575 469L575 480C578.867 480.126 582.131 480.585 582.852 485.019C584.404 494.565 579.833 506.72 586.419 514.956C590.208 519.694 607.113 525.532 611.972 519.397C613.911 516.949 613 511.927 613 509C609.513 509 605.322 509.576 602.019 508.258C593.314 504.782 597.747 488.393 596 481L611 480L611 469C599.383 469 596 468.267 596 456L583 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M744 456L744 467L739 467L739 468L746 468L744 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M746 456L746 469L738 469L738 480L746 480C746 492.854 741.985 515.361 758 520.2C763.587 521.888 770.222 521 776 521L776 509C762.943 509 759.999 504.7 760 492C760 488.899 759.177 484.029 761.603 481.603C764.483 478.724 771.279 480 775 480L775 469L760 469L760 456L746 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M883 456L884 457L883 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1097 456L1098 457L1097 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1109 456L1110 457L1109 456z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M315.333 457.667L315.667 458.333L315.333 457.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M443 457L444 458L443 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M488 457L489 458L488 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M882 457L883 458L882 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1098 457L1099 458L1098 457z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1107 457L1108 458L1107 457M442 458L443 459L442 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M490 458L491 459L490 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M881 458L882 459L881 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1100 458L1100 459L1103 459L1100 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1103 458L1104 459L1103 458z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1104.67 458.333L1105.33 458.667L1104.67 458.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M441 459L442 460L441 459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M491 459L492 460L491 459z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M881 459L882 460L881 459M921 459L922 460L921 459M440 460L441 461L440 460z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M492 460L493 461L492 460M880 460L881 461L880 460M922 460L923 461L922 460M493 461L494 462L493 461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M923 461L924 462L923 461z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M438 462L439 463L438 462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M494 462L495 463L494 462M879 462L880 463L879 462z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M900 462L900 463L903 463L900 462M437 463L438 464L437 463M461 463L461 464L464 464L461 463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M464 463L464 464L469 464L464 463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M469.667 463.333L470.333 463.667L469.667 463.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M495 463L496 464L495 463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M879 463L880 464L879 463M896 463L897 464L896 463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M897 463L898 464L897 463M905 463L906 464L905 463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M906 463L907 464L906 463z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M315 464L315 468L316 468L315 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M436 464L437 465L436 464M458 464L459 465L458 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M459 464L460 465L459 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M460 464.532C433.074 470.947 444.223 513.892 472 507.471C499.768 501.052 488.094 457.84 460 464.532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M472 464L473 465L472 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M473.667 464.333L474.333 464.667L473.667 464.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M878.333 464.667L878.667 465.333L878.333 464.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M895 464L896 465L895 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M907 464L908 465L907 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M908 464L909 465L908 464M922 464L923 465L922 464z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M298 465L293 467L293 468C295.499 467.959 299.235 468.275 298 465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M435 465L436 466L435 465M456 465L457 466L456 465M475 465L476 466L475 465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M476 465L477 466L476 465M496 465L497 466L496 465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M582 465L574 468L574 469C577.225 468.989 583.031 469.588 582 465M894 465L895 466L894 465M909 465L910 466L909 465M921 465L922 466L921 465z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M359 466L360 467L359 466M362 466L362 467L366 467L362 466M368 466L369 467L368 466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M454 466L455 467L454 466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M477 466L478 467L477 466M497 466L498 467L497 466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M708 466L708 467L712 467L708 466M713 466L714 467L713 466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M878.333 466.667L878.667 467.333L878.333 466.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M893 466L894 467L893 466z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M910 466L911 467L910 466M920 466L921 467L920 466M136 467L137 468L136 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M137 467L137 468L146 468L137 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M146.667 467.333L147.333 467.667L146.667 467.333M213 467L214 468L213 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M214 467L214 468L218 468L214 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M218 467L219 468L218 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M320 467L320 468L323 468L320 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M359 467L359 468L363 468L359 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M363 467L363 468L366 468L363 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M366 467L366 468L370 468L366 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M434 467L435 468L434 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M453 467L454 468L453 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M479 467L480 468L479 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M539.667 467.333L540.333 467.667L539.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M541 467L541 468L546 468L541 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M546.667 467.333L547.333 467.667L546.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M686 467L686 468L690 468L686 467M691 467L691 468L694 468L691 467M703 467L704 468L703 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M706 467L706 468L709 468L706 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M709 467L709 468L712 468L709 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M712.667 467.333L713.333 467.667L712.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M804.667 467.333L805.333 467.667L804.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M806 467L806 468L815 468L806 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M815 467L816 468L815 467M893.333 467.667L893.667 468.333L893.333 467.667M911 467L912 468L911 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M918 467L919 468L918 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M960 467L961 468L960 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M961.667 467.333L962.333 467.667L961.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M963 467L963 468L968 468L963 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M968.667 467.333L969.333 467.667L968.667 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M970 467L971 468L970 467M1014.67 467.333L1015.33 467.667L1014.67 467.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1016 467L1016 468L1023 468L1016 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1023.67 467.333L1024.33 467.667L1023.67 467.333M1148 467L1149 468L1148 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1149 467L1149 468L1156 468L1149 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1156 467L1157 468L1156 467M1203 467L1204 468L1203 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1204 467L1204 468L1211 468L1204 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1211 467L1212 468L1211 467z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M30 468L30 470L32 470L32 468L30 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M132 468L133 469L132 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M133 468L134 469L133 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M134 468.529C98.8875 476.59 114.573 528.374 149 520.471C183.962 512.445 168.259 460.665 134 468.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M148 468L149 469L148 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M149 468L150 469L149 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M150 468L151 469L150 468M172 468L173 469L172 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M172 469L172 470L187 469L172 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M187 468L188 469L187 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M199 498C196.663 491.093 192.778 474.126 186.582 470.028C183.22 467.804 176.868 469 173 469L190.231 508L198.17 520.534L204.752 513.999L215 492L217 492L230 521C237.456 520.752 238.338 514.955 241.245 509C247.536 496.111 254.378 482.573 259 469C255.131 469 248.781 467.804 245.418 470.028C239.192 474.145 235.647 490.176 233 497L232 497L219 468C208.288 468.356 203.826 489.732 199 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M244 468L245 469L244 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M245 468L245 469L260 470L245 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M259 468L260 469L259 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M292 468L292 469L300 469L292 468M314 468L314 469L329 469L314 468M355 468L356 469L355 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M356 468L357 469L356 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M357 468.529C321.886 476.59 337.565 528.375 372 520.471C407.051 512.425 391.309 460.654 357 468.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M371.667 468.333L372.333 468.667L371.667 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M373 468L374 469L373 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M375 468L376 469L375 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M433 468L434 469L433 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M451 468L452 469L451 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M480 468L481 469L480 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M498 468L499 469L498 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M514 468L514 469L527 469L514 468M535 468L536 469L535 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M536 468L537 469L536 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M527 475L527 469L514 469L514 539L528 539L528 516C532.469 519.178 536.461 520.923 542 520.996C546.487 521.055 550.893 521.057 555 519C587.533 502.707 555.795 447.762 527 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M550 468L551 469L550 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M551 468L552 469L551 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M582 468L583 469L582 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M597 468L597 469L612 469L597 468M682 468L682 469L695 469L682 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M700 468L701 469L700 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M702 468L703 469L702 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M703 468L704 469L703 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M695 473L695 469L682 469L682 520L696 520C696 510.597 690.949 480.427 706 480.427C721.051 480.427 716 510.597 716 520L729 520C729 501.1 735.609 462.855 705 468.329C701.248 469 698.135 470.952 695 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M716 468L717 469L716 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M717 468L718 469L717 468M738 468L738 469L746 469L738 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M760 468L761 469L760 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M801.667 468.333L802.333 468.667L801.667 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M803 468L804 469L803 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M804 468.468C785.753 471.916 776.888 494.965 787.638 509.999C794.377 519.423 805.905 522.617 817 520.671C835.695 517.393 844.146 494.056 833.362 479.001C826.661 469.646 815.023 466.384 804 468.468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M817.667 468.333L818.333 468.667L817.667 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M819 468L820 469L819 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M878 468L878 472L879 472L878 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M912 468L913 469L912 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M917 468L918 469L917 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M957 468L958 469L957 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M958 468L959 469L958 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M972 468L973 469L972 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M973 468L974 469L973 468M1010 468L1011 469L1010 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1011 468L1012 469L1011 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1012 468L1013 469L1012 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M1028 491C1019.57 491 1007.08 489.841 1000.21 495.638C992.496 502.152 995.378 515.593 1004 519.583C1012.15 523.348 1021.96 520.597 1029 516L1029 520L1042 520C1042 506.759 1046.41 483.459 1035.79 473.34C1028.57 466.459 1015.59 466.584 1007 470.518C1003.93 471.926 998.428 474.907 998.921 479.003C999.287 482.039 1002.9 485.292 1006 484.698C1014.91 482.987 1027.09 474.394 1028 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1026 468L1027 469L1026 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1027 468L1028 469L1027 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1028 468L1029 469L1028 468M1055 468L1056 469L1055 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1055 520L1056 520L1056 469L1068 469C1064.94 467.715 1057.45 466.565 1055.6 470.318C1053.73 474.122 1055 480.845 1055 485L1055 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1068 468L1069 469L1068 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1077.67 468.333L1078.33 468.667L1077.67 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1079 468L1080 469L1079 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M1068 474L1068 469L1056 469L1056 520L1069 520C1069 503.885 1064.68 481.187 1087 481C1087 465.707 1079.82 466.893 1068 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1085.67 468.333L1086.33 468.667L1085.67 468.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1087 468L1088 469L1087 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1096 468L1096 469L1110 469L1110 520C1114.21 509.973 1111 492.896 1111 482C1111 478.672 1112.18 472.385 1109.97 469.603C1107.53 466.516 1099.51 468 1096 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1124 468L1125 469L1124 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1125 468L1125 469L1137 469L1125 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1144 468L1145 469L1144 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1145 468L1146 469L1145 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1146 468L1147 469L1146 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M1137 473L1137 469L1124 469C1126.7 483.527 1126.72 505.37 1124 520L1138 520C1138 510.438 1135.59 497.082 1138.7 488.004C1140.37 483.14 1145.67 478.856 1151 480.758C1162.72 484.945 1158 510.192 1158 520L1172 520C1172 501.119 1177.59 462.551 1147 468.468C1143.25 469.194 1140.23 471.081 1137 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1158 468L1159 469L1158 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1159 468L1160 469L1159 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1160 468L1161 469L1160 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1199 468L1200 469L1199 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1200 468L1201 469L1200 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M1224 513C1223.79 515.435 1223.52 517.76 1222.43 519.998C1212.88 539.612 1192.63 512.017 1186 532C1190.86 534.924 1195.42 537.745 1201 539.1C1204.64 539.985 1208.27 540.016 1212 539.999C1246.73 539.843 1237 492.245 1237 469L1225 469L1225 475C1221.44 471.81 1217.82 469.176 1213 468.329C1175 461.651 1173.88 522.904 1210 518.557C1215.44 517.902 1219.38 515.777 1224 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1214 468L1215 469L1214 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1215 468L1216 469L1215 468M1225 468L1225 469L1237 469L1225 468z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1237 468L1238 469L1237 468M129 469L130 470L129 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M130 469L131 470L130 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M152 469L153 470L152 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M153 469L154 470L153 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M187 469L188 470L187 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M212 469L213 470L212 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M219 469L220 470L219 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M244 469L245 470L244 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M290 469L290 480L291 480L290 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M291 469L291 480L292 480L291 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M353 469L354 470L353 469M374.667 469.333L375.333 469.667L374.667 469.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M377 469L378 470L377 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M433 469L434 470L433 469M450 469L451 470L450 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M481 469L482 470L481 469M499 469L500 470L499 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M533 469L534 470L533 469M553 469L554 470L553 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M554 469L555 470L554 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M574 469C574 476.38 573.441 480.899 582 481L582 480L575 480L574 469M611 469L611 480L597 480L597 481C605.743 481 616.056 481.05 611 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M696.333 469.667L696.667 470.333L696.333 469.667M698 469L699 470L698 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M700 469L701 470L700 469M719 469L720 470L719 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M775 469L776 470L775 469M798 469L799 470L798 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M799 469L800 470L799 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M821 469L822 470L821 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M822 469L823 470L822 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M892 469L893 470L892 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M913 469L914 470L913 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M916 469L917 470L916 469M955 469L956 470L955 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M956 469L957 470L956 469M974 469L975 470L974 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M975 469L976 470L975 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1008 469L1009 470L1008 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1009 469L1010 470L1009 469M1029 469L1030 470L1029 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1030 469L1031 470L1030 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1068 469L1068 474L1069 474L1068 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1074 469L1075 470L1074 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1075 469L1076 470L1075 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1087 469L1087 481L1088 481L1087 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M1096 469L1096 520L1110 520L1110 469L1096 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1137 469L1137 472L1138 472L1137 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1142 469L1143 470L1142 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1161 469L1162 470L1161 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1162 469L1163 470L1162 469M1196 469L1197 470L1196 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1197 469L1198 470L1197 469M1217 469L1218 470L1217 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1218 469L1219 470L1218 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1224 469L1224 474L1225 474L1224 469z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1237.33 469.667L1237.67 470.333L1237.33 469.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M127 470L128 471L127 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M128 470L129 471L128 470M154 470L155 471L154 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M155 470L156 471L155 470M188 470L189 471L188 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M219 470L220 471L219 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M243 470L244 471L243 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M258 470L259 471L258 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M350 470L351 471L350 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M351 470L352 471L351 470M377 470L378 471L377 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M432 470L433 471L432 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M449 470L450 471L449 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M482 470L483 471L482 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M499 470L500 471L499 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M531 470L532 471L531 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M555 470L556 471L555 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M698 470L699 471L698 470M721 470L722 471L721 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M796 470L797 471L796 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M797 470L798 471L797 470M823 470L824 471L823 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M824 470L825 471L824 470M893.333 470.667L893.667 471.333L893.333 470.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M914 470L915 471L914 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M915 470L916 471L915 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M954 470L955 471L954 470M976 470L977 471L976 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1006 470L1007 471L1006 470M1032 470L1033 471L1032 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1073 470L1074 471L1073 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1140 470L1141 471L1140 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1163 470L1164 471L1163 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1194 470L1195 471L1194 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1195 470L1196 471L1195 470M1219 470L1220 471L1219 470z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M126 471L127 472L126 471M156 471L157 472L156 471M173 471L174 472L173 471M188 471L189 472L188 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M211 471L212 472L211 471M220 471L221 472L220 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M243 471L244 472L243 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M258 471L259 472L258 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M349 471L350 472L349 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M379 471L380 472L379 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M432 471L433 472L432 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M483 471L484 472L483 471M500 471L501 472L500 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M530 471L531 472L530 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M557 471L558 472L557 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M697 471L698 472L697 471M722 471L723 472L722 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M736 471L736 480L737 480L736 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M795 471L796 472L795 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M825 471L826 472L825 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M952 471L953 472L952 471M978 471L979 472L978 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1004 471L1005 472L1004 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1033 471L1034 472L1033 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1071 471L1072 472L1071 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1124 471L1124 481L1125 481L1124 471M1139 471L1140 472L1139 471M1164 471L1165 472L1164 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1193 471L1194 472L1193 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1221 471L1222 472L1221 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1237 471L1237 514L1238 514C1238 501.781 1241.71 482.225 1237 471z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M124 472L125 473L124 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M157 472L158 473L157 472M211 472L212 473L211 472M220 472L221 473L220 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M346 472L347 473L346 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M380 472L381 473L380 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M382 472L385 475L382 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M431 472L432 473L431 472M448 472L449 473L448 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M484 472L485 473L484 472M500 472L501 473L500 472M529 472L530 473L529 472M558 472L559 473L558 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M695 472L696 473L695 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M794 472L795 473L794 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M827 472L828 473L827 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M878 472L879 473L878 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M893 472L894 473L893 472M951 472L952 473L951 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M979 472L980 473L979 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1003 472L1004 473L1003 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1035 472L1036 473L1035 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1070 472L1071 473L1070 472M1137 472L1138 473L1137 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1138 472L1139 473L1138 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1166 472L1167 473L1166 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1192 472L1193 473L1192 472z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1222 472L1223 473L1222 472M123 473L124 474L123 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M159 473L160 474L159 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M174 473L175 474L174 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M189 473L190 474L189 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M210 473L211 474L210 473M221 473L222 474L221 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M242 473L243 474L242 473M257 473L258 474L257 473M346 473L347 474L346 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M382 473L383 474L382 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M431 473L432 474L431 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M447 473L448 474L447 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M528 473L529 474L528 473M724 473L725 474L724 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M792 473L793 474L792 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M828 473L829 474L828 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M878 473L879 474L878 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M894 473L895 474L894 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M980 473L981 474L980 473M1001 473L1002 474L1001 473M1036 473L1037 474L1036 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1069 473L1070 474L1069 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1190 473L1191 474L1190 473M1223 473L1224 474L1223 473z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M122 474L123 475L122 474M160 474L161 475L160 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M174 474L175 475L174 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M189 474L190 475L189 474M210 474L211 475L210 474M221 474L222 475L221 474M242 474L243 475L242 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M257 474L258 475L257 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M345 474L346 475L345 474M383 474L384 475L383 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M446 474L447 475L446 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M485 474L486 475L485 474M501 474L502 475L501 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M527 474L528 475L527 474M725 474L726 475L725 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M791 474L792 475L791 474M829 474L830 475L829 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M895 474L896 475L895 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1000 474L1001 475L1000 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1037 474L1038 475L1037 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1167 474L1168 475L1167 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1189 474L1190 475L1189 474z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1224 474L1225 475L1224 474M121 475L122 476L121 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M161 475L162 476L161 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M175 475L176 476L175 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M190 475L191 476L190 475M209 475L210 476L209 475M222 475L223 476L222 475M241 475L242 476L241 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M256 475L257 476L256 475M344 475L345 476L344 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M384 475L385 476L384 475M430.333 475.667L430.667 476.333L430.333 475.667M446 475L447 476L446 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M501 475L502 476L501 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M726 475L727 476L726 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M727 475L728 476L727 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M790 475L791 476L790 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M830 475L831 476L830 475M879 475L880 476L879 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M897 475L898 476L897 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M981 475L982 476L981 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M999 475L1000 476L999 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1168 475L1169 476L1168 475z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M120 476L121 477L120 476M162 476L163 477L162 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M175 476L176 477L175 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M190 476L191 477L190 476M209 476L210 477L209 476M222 476L223 477L222 476M241 476L242 477L241 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M256 476L257 477L256 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M343 476L344 477L343 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M385 476L387 478L385 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M386 476L387 477L386 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M486 476L487 477L486 476M562 476L563 477L562 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M789 476L790 477L789 476M831 476L832 477L831 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M879 476L880 477L879 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M899 476L900 477L899 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M982 476L983 477L982 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M998 476L999 477L998 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1038 476L1039 477L1038 476z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1169 476L1170 477L1169 476M58 477L58 478L88 478L58 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M119 477L120 478L119 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M163 477L164 478L163 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M176 477L177 478L176 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M223 477L224 478L223 477M240 477L241 478L240 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M255 477L256 478L255 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M342 477L343 478L342 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M387 477L388 478L387 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M430 477L431 478L430 477M445 477L446 478L445 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M502.333 477.667L502.667 478.333L502.333 477.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M563 477L564 478L563 477M727 477L728 478L727 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M788 477L789 478L788 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M832 477L833 478L832 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M880 477L881 478L880 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M901 477L902 478L901 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M982 477L983 478L982 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M997 477L998 478L997 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1039 477L1040 478L1039 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1169 477L1170 478L1169 477M1187 477L1188 478L1187 477z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M118 478L119 479L118 478M164 478L165 479L164 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M176 478L177 479L176 478M191 478L192 479L191 478M208 478L209 479L208 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M223 478L224 479L223 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M240 478L241 479L240 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M255 478L256 479L255 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M341 478L342 479L341 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M487.333 478.667L487.667 479.333L487.333 478.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M564 478L565 479L564 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M833 478L834 479L833 478M880 478L881 479L880 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M903 478L904 479L903 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M904 478L905 479L904 478M983 478L984 479L983 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M997 478L998 479L997 478M1039 478L1040 479L1039 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1170 478L1171 479L1170 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1186 478L1187 479L1186 478z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M164 479L165 480L164 479M191 479L192 480L191 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M224 479L225 480L224 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M254 479L255 480L254 479M502.333 479.667L502.667 480.333L502.333 479.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M728 479L729 480L728 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M786 479L787 480L786 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M787 479L788 480L787 479M881 479L882 480L881 479M905 479L906 480L905 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M906 479L907 480L906 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M983 479L984 480L983 479M1017.67 479.333L1018.33 479.667L1017.67 479.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1040 479L1041 480L1040 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1170 479L1171 480L1170 479M1208 479L1208 480L1213 480L1208 479z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M32 480L32 485L33 485L32 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M117 480L118 481L117 480M138.667 480.333L139.333 480.667L138.667 480.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M140.667 480.333L141.333 480.667L140.667 480.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M142.667 480.333L143.333 480.667L142.667 480.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M165 480L166 481L165 480M177 480L178 481L177 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M192 480L193 481L192 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M207 480L208 481L207 480M224 480L225 481L224 480M239 480L240 481L239 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M254 480L255 481L254 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M292 480L292 481L300 481L292 480M314 480L314 481L329 481L314 480M340 480L341 481L340 480M361 480L361 481L367 481L361 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M388 480L389 481L388 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M389 480L390 483L391 483L389 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M429 480L429 483L430 483L429 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M444.333 480.667L444.667 481.333L444.333 480.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M487 480L488 481L487 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M537 480L537 481L541 481L537 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M541 480L542 481L541 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M542.667 480.333L543.333 480.667L542.667 480.333M565 480L566 481L565 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M574 480L575 481L574 480M611 480L612 481L611 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M703 480L704 481L703 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M704 480L704 481L708 481L704 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M708 480L709 481L708 480M728 480L729 481L728 480M738 480L738 481L746 481L738 480M761 480L761 481L775 481L761 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M786 480L787 481L786 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M808 480L809 481L808 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M809 480L809 481L812 481L809 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M812.667 480.333L813.333 480.667L812.667 480.333M834 480L835 481L834 480M907 480L908 481L907 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M908 480L909 481L908 480M958.667 480.333L959.333 480.667L958.667 480.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M960.667 480.333L961.333 480.667L960.667 480.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M962.667 480.333L963.333 480.667L962.667 480.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M964 480L965 481L964 480M1013 480L1014 481L1013 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1014 480L1015 481L1014 480M1021 480L1022 481L1021 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1022 480L1023 481L1022 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1040 480L1041 481L1040 480M1145 480L1146 481L1145 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1146 480L1146 481L1151 481L1146 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1151 480L1152 481L1151 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1185 480L1186 481L1185 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1204 480L1205 481L1204 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1205 480L1206 481L1205 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1206 480.653C1190.61 485.519 1198.72 511.401 1215 505.721C1230.26 500.395 1222.28 475.505 1206 480.653z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1214 480L1215 481L1214 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1215 480L1216 481L1215 480z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M116 481L117 482L116 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M135 481L136 482L135 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M136 481L137 482L136 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M137 481L138 482L137 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M138.001 481.534C121.88 485.393 128.137 511.546 144.985 507.606C160.743 503.92 154.438 477.599 138.001 481.534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M145 481L146 482L145 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M146 481L147 482L146 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M192 481L193 482L192 481M239 481L240 482L239 481M253 481L254 482L253 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M293 481L294 482L293 481M295 481L295 482L298 482L298 486L299 486L299 481L295 481M315.667 481.333L316.333 481.667L315.667 481.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M358 481L359 482L358 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M359 481L360 482L359 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M369 483C365.453 478.941 357.733 481.443 354.653 485.214C350.344 490.488 350.53 499.751 355.394 504.606C371.25 520.429 387.461 486.181 369 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M369 481L370 482L369 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M389 481L390 482L389 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M535 481L536 482L535 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M536.004 481.742C520.971 487.565 529.754 513.547 545.996 507.258C561.49 501.259 552.16 475.484 536.004 481.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M546 481L547 482L546 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M582 481L583 482L582 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M596 481L597 482L596 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M701 481L702 482L701 481M710 481L711 482L710 481M760 481L760 504L761 504L760 481M805 481L806 482L805 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M806 481L807 482L806 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M807 481.573C790.872 486.13 798.033 512.732 814.996 507.347C829.829 502.639 822.989 477.056 807 481.573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M814 481L815 482L814 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M815 481L816 482L815 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M816 481L817 482L816 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M835 481L836 482L835 481M882 481L883 482L882 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M910 481L911 482L910 481M956 481L957 482L956 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M965 481L966 482L965 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M966 481L967 482L966 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M984 481L985 482L984 481M999 481L1000 482L999 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1011 481L1012 482L1011 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1024 481L1025 482L1024 481M1079 481L1080 482L1079 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1080.67 481.333L1081.33 481.667L1080.67 481.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1082 481L1082 482L1087 482L1082 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1143 481L1144 482L1143 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1152 481L1153 482L1152 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1153 481L1154 482L1153 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1171 481L1172 482L1171 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1203 481L1204 482L1203 481M1217 481L1218 482L1217 481z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M116 482L117 483L116 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M134 482L135 483L134 482M148 482L149 483L148 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M166 482L167 483L166 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M178 482L179 483L178 482M206 482L207 483L206 482M225 482L226 483L225 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M238 482L239 483L238 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M253 482L254 483L253 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M339 482L340 483L339 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M357 482L358 483L357 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M369 482L370 483L369 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M371 482L372 483L371 482M389 482L390 483L389 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M444 482L444 487L445 487L444 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M533 482L534 483L533 482M548 482L549 483L548 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M566 482L567 483L566 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M582 482L583 483L582 482M699 482L700 483L699 482M712 482L713 483L712 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M729.333 482.667L729.667 483.333L729.333 482.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M745.333 482.667L745.667 483.333L745.333 482.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M785 482L786 483L785 482M803 482L804 483L803 482M817 482L818 483L817 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M835 482L836 483L835 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M883 482L884 483L883 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M912 482L913 483L912 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M954 482L955 483L954 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M967 482L968 483L967 482M984 482L985 483L984 482M1000 482L1001 483L1000 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1009 482L1010 483L1009 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1025 482L1026 483L1025 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1041 482L1042 483L1041 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1076 482L1077 483L1076 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1077 482L1078 483L1077 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1141 482L1142 483L1141 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1154 482L1155 483L1154 482M1171 482L1172 483L1171 482M1184 482L1185 483L1184 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1201 482L1202 483L1201 482M1219 482L1220 483L1219 482z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M115 483L116 484L115 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M132 483L133 484L132 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M149 483L150 484L149 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M167 483L168 484L167 483M178 483L179 484L178 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M193 483L194 484L193 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M238 483L239 484L238 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M372 483L373 484L372 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M428 483L428 491L429 491L428 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M429 483L429 489L430 489L429 483M488 483L488 489L489 489L488 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M532 483L533 484L532 483M549 483L550 484L549 483M582 483L582 489L583 489L582 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M596.333 483.667L596.667 484.333L596.333 483.667M698 483L699 484L698 483M713 483L714 484L713 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M802 483L803 484L802 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M818 483L819 484L818 483M836 483L837 484L836 483M884 483L885 484L884 483M914 483L915 484L914 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M953 483L954 484L953 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M968 483L969 484L968 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M984 483L984 486L985 486L984 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1001 483L1002 484L1001 483M1008 483L1009 484L1008 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1026 483L1027 484L1026 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1041.33 483.667L1041.67 484.333L1041.33 483.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1074 483L1075 484L1074 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1075 483L1076 484L1075 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1155 483L1156 484L1155 483z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1171 483L1171 486L1172 486L1171 483M1184 483L1185 484L1184 483M1200 483L1201 484L1200 483M1220 483L1221 484L1220 483M115 484L116 485L115 484M131 484L132 485L131 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M150 484L151 485L150 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M167 484L168 485L167 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M179 484L180 485L179 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M205 484L206 485L205 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M226 484L227 485L226 484M252 484L253 485L252 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M338 484L339 485L338 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M373 484L374 485L373 484M390 484L391 485L390 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M391 484L392 485L391 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M531 484L532 485L531 484M550 484L551 485L550 484M567 484L568 485L567 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M729 484L729 520L716 520L716 487L715 487C715 494.196 711.532 513.72 716.028 519.397C718.514 522.535 728.461 521.964 729.682 517.852C731.911 510.344 731.994 491.136 729 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M784 484L785 485L784 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M801 484L802 485L801 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M836 484L837 485L836 484M886 484L887 485L886 484M915 484L916 485L915 484M969 484L970 485L969 484M1002 484L1003 485L1002 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1007 484L1008 485L1007 484M1026 484L1027 485L1026 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1073 484L1074 485L1073 484M1156 484L1157 485L1156 484M1199 484L1200 485L1199 484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M151 485L152 486L151 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M179 485L180 486L179 485M194 485L195 486L194 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M205 485L206 486L205 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M237 485L238 486L237 485M374 485L375 486L374 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M530 485L531 486L530 485M551 485L552 486L551 485M567 485L568 486L567 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M697 485L698 486L697 485M714 485L715 486L714 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M742 485L743 486L742 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M784 485L785 486L784 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M800 485L801 486L800 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M820 485L821 486L820 485M837 485L838 486L837 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M887 485L888 486L887 485M917 485L918 486L917 485M952 485L953 486L952 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M969 485L970 486L969 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1003 485L1004 486L1003 485M1027 485L1028 486L1027 485M1041 485L1042 486L1041 485M1072 485L1073 486L1072 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1139 485L1140 486L1139 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1156 485L1157 486L1156 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1183 485L1184 486L1183 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1199 485L1200 486L1199 485M1221 485L1222 486L1221 485z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M114 486L115 487L114 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M130 486L131 487L130 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M152 486L153 487L152 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M168 486L169 487L168 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M180 486L181 487L180 486M194 486L195 487L194 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M204 486L205 487L204 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M227 486L228 487L227 486M251 486L252 487L251 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M336 486L337 487L336 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M337 486L338 487L337 486M353 486L354 487L353 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M375 486L376 487L375 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M391 486L392 487L391 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M552 486L553 487L552 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M740.333 486.667L740.667 487.333L740.333 486.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M745 486L746 487L745 486M783 486L784 487L783 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M799 486L800 487L799 486M821 486L822 487L821 486M837 486L838 487L837 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M888 486L889 487L888 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M889 486L890 487L889 486M918 486L919 487L918 486M970 486L971 487L970 486M1004 486L1005 487L1004 486z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1027.33 486.667L1027.67 487.333L1027.33 486.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1071 486L1072 487L1071 486M1157 486L1158 487L1157 486M1183.33 486.667L1183.67 487.333L1183.33 486.667M1198 486L1199 487L1198 486M1222 486L1223 487L1222 486M114 487L115 488L114 487M129 487L130 488L129 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M168 487L169 488L168 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M180 487L181 488L180 487M195 487L196 488L195 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M204 487L205 488L204 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M236 487L237 488L236 487M251 487L252 488L251 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M337 487L338 488L337 487M352 487L353 488L352 487M391 487L392 488L391 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M529 487L530 488L529 487M552 487L553 488L552 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M696 487L697 488L696 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M783 487L784 488L783 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M822 487L823 488L822 487M837 487L838 488L837 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M890 487L891 488L890 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M919 487L920 488L919 487M951 487L952 488L951 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M970 487L971 488L970 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1071 487L1072 488L1071 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1138 487L1139 488L1138 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1157 487L1158 488L1157 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1198 487L1199 488L1198 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1222 487L1223 488L1222 487z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M32.3333 488.667L32.6667 489.333L32.3333 488.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M129 488L130 489L129 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M153 488L154 489L153 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M168 488L169 489L168 488M181 488L182 489L181 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M195 488L196 489L195 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M203 488L204 489L203 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M228 488L229 489L228 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M236 488L237 489L236 488M250 488L251 489L250 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M352 488L353 489L352 488M376 488L377 489L376 488M444.333 488.667L444.667 489.333L444.333 488.667M568.333 488.667L568.667 489.333L568.333 488.667M696 488L696 520L697 520L696 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M783.333 488.667L783.667 489.333L783.333 488.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M798 488L799 489L798 488M822 488L823 489L822 488M892 488L893 489L892 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M920 488L921 489L920 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M951 488L951 520L937 520L937 521L950.397 519.972L952 512L951 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M970 488L970 520L971 520L970 488M1027.33 488.667L1027.67 489.333L1027.33 488.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1070 488L1071 489L1070 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1138 488L1138 521L1139 521L1138 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1157 488L1157 520L1158 520L1157 488z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1197 488L1198 489L1197 488M128.333 489.667L128.667 490.333L128.333 489.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M153 489L154 490L153 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M181 489L182 490L181 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M203 489L204 490L203 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M250 489L251 490L250 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M429 489L429 492L430 492L429 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M528 489L529 490L528 489M553 489L554 490L553 489M582 489L582 504L583 504L582 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M798 489L799 490L798 489M838.333 489.667L838.667 490.333L838.333 489.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M894 489L895 490L894 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M921 489L922 490L921 489z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1070 489L1071 490L1070 489M1197.33 489.667L1197.67 490.333L1197.33 489.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1223.33 489.667L1223.67 490.333L1223.33 489.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M113 490L114 491L113 490M169 490L169 498L170 498L169 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M196 490L197 491L196 490M229 490L230 491L229 490M235 490L236 491L235 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M249 490L250 491L249 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M336 490L336 499L337 499L336 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M351 490L352 491L351 490M377.333 490.667L377.667 491.333L377.333 490.667M444.333 490.667L444.667 491.333L444.333 490.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M528 490L528 493L529 493L528 490M553 490L554 491L553 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M568.333 490.667L568.667 491.333L568.333 490.667M797 490L798 491L797 490M823 490L824 491L823 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M896 490L897 491L896 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M897 490L898 491L897 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M922 490L923 491L922 490M1027 490L1028 491L1027 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1070 490L1071 491L1070 490M1182 490L1182 496L1183 496L1182 490z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M113 491L113 498L114 498L113 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M128 491L128 494L129 494L128 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M154 491L155 492L154 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M182 491L183 492L182 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M196 491L197 492L196 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M202 491L203 492L202 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M229 491L230 492L229 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M249 491L250 492L249 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M351 491L351 494L352 494L351 491M392 491L392 498L393 498L392 491M487 491L488 492L487 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M502.333 491.667L502.667 492.333L502.333 491.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M782 491L782 498L783 498L782 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M797 491L797 494L798 494L797 491M823 491L824 492L823 491M838 491L838 494L839 494L838 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M898 491L899 492L898 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M899 491L900 492L899 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M923 491L924 492L923 491M1008 491L1009 492L1008 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1009 491L1010 492L1009 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1010 491L1010 492L1015 492L1010 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1197 491L1197 496L1198 496L1197 491z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1223 491L1223 495L1224 495L1223 491M154 492L155 493L154 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M197 492L198 493L197 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M215.667 492.333L216.333 492.667L215.667 492.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M230 492L231 493L230 492M234 492L235 493L234 492M377 492L377 497L378 497L377 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M487.333 492.667L487.667 493.333L487.333 492.667M554 492L554 497L555 497L554 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M823 492L823 497L824 497L823 492M900 492L901 493L900 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M901 492L902 493L901 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1004 492L1005 493L1004 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1005 492L1006 493L1005 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1069 492L1069 520L1056 520L1056 521C1059.36 521 1065.61 522.179 1068.4 519.972C1072.45 516.763 1070.85 496.405 1069 492z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M154 493L154 496L155 496L154 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M183 493L184 494L183 493M197 493L198 494L197 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M201 493L202 494L201 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M230 493L231 494L230 493M234 493L235 494L234 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M248 493L249 494L248 493M445 493L446 494L445 493M502.333 493.667L502.667 494.333L502.333 493.667M903 493L904 494L903 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M924 493L925 494L924 493M1002 493L1003 494L1002 493z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1003 493L1004 494L1003 493M214 494L215 495L214 494M217 494L218 495L217 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M231 494L232 495L231 494M233 494L234 495L233 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M430.333 494.667L430.667 495.333L430.333 494.667M445 494L446 495L445 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M486 494L487 495L486 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M797 494L798 495L797 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M838 494L839 495L838 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M905 494L906 495L905 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M924 494L925 495L924 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1001 494L1002 495L1001 494z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M184 495L185 496L184 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M198 495L199 496L198 495M200 495L201 496L200 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M214 495L215 496L214 495M217 495L218 496L217 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M231 495L232 496L231 495M233 495L234 496L233 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M247 495L248 496L247 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M486 495L487 496L486 495M568 495L568 500L569 500L568 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M797 495L797 498L798 498L797 495M838 495L838 498L839 498L838 495M907 495L908 496L907 495z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1223.33 495.667L1223.67 496.333L1223.33 495.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M128.333 496.667L128.667 497.333L128.333 496.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M154.333 496.667L154.667 497.333L154.333 496.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M184 496L185 497L184 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M198 496L199 497L198 496M213 496L214 497L213 496M218 496L219 497L218 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M232 496L233 497L232 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M247 496L248 497L247 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M351.333 496.667L351.667 497.333L351.333 496.667M430 496L431 497L430 496M446 496L447 497L446 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M501 496L502 497L501 496M596 496L597 497L596 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M908 496L909 497L908 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M925.333 496.667L925.667 497.333L925.333 496.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1124 496L1124 518L1125 518L1124 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1197 496L1198 497L1197 496z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M185 497L186 498L185 497M199 497L200 498L199 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M213 497L214 498L213 497M218 497L219 498L218 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M246 497L247 498L246 497M377.333 497.667L377.667 498.333L377.333 497.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M408 497L408 504L410 504L408 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M485 497L486 498L485 497M501 497L502 498L501 497M528.333 497.667L528.667 498.333L528.333 497.667M823.333 497.667L823.667 498.333L823.333 497.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M909 497L910 498L909 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1197 497L1198 498L1197 497z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M113 498L114 499L113 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M128 498L129 499L128 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M154 498L155 499L154 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M185 498L186 499L185 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M212 498L213 499L212 498M219 498L220 499L219 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M246 498L247 499L246 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M351.333 498.667L351.667 499.333L351.333 498.667M431 498L432 499L431 498M447 498L448 499L447 498M797 498L798 499L797 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M838.333 498.667L838.667 499.333L838.333 498.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M910 498L911 499L910 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M925 498L925 504L926 504L925 498M997 498L998 499L997 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1222 498L1223 499L1222 498z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M128 499L129 500L128 499M186 499L187 500L186 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M212 499L213 500L212 499M219 499L220 500L219 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M245 499L246 500L245 499M484 499L485 500L484 499M500 499L501 500L500 499M528 499L529 500L528 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M553 499L554 500L553 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M730 499L730 504L731 504L730 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M823 499L824 500L823 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M883 499L884 500L883 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M884 499L885 500L884 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M996 499L997 500L996 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1183 499L1184 500L1183 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1198 499L1199 500L1198 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1222 499L1223 500L1222 499z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M129 500L130 501L129 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M153 500L154 501L153 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M168 500L169 501L168 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M186 500L187 501L186 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M211 500L212 501L211 500M220 500L221 501L220 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M245 500L246 501L245 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M352 500L353 501L352 500M376 500L377 501L376 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M391.333 500.667L391.667 501.333L391.333 500.667M432 500L433 501L432 500M483 500L484 501L483 500M553 500L554 501L553 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M568.333 500.667L568.667 501.333L568.333 500.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M783 500L784 501L783 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M798 500L799 501L798 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M822 500L823 501L822 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M882 500L883 501L882 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M885 500L886 501L885 500M911 500L911 503L912 503L911 500M996 500L997 501L996 500M1014 500L1014 501L1028 501L1014 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1183 500L1184 501L1183 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1221 500L1222 501L1221 500z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M114 501L115 502L114 501M129 501L130 502L129 501M153 501L154 502L153 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M168 501L169 502L168 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M187 501L188 502L187 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M211 501L212 502L211 501M220 501L221 502L220 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M244 501L245 502L244 501M337 501L338 502L337 501M352 501L353 502L352 501M449 501L450 502L449 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M482 501L483 502L482 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M499 501L500 502L499 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M529 501L530 502L529 501M552 501L553 502L552 501M783 501L784 502L783 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M798 501L799 502L798 501M822 501L823 502L822 501M837 501L838 502L837 501M881 501L882 502L881 501M886 501L887 502L886 501M1011 501L1010 503L1011 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1012 501L1013 502L1012 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1027 501L1019 501.004C999.198 501.281 1024.66 521.956 1027 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1027 501L1028 502L1027 501M1183 501L1184 502L1183 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1199 501L1200 502L1199 501M1221 501L1222 502L1221 501z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M114 502L115 503L114 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M130 502L131 503L130 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M152 502L153 503L152 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M168 502L169 503L168 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M187 502L188 503L187 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M210 502L211 503L210 502M221 502L222 503L221 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M244 502L245 503L244 502M314.333 502.667L314.667 503.333L314.333 502.667M337 502L338 503L337 502M353 502L354 503L353 502M375 502L376 503L375 502M391 502L392 503L391 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M432 502L433 503L432 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M433 502L434 503L433 502M450 502L451 503L450 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M481 502L482 503L481 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M552 502L553 503L552 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M783 502L784 503L783 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M799 502L800 503L799 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M821 502L822 503L821 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M837 502L838 503L837 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M879 502L880 503L879 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M880 502L881 503L880 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M887 502L888 503L887 502M995 502L996 503L995 502M1027.33 502.667L1027.67 503.333L1027.33 502.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1184 502L1185 503L1184 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1200 502L1201 503L1200 502z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1220 502L1221 503L1220 502M130 503L131 504L130 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M151 503L152 504L151 503M210 503L211 504L210 503M221 503L222 504L221 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M374 503L375 504L374 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M451 503L452 504L451 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M480 503L481 504L480 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M498 503L499 504L498 503M530 503L531 504L530 503M551 503L552 504L551 503M567 503L568 504L567 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M800 503L801 504L800 503M837 503L838 504L837 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M878 503L879 504L878 503M888 503L889 504L888 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M995 503L995 509L996 509L995 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1184 503L1185 504L1184 503M1201 503L1202 504L1201 503M1219 503L1220 504L1219 503z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M115 504L116 505L115 504M131 504L132 505L131 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M150 504L151 505L150 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M167 504L168 505L167 504M188 504L189 505L188 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M209 504L210 505L209 504M222 504L223 505L222 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M243 504L244 505L243 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M314 504L315 505L314 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M315 504L316 505L315 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M338 504L339 505L338 504M354 504L355 505L354 504M390 504L391 505L390 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M391 504L392 505L391 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M434 504L435 505L434 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M453 504L454 505L453 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M479 504L480 505L479 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M531 504L532 505L531 504M550 504L551 505L550 504M567 504L568 505L567 504M582 504L582 507L583 507L582 504M597 504L598 505L597 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M760 504L761 505L760 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M784 504L785 505L784 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M820 504L821 505L820 504M836 504L837 505L836 504M877 504L878 505L877 504M889 504L890 505L889 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M910 504L911 505L910 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M925.333 504.667L925.667 505.333L925.333 504.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1009 504L1010 505L1009 504M1027 504L1028 505L1027 504M1202 504L1203 505L1202 504M1218 504L1219 505L1218 504z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M115 505L116 506L115 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M132 505L133 506L132 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M209 505L210 506L209 505M222 505L223 506L222 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M338 505L339 506L338 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M355 505L356 506L355 505M454 505L455 506L454 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M477 505L478 506L477 505M497 505L498 506L497 505M532 505L533 506L532 505M549 505L550 506L549 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M597 505L598 506L597 505M746.333 505.667L746.667 506.333L746.333 505.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M761 505L762 506L761 505M802 505L803 506L802 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M819 505L820 506L819 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M836 505L837 506L836 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M875 505L876 506L875 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M890 505L891 506L890 505M910 505L911 506L910 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1009 505L1010 506L1009 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1026 505L1027 506L1026 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1185 505L1186 506L1185 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1204 505L1205 506L1204 505M1216 505L1217 506L1216 505z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M134 506L135 507L134 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M148 506L149 507L148 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M166 506L167 507L166 506M189 506L190 507L189 506M208 506L209 507L208 506M223 506L224 507L223 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M242 506L243 507L242 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M315 506L316 507L315 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M357 506L358 507L357 506M371 506L372 507L371 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M389 506L390 507L389 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M435 506L436 507L435 506M456 506L457 507L456 506M475 506L476 507L475 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M476 506L477 507L476 506M496 506L497 507L496 506M533 506L534 507L533 506M548 506L549 507L548 506M566 506L567 507L566 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M598 506L599 507L598 506M785 506L786 507L785 506M803 506L804 507L803 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M817 506L818 507L817 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M892 506L893 507L892 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M909 506L910 507L909 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M925 506L926 507L925 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1009.33 506.667L1009.67 507.333L1009.33 506.667M1026 506L1027 507L1026 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1185 506L1186 507L1185 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1206 506L1207 507L1206 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1207 506L1208 507L1207 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1208.67 506.333L1209.33 506.667L1208.67 506.333M1212 506L1213 507L1212 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1213 506L1214 507L1213 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1214 506L1215 507L1214 506z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M116 507L117 508L116 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M135 507L136 508L135 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M136 507L137 508L136 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M146 507L147 508L146 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M147 507L148 508L147 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M189 507L190 508L189 507M208 507L209 508L208 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M223 507L224 508L223 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M300.333 507.667L300.667 508.333L300.333 507.667M316 507L317 508L316 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M339 507L340 508L339 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M358 507L359 508L358 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M359 507L360 508L359 507M369 507L370 508L369 507M436 507L437 508L436 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M458 507L459 508L458 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M459 507L460 508L459 507M472 507L473 508L472 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M473 507L474 508L473 507M495 507L496 508L495 507M534 507L535 508L534 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M535 507L536 508L535 507M546 507L547 508L546 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M547 507L548 508L547 507M599 507L600 508L599 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M730 507L730 521L719 521L719 522C729.562 522.087 735.029 518.958 730 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M746 507L747 508L746 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M763 507L764 508L763 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M804 507L805 508L804 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M805 507L806 508L805 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M815 507L816 508L815 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M816 507L817 508L816 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M835 507L836 508L835 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M875 507L876 508L875 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M894 507L895 508L894 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M908 507L909 508L908 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1025 507L1026 508L1025 507z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1186 507L1187 508L1186 507M117 508L118 509L117 508M138 508L139 509L138 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M139 508L139 509L144 509L139 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M144 508L145 509L144 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M165 508L166 509L165 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M190 508L191 509L190 508M207 508L208 509L207 508M224 508L225 509L224 508M241 508L242 509L241 508M318 508L319 509L318 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M319.667 508.333L320.333 508.667L319.667 508.333M327 508L327 509L330 509L327 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M340 508L341 509L340 508M361.667 508.333L362.333 508.667L361.667 508.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M363 508L363 509L366 509L363 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M366.667 508.333L367.333 508.667L366.667 508.333M388 508L389 509L388 508M437 508L438 509L437 508M462 508L462 509L465 509L462 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M465 508L465 509L468 509L465 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M468 508L468 509L471 509L468 508M537 508L538 509L537 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M538 508L538 509L544 509L538 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M544 508L545 509L544 508M565 508L566 509L565 508M601 508L602 509L601 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M602.667 508.333L603.333 508.667L602.667 508.333M608 508L608 509L613 509L608 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M746.333 508.667L746.667 509.333L746.333 508.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M764 508L765 509L764 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M765 508L766 509L765 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M766.667 508.333L767.333 508.667L766.667 508.333M773.667 508.333L774.333 508.667L773.667 508.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M775 508L777 510L775 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M776 508L777 509L776 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M786 508L787 509L786 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M807 508L808 509L807 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M808 508L808 509L813 509L808 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M813 508L814 509L813 508M834 508L835 509L834 508M896 508L897 509L896 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M897 508L898 509L897 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M898 508L899 509L898 508M904.667 508.333L905.333 508.667L904.667 508.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M906 508L907 509L906 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M924 508L925 509L924 508M1010 508L1011 509L1010 508M1024 508L1025 509L1024 508z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M164 509L165 510L164 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M190 509L191 510L190 509M207 509L208 510L207 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M224 509L225 510L224 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M241 509L242 510L241 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M299 509L300 510L299 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M300 509L301 510L300 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M330 509L331 510L330 509M438 509L439 510L438 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M494 509L495 510L494 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M583 509L584 510L583 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M613 509L613 520L614 520L613 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M876 509L877 510L876 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M901 509L902 510L901 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M995.333 509.667L995.667 510.333L995.333 509.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1011 509L1012 510L1011 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1023 509L1024 510L1023 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1187 509L1188 510L1187 509z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M118 510L119 511L118 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M191 510L192 511L191 510M206 510L207 511L206 510M225 510L226 511L225 510M240 510L241 511L240 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M266 510L267 511L266 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M330 510L330 521L331 521L330 510M341 510L342 511L341 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M416 510L416 511L419 512L416 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M439 510L440 511L439 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M493 510L494 511L493 510M564 510L565 511L564 510M583 510L584 511L583 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M747 510L748 511L747 510M776 510L776 520L777 520L776 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M787 510L788 511L787 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M833 510L834 511L833 510M877 510L878 511L877 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M923 510L924 511L923 510M1012 510L1013 511L1012 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1013 510L1014 511L1013 510M1020 510L1021 511L1020 510z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1021 510L1022 511L1021 510M1188 510L1189 511L1188 510M119 511L120 512L119 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M163 511L164 512L163 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M191 511L192 512L191 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M206 511L207 512L206 511M225 511L226 512L225 511M240 511L241 512L240 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M300.333 511.667L300.667 512.333L300.333 511.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M301 511L302 512L301 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M341 511L342 512L341 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M342 511L343 512L342 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M386 511L387 512L386 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M387 511L388 512L387 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M440 511L441 512L440 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M492 511L493 512L492 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M563 511L564 512L563 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M747 511L748 512L747 511M788 511L789 512L788 511M832 511L833 512L832 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M878 511L879 512L878 511M1015 511L1015 512L1019 512L1015 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1189 511L1190 512L1189 511z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M120 512L121 513L120 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M162 512L163 513L162 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M205 512L206 513L205 512M226 512L227 513L226 512M239 512L240 513L239 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M331 512L331 520L332 520L331 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M343 512L344 513L343 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M385 512L386 513L385 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M441 512L442 513L441 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M491 512L492 513L491 512M584 512L585 513L584 512M789 512L790 513L789 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M831 512L832 513L831 512M879 512L880 513L879 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M922 512L923 513L922 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M996 512L997 513L996 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1190 512L1191 513L1190 512z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M121 513L122 514L121 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M161 513L162 514L161 513M192 513L193 514L192 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M205 513L206 514L205 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M226 513L227 514L226 513M239 513L240 514L239 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M301 513L302 514L301 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M302 513L303 514L302 513M344 513L345 514L344 513M384 513L385 514L384 513M442 513L443 514L442 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M490 513L491 514L490 513M562 513L563 514L562 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M748 513L749 514L748 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M790 513L791 514L790 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M830 513L831 514L830 513M880 513L881 514L880 513M921 513L922 514L921 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M996 513L997 514L996 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1191 513L1192 514L1191 513z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1222.67 513.333L1223.33 513.667L1222.67 513.333M122 514L123 515L122 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M160 514L161 515L160 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M204 514L205 515L204 514M227 514L228 515L227 514M238 514L239 515L238 514M345 514L346 515L345 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M383 514L382 516L383 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M384 514L385 515L384 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M443 514L444 515L443 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M488 514L489 515L488 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M561 514L562 515L561 514M585 514L586 515L585 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M749 514L750 515L749 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M791 514L792 515L791 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M829 514L830 515L829 514M881 514L882 515L881 514M920 514L921 515L920 514M997 514L998 515L997 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1192 514L1193 515L1192 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1221 514L1222 515L1221 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1223 514L1224 515L1223 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1237 514L1237 517L1238 517L1237 514z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M123 515L124 516L123 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M159 515L160 516L159 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M193 515L194 516L193 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M204 515L205 516L204 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M227 515L228 516L227 515M238 515L239 516L238 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M302 515L303 516L302 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M346 515L347 516L346 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M383 515L384 516L383 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M444 515L445 516L444 515M487 515L488 516L487 515M560 515L561 516L560 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M586 515L587 516L586 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M792 515L793 516L792 515M828 515L829 516L828 515M882 515L883 516L882 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M919 515L920 516L919 515M1194 515L1195 516L1194 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1220 515L1221 516L1220 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1223 515L1223 518L1224 518L1223 515z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M124 516L125 517L124 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M203 516L204 517L203 516M228 516L229 517L228 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M304 516L305 517L304 516M347 516L348 517L347 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M412.667 516.333L413.333 516.667L412.667 516.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M446 516L447 517L446 516M485 516L486 517L485 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M528 516L529 517L528 516M559 516L560 517L559 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M587 516L588 517L587 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M714.333 516.667L714.667 517.333L714.333 516.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M793 516L794 517L793 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M827 516L828 517L827 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M883 516L884 517L883 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M918 516L919 517L918 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M998 516L999 517L998 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1028 516L1029 517L1028 516z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1196 516L1197 517L1196 516M1218 516L1219 517L1218 516M126 517L127 518L126 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M156 517L157 518L156 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M194 517L195 518L194 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M203 517L204 518L203 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M228 517L229 518L228 517M237 517L238 518L237 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M303 517L306 519L303 517M347 517L347 518L351 520L351 519L347 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M348 517L349 518L348 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M349 517L350 518L349 517M379 517L380 518L379 517M448 517L449 518L448 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M484 517L485 518L484 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M557 517L558 518L557 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M588 517L589 518L588 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M752 517L753 518L752 517M795 517L796 518L795 517M825 517L826 518L825 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M885 517L886 518L885 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M917 517L918 518L917 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1000 517L1001 518L1000 517M1026 517L1027 518L1026 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1198 517L1199 518L1198 517M1216 517L1217 518L1216 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1217 517L1218 518L1217 517z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1237 517L1237 520L1238 520L1237 517M127 518L128 519L127 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M128 518L129 519L128 518M154 518L155 519L154 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M194 518L195 519L194 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M202 518L203 519L202 518M229 518L230 519L229 518M307 518L308 519L307 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M350 518L351 519L350 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M351 518L352 519L351 518M377 518L378 519L377 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M449 518L450 519L449 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M450 518L451 519L450 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M482 518L483 519L482 518M528 518L528 538L529 538L528 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M531 518L532 519L531 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M556 518L557 519L556 518M589 518L590 519L589 518M753 518L754 519L753 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M796 518L797 519L796 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M797 518L798 519L797 518M823 518L824 519L823 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M824 518L825 519L824 518M886 518L887 519L886 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M887 518L888 519L887 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M915 518L916 519L915 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1001 518L1002 519L1001 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1025 518L1026 519L1025 518M1201.67 518.333L1202.33 518.667L1201.67 518.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1203.67 518.333L1204.33 518.667L1203.67 518.333M1210 518L1210 519L1213 519L1210 518z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1213 518L1214 519L1213 518M129 519L130 520L129 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M130 519L131 520L130 519M152 519L153 520L152 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M153 519L154 520L153 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M195 519L196 520L195 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M202 519L203 520L202 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M229 519L230 520L229 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M236 519L237 520L236 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M306 519L309 521L306 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M309 519L310 520L309 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M352 519L353 520L352 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M353 519L354 520L353 519M375 519L376 520L375 519M452 519L453 520L452 519M479 519L480 520L479 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M480 519L481 520L480 519M532 519L533 520L532 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M533 519L534 520L533 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M554 519L555 520L554 519M591 519L592 520L591 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M754 519L755 520L754 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M755 519L756 520L755 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M798 519L799 520L798 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M799 519L800 520L799 519M821 519L822 520L821 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M822 519L823 520L822 519M888 519L889 520L888 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M889 519L890 520L889 519M913 519L914 520L913 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1002 519L1003 520L1002 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1003 519L1004 520L1003 519M1023 519L1024 520L1023 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1028 519L1029 520L1028 519M1222 519L1223 520L1222 519z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M43 520L44 521L43 520M57 520L58 521L57 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M88 520L88 521L102 521L88 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M131 520L132 521L131 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M132 520L133 521L132 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M133 520L134 521L133 520M149 520L150 521L149 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M150 520L151 521L150 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M195 520L196 521L195 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M201 520L196 521L196 522L202 521L201 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M236 520L237 521L236 520M278 520L280 522L280 520L278 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M311 520L312 521L311 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M352 520L353 521L352 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M355 520L356 521L355 520M372 520L373 521L372 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M373 520L374 521L373 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M406 520L406 521L410 521L406 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M454 520L455 521L454 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M455.667 520.333L456.333 520.667L455.667 520.333M476 520L477 521L476 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M477 520L478 521L477 520M534 520L535 521L534 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M535 520L536 521L535 520M551 520L552 521L551 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M552 520L553 521L552 520M593 520L594 521L593 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M594 520L595 521L594 520M612 520L613 521L612 520M654 520L654 521L668 521L654 520M682 520L682 521L696 521L682 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M715 520L716 521L715 520M729 520L730 521L729 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M756 520L757 521L756 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M757 520L758 521L757 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M758 520L759 521L758 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M776 520L777 521L776 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M800 520L801 521L800 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M801 520L802 521L801 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M802 520L803 521L802 520M818 520L819 521L818 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M819 520L820 521L819 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M820 520L821 521L820 520M891 520L892 521L891 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M892 520L893 521L892 520M910 520L911 521L910 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M911 520L912 521L911 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M951 520L952 521L951 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M971 520L971 521L985 521L971 520M1004 520L1005 521L1004 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1005 520L1006 521L1005 520M1020 520L1021 521L1020 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1021 520L1022 521L1021 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1029 520L1029 521L1041 521L1029 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1041 520L1042 521L1041 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1055 520L1056 521L1055 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1069 520L1070 521L1069 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1096 520L1096 521L1110 521L1096 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1110 520L1111 521L1110 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1124 520L1125 521L1124 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1125 520L1125 521L1138 521L1125 520M1158 520L1158 521L1172 521L1158 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1222 520L1223 521L1222 520z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1237 520L1238 521L1237 520M135 521L136 522L135 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M136.667 521.333L137.333 521.667L136.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M138 521L138 522L144 522L138 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M144 521L144 522L147 522L144 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M147 521L148 522L147 521M201 521L202 522L201 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M230 521L231 522L230 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M231 521L231 522L235 522L231 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M235 521L236 522L235 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M309 521L309 522L312 522L309 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M314.667 521.333L315.333 521.667L314.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M316 521L316 522L326 522L316 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M326.667 521.333L327.333 521.667L326.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M354 521L355 522L354 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M358.667 521.333L359.333 521.667L358.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M360 521L360 522L369 522L360 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M369.667 521.333L370.333 521.667L369.667 521.333M458.667 521.333L459.333 521.667L458.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M460 521L460 522L465 522L460 521M467 521L467 522L472 522L467 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M472 521L472 522L475 522L472 521M537.667 521.333L538.333 521.667L537.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M539 521L539 522L549 522L539 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M549 521L550 522L549 521M596.667 521.333L597.333 521.667L596.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M598 521L598 522L609 522L598 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M609.667 521.333L610.333 521.667L609.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M759 521L760 522L759 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M760.667 521.333L761.333 521.667L760.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M762 521L762 522L771 522L762 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M771.667 521.333L772.333 521.667L771.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M773 521L774 522L773 521M803.667 521.333L804.333 521.667L803.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M805.667 521.333L806.333 521.667L805.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M807 521L807 522L814 522L807 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M814.667 521.333L815.333 521.667L814.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M816 521L817 522L816 521M894 521L895 522L894 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M895.667 521.333L896.333 521.667L895.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M897 521L897 522L906 522L897 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M906.667 521.333L907.333 521.667L906.667 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M908 521L909 522L908 521M1007 521L1008 522L1007 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1008.67 521.333L1009.33 521.667L1008.67 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1010 521L1010 522L1017 522L1010 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1017.67 521.333L1018.33 521.667L1017.67 521.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1192 521L1193 522L1192 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1193 521L1194 522L1193 521z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M312 523L312 524L318 523L312 523M319.333 522.667L319.667 523.333L319.333 522.667M322 522L322 523L328 523L322 522M329 522L330 523L329 522M359 522L359 523L362 523L359 522M366 522L366 523L370 523L366 522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1191 522L1192 523L1191 522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1194 522L1195 523L1194 522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1221 522L1222 523L1221 522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1236 522L1237 523L1236 522z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M321 523L322 524L321 523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1190 523L1191 524L1190 523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1196 523L1197 524L1196 523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1220 523L1221 524L1220 523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1236 523L1237 524L1236 523z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M317 524L320 527L317 524M725 524L726 525L725 524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1198 524L1199 525L1198 524M1219 524L1220 525L1219 524M1236 524L1237 525L1236 524z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M312 525L313 526L312 525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1189 525L1190 526L1189 525M1199 525L1200 526L1199 525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1200 525L1201 526L1200 525M1218 525L1219 526L1218 525z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M298 526L298 527L301 527L298 526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1188 526L1189 527L1188 526M1202 526L1203 527L1202 526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1203 526L1204 527L1203 526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1216 526L1217 527L1216 526M1235 526L1236 527L1235 526z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1187 527L1188 528L1187 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1205 527L1206 528L1205 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1206.67 527.333L1207.33 527.667L1206.67 527.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1208 527L1208 528L1212 528L1208 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1212 527L1213 528L1212 527z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1213.67 527.333L1214.33 527.667L1213.67 527.333M1234 528L1235 529L1234 528z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M393 529L394 530L393 529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1186 529L1187 530L1186 529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1185 530L1186 531L1185 530M1233 530L1234 531L1233 530z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1185 531L1186 532L1185 531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1232 531L1233 532L1232 531z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M800 532L801 533L800 532z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1187 532L1188 533L1187 532M1231 532L1232 533L1231 532M1188 533L1189 534L1188 533M1230 533L1231 534L1230 533z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1189 534L1190 535L1189 534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1229 534L1230 535L1229 534z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1191 535L1192 536L1191 535M1228 535L1229 536L1228 535z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1192 536L1193 537L1192 536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1193 536L1194 537L1193 536M1226 536L1227 537L1226 536z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1227 536L1228 537L1227 536M1194 537L1195 538L1194 537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1195 537L1196 538L1195 537z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1225 537L1226 538L1225 537M1197 538L1198 539L1197 538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1198 538L1199 539L1198 538M1222 538L1223 539L1222 538z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1223 538L1224 539L1223 538M514 539L514 540L528 540L514 539M1200.67 539.333L1201.33 539.667L1200.67 539.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1202 539L1203 540L1202 539M1219 539L1220 540L1219 539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1220 539L1221 540L1220 539z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1204.67 540.333L1205.33 540.667L1204.67 540.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1206.67 540.333L1207.33 540.667L1206.67 540.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1208 540L1208 541L1214 541L1208 540z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1214.67 540.333L1215.33 540.667L1214.67 540.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1216 540L1217 541L1216 540M794 545L795 546L794 545M476 566L477 567L476 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M477 566L477 567L480 567L477 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M480 566L481 567L480 566M948 566L949 567L948 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M949 566L949 567L952 567L949 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M952 566L953 567L952 566M1020 566L1021 567L1020 566z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1021.67 566.333L1022.33 566.667L1021.67 566.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1023.67 566.333L1024.33 566.667L1023.67 566.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M474 567L475 568L474 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M475.044 567.743C464.973 571.791 472.022 587.089 481.981 583.254C492.181 579.325 485.374 563.592 475.044 567.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M482 567L483 568L482 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M483 567L484 568L483 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M543 567L544 568L543 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M543 580L544 580L544 568L557 568L557 598C559.076 593.053 560.442 572.984 556.972 568.603C554.766 565.817 545.246 565.979 543.603 569.318C542.176 572.218 543 576.844 543 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M557 567L558 568L557 567M915 567L916 568L915 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M915 646L916 646L916 568L929 568C925.836 566.672 917.504 565.455 915.603 569.318C912.87 574.873 915 585.865 915 592L915 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M929 567L930 568L929 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M946 567L947 568L946 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M947.044 567.743C937.012 571.775 943.712 587.276 953.956 582.987C963.959 578.799 957.148 563.682 947.044 567.743z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M954 567L955 568L954 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1017 567L1018 568L1017 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1018 567L1019 568L1018 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M1019.02 567.746C1008.77 571.671 1014.95 587.067 1024.98 583.254C1035.51 579.253 1029.08 563.894 1019.02 567.746z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1025 567L1026 568L1025 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1026 567L1027 568L1026 567z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M472 568L473 569L472 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M484 568L485 569L484 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M544 568L543.617 626.17L544.259 644.397L557 646C557 636.183 554.845 623.458 557.573 614.001C559.055 608.861 564.534 604.642 569.996 606.607C581.709 610.821 577 636.206 577 646L591 646C591 629.026 596.948 588.137 568 593.468C563.994 594.206 560.562 596.135 557 598L557 568L544 568M916 568L916 646L929 646L929 568L916 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M929 568L929 646L930 646L930 592L929 568M944 568L945 569L944 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M956 568L957 569L956 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1016 568L1017 569L1016 568M1027 568L1028 569L1027 568z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M471 569L472 570L471 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M485 569L486 570L485 569M943 569L944 570L943 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M957 569L958 570L957 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1015 569L1016 570L1015 569M1028 569L1029 570L1028 569z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M486 570L487 571L486 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M942 570L943 571L942 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1014 570L1015 571L1014 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1029 570L1030 571L1029 570z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M470 571L471 572L470 571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M942 571L943 572L942 571M958 571L959 572L958 571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1013 571L1014 572L1013 571z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1030 571L1031 572L1030 571M487 572L488 573L487 572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M941 572L942 573L941 572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1013 572L1014 573L1013 572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1030 572L1031 573L1030 572z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M469 573L469 577L470 577L469 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M487 573L487 578L488 578L487 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M914 573L914 576L915 576L914 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M941 573L942 574L941 573M959 573L959 578L960 578L959 573z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1013 573L1014 574L1013 573M941 574L941 577L942 577L941 574z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1031 574L1031 577L1032 577L1031 574M749.667 575.333L750.333 575.667L749.667 575.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M751 575L751 576L756 576L751 575z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M756 575L756 576L759 576L756 575M744 576L745 577L744 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M745 576L746 577L745 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M746 576L747 577L746 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M773 623C770.125 627.069 766.656 630.609 762 632.633C758.852 634.002 755.398 634.314 752 634.076C717.491 631.653 733.418 576.047 763 590.839C767.204 592.942 770.331 596.222 773 600C795.276 591.431 768.536 576.588 756 576.039C718.109 574.38 701.758 627.655 738 644.096C748.013 648.638 761.254 648.179 771 643.179C782.096 637.486 786.865 628.333 773 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M760.667 576.333L761.333 576.667L760.667 576.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M762 576L763 577L762 576z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M763 576L764 577L763 576M126 577L126 628L127.603 645.972L152 647L152 646L127 646L127 599L126 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M127 577L127 646C140.226 646 155.728 648.16 168 642.179C190.673 631.128 193.637 598.349 173 583.638C160.214 574.523 141.781 577 127 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M154 577L154 578L157 578L154 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M157.667 577.333L158.333 577.667L157.667 577.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M159 577L160 578L159 577M469 577L470 578L469 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M741 577L742 578L741 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M742 577L743 578L742 577M765 577L766 578L765 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M766 577L767 578L766 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M941 577L942 578L941 577z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1013 577L1014 578L1013 577M161 578L162 579L161 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M162 578L163 579L162 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M163.667 578.333L164.333 578.667L163.667 578.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M487 578L488 579L487 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M738 578L739 579L738 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M739 578L740 579L739 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M768 578L769 579L768 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M941 578L942 579L941 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1013 578L1014 579L1013 578z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1030 578L1031 579L1030 578M164 579L165 580L164 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M165 579L166 580L165 579M470 579L471 580L470 579M736 579L737 580L736 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M737 579L738 580L737 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M770 579L771 580L770 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M942 579L943 580L942 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M958 579L959 580L958 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1030 579L1031 580L1030 579z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M167 580L168 581L167 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M168 580L169 581L168 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M471 580L472 581L471 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M486 580L487 581L486 580M734 580L735 581L734 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M735 580L736 581L735 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M772 580L773 581L772 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M914 580L915 581L914 580M942 580L943 581L942 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1014 580L1015 581L1014 580z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1029 580L1030 581L1029 580M169 581L170 582L169 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M170 581L171 582L170 581M257 581L258 582L257 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M258 581L259 582L258 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M258 595L250 595L250 606L258 606C258 621.962 254.363 646.429 277 646.985C280.756 647.078 284.317 646.684 288 646L288 635C268.927 634.998 272 621.066 272 606C282.879 606 286.548 606.582 287 595C274.645 595 272 593.677 272 581C259.493 581 258 582.493 258 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M272 581L272 593L273 593L272 581M471 581L472 582L471 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M485 581L486 582L485 581M502 581L502 594L503 594L502 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M503 581C503 588.321 504.013 594.706 495 595L495 606L503 606C503 622.49 498.82 646.417 522 646.985C525.756 647.077 529.317 646.684 533 646L533 635C520.219 634.999 516.004 630.893 516 618C515.999 614.9 515.178 610.029 517.603 607.603C520.483 604.724 527.279 606 531 606L531 595C518.645 595 516 593.677 516 581L503 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M504 581L504 582L515 582L504 581M516 581L516 594L517 594L516 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M733 581L734 582L733 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M773 581L774 582L773 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M774 581L775 582L774 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M943 581L944 582L943 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M957 581L958 582L957 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M974 581L975 582L974 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M975 581C975 589.124 975.677 594.886 966 595L966 606L975 606C975 621.508 970.366 645.324 992 646.91C996.412 647.233 1000.65 646.55 1005 646L1005 635C985.351 634.998 988 621.848 988 606L1003 606L1003 595C990.645 595 988 593.677 988 581L975 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M976 581L976 582L984 582L976 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M988 581L988 594L989 594L988 581M1015 581L1016 582L1015 581z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1028 581L1029 582L1028 581M171 582L172 583L171 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M472 582L473 583L472 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M473 582L474 583L473 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M484 582L485 583L484 582M731 582L732 583L731 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M732 582L733 583L732 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M775 582L776 583L775 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M944 582L945 583L944 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M955 582L956 583L955 582M974 582L974 594L975 594L974 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1016 582L1017 583L1016 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1027 582L1028 583L1027 582z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M173 583L174 584L173 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M474 583L475 584L474 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M475 583L476 584L475 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M482 583L483 584L482 583M730 583L731 584L730 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M776 583L777 584L776 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M914 583L915 584L914 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M946 583L947 584L946 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M947 583L948 584L947 583M953 583L954 584L953 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M954 583L955 584L954 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1018 583L1019 584L1018 583M1025 583L1026 584L1025 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1026 583L1027 584L1026 583z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M174 584L175 585L174 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M476 584L476 585L481 585L476 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M543 584L543 618L544 618L543 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M729 584L730 585L729 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M777 584L778 585L777 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M950.667 584.333L951.333 584.667L950.667 584.333M1020.67 584.333L1021.33 584.667L1020.67 584.333M1023 584L1024 585L1023 584z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M175 585L176 586L175 585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M728 585L729 586L728 585z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M778 585L779 586L778 585M176 586L177 587L176 586M727 586L728 587L727 586M779 586L780 587L779 586M177 587L178 588L177 587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M726 587L727 588L726 587z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M780 587L781 588L780 587M178 588L179 589L178 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M725 588L726 589L725 588z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M781 588L782 589L781 588M179 589L180 590L179 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M724 589L725 590L724 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M747 589L748 590L747 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M748.667 589.333L749.333 589.667L748.667 589.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M750.667 589.333L751.333 589.667L750.667 589.333M757 589L758 590L757 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M758.667 589.333L759.333 589.667L758.667 589.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M760 589L761 590L760 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M782 589L783 590L782 589z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M141 590L142 591L141 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M141 591L142 633C149.894 633 158.623 633.353 164.957 627.775C184.498 610.569 163.001 584.497 141 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M153.667 590.333L154.333 590.667L153.667 590.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M155 590L156 591L155 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M156 590L157 591L156 590M180 590L181 591L180 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M723 590L724 591L723 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M745 590L746 591L745 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M761 590L762 591L761 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M762 590L763 591L762 590z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M783 590L784 591L783 590M158 591L159 592L158 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M159 591L160 592L159 591M181 591L182 592L181 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M723 591L724 592L723 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M743 591L744 592L743 591M764 591L765 592L764 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M783 591L784 592L783 591z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M914 591L914 640L915 640C915 626.212 919.309 603.652 914 591M141 592L141 633L142 633C142 621.304 145.511 602.75 141 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M161 592L162 593L161 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M569 592L569 593L574 593L569 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M722 592L723 593L722 592M741 592L742 593L741 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M765 592L766 593L765 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M766 592L767 593L766 592z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M784 592L785 593L784 592M163 593L164 594L163 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M182 593L183 594L182 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M212 593L213 594L212 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M213.667 593.333L214.333 593.667L213.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M215 593L215 594L224 594L215 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M224.667 593.333L225.333 593.667L224.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M226 593L227 594L226 593M313 593L314 594L313 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M314 593L315 594L314 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M315 593L315 594L318 594L315 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M304 612L305 612C313.722 605.107 327.535 601.34 328 617C319.418 617 308.476 615.422 301.105 620.854C292.186 627.427 295.449 641.593 305.001 645.517C314.191 649.292 321.555 645.069 330 642L329 646L342 646C342 631.393 347.1 606.166 332.996 596.703C321.604 589.059 290.624 595.317 304 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M320 593L321 594L320 593M322 593L322 594L325 594L322 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M325 593L326 594L325 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M326 593L327 594L326 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M417 593L418 594L417 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M402 623C400.884 616.52 396.245 599.774 390.582 596.028C387.22 593.804 380.868 595 377 595C380.941 608.68 388.763 622.052 394.691 635C396.151 638.188 398.257 647.096 403 646.534C409.85 645.723 416.601 623.762 419 618L421 618L434 647C441.337 646.434 442.616 639.881 445.309 634C451.244 621.038 457.527 608.163 463 595L449.418 595.603L436 623C432.798 614.747 428.604 607.01 424.857 599.005C423.712 596.557 421.872 592.168 418.375 594.086C409.665 598.864 409.638 616.335 402 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M422 593L423 594L422 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M565 593L566 594L565 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M566.667 593.333L567.333 593.667L566.667 593.333M575.667 593.333L576.333 593.667L575.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M577 593L578 594L577 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M578 593L579 594L578 593M647.667 593.333L648.333 593.667L647.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M649 593L650 594L649 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M650 593L650 594L656 594L650 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M663 617C654.733 617 644.426 615.523 637.094 620.228C628.418 625.794 629.33 639.602 638.04 644.583C646.822 649.604 657.498 646.699 665 641L665 646L677 646C677 632.731 681.421 609.921 671.471 599.468C664.679 592.333 651.598 592.187 643 595.88C639.827 597.244 634.293 599.936 634.192 604.004C634.117 607.04 637.828 611.403 641.039 610.67C650.22 608.573 662.577 599.488 663 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M657 593L657 594L660 594L657 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M660.667 593.333L661.333 593.667L660.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M662 593L663 594L662 593M721 593L722 594L721 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M740 593L741 594L740 593M767 593L768 594L767 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M783 593L784 594L783 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M812 593L813 594L812 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M813 593L814 594L813 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M814.667 593.333L815.333 593.667L814.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M816 593.725C781.32 595.094 786.63 648.357 821 646.96C841.403 646.131 854.613 622.14 842.362 605.001C835.971 596.06 826.525 593.309 816 593.725z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M817 593L817 594L825 594L817 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M825 593L826 594L825 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M826 593L827 594L826 593M872 593L873 594L872 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M873.667 593.333L874.333 593.667L873.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M875 593L875 594L884 594L875 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M884.667 593.333L885.333 593.667L884.667 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1061 593L1062 594L1061 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1062 593L1063 594L1062 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1063 593L1063 594L1073 594L1063 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1073.67 593.333L1074.33 593.667L1073.67 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1129 593L1130 594L1129 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1130 593L1131 594L1130 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1131 593L1131 594L1139 594L1131 593z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1139.67 593.333L1140.33 593.667L1139.67 593.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M164 594L165 595L164 594M183 594L184 595L183 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M209 594L210 595L209 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M210 594L211 595L210 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M203 612C212.658 607.703 226.391 599.263 228 617C219.443 617 208.388 615.246 201.044 620.652C192.133 627.212 194.082 641.046 204.015 645.467C212.714 649.338 221.113 645.661 229 642L229 646L241 646C241 632.588 246.101 606.801 233.957 597.638C226.942 592.346 213.635 592.436 206 596.403C203.317 597.797 198.321 600.498 198.345 604.039C198.364 606.863 201.5 609.793 203 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M228 594L229 595L228 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M229 594L229 595L232 596L229 594M249 594L249 606L250 606L249 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M250 594L250 595L258 595L250 594M273 594L273 595L287 595L273 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M309 594L310 595L309 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M310 594L311 595L310 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M311 594L312 595L311 594M328 594L329 595L328 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M329 594L330 595L329 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M376 594L376 595L392 596L376 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M391 594L392 595L391 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M416 594L417 595L416 594M448 594L449 595L448 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M449 594L449 595L463 595L449 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M463 594L464 595L463 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M471 594L471 646L472 646L472 611L471 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M472 594L472 595L486 595L472 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M494 594L495 595L494 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M495 594L495 595L502 595L495 594M517 594L517 595L531 595L517 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M531 594L530 607L531 607L531 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M562 594L563 595L562 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M563 594L564 595L563 594M579 594L580 595L579 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M580 594L580 595L583 596L580 594M642 596L645 595L642 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M645 594L646 595L645 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M646 594L647 595L646 594M663 594L664 595L663 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M664 594L665 595L664 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M665 594L666 595L665 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M721 594L722 595L721 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M739 594L740 595L739 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M768 594L769 595L768 594M782 594L783 595L782 594M809 594L810 595L809 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M810 594L811 595L810 594M828 594L829 595L828 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M829 594L830 595L829 594M869 594L870 595L869 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M870 594L871 595L870 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M857 603L857 604L864 612L865 612C873.592 604.288 886.653 602.16 888 617C879.443 617 868.388 615.246 861.044 620.652C851.66 627.56 854.518 641.741 865 645.852C873.441 649.162 881.456 645.501 889 642L889 646L901 646C901 633.83 904.173 616.373 899.517 605C892.298 587.366 867.838 593.114 857 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M887 594L888 595L887 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M888 594L889 595L888 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M889 594L890 595L889 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M943 594L944 595L943 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M943 646L944 646L944 595L958 596C954.791 593.569 944.875 591.903 943.318 597.148C939.206 611 943 631.512 943 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M957 594L958 595L957 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M966 594L966 595L974 595L966 594M989 594L989 595L1003 595L989 594M1015 594L1015 595L1029 595L1015 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1029 594L1030 595L1029 594M1057 594L1058 595L1057 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1058 594L1059 595L1058 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1059 594L1060 595L1059 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M1060 594.529C1026.02 602.37 1041.39 654.036 1075 646.319C1092.58 642.283 1101.81 620.009 1091.2 605.004C1084.25 595.179 1071.43 591.891 1060 594.529z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1076 594L1077 595L1076 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1077 594L1078 595L1077 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1078 594L1079 595L1078 594M1106 594L1106 631C1106 634.731 1104.58 642.302 1107.03 645.397C1109.7 648.766 1118.53 647.025 1122 646L1122 645L1107 646L1107 611L1106 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1107 594L1107 595L1119 595L1122 598L1122 597L1120 594L1107 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1126 594L1127 595L1126 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1127 594L1128 595L1127 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M1120 599L1119 595L1107 595L1107 646L1121 646C1121 636.206 1116.29 610.821 1128 606.607C1133.52 604.623 1138.75 608.92 1140.35 614.001C1143.27 623.287 1141 636.295 1141 646L1154 646C1154 633.775 1157.11 616.541 1152.87 605C1147.9 591.489 1129.89 591.02 1120 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1142 594L1143 595L1142 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1143 594L1144 595L1143 594z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M166 595L167 596L166 595M183 595L184 596L183 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M206 595L207 596L206 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M207 595L208 596L207 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M230 595L231 596L230 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M307 595L308 596L307 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M308 595L309 596L308 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M331 595L332 596L331 595M376 595L377 596L376 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M416 595L417 596L416 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M423 595L424 596L423 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M447 595L448 596L447 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M472 595L472 646L486 646L486 595L472 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M494 595L494 606L495 606L494 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M560 595L561 596L560 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M561 595L562 596L561 595M581 595L582 596L581 595M643 595L644 596L643 595M666 595L667 596L666 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M667 595L668 596L667 595M720 595L721 596L720 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M769 595L770 596L769 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M780 595L781 596L780 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M781 595L782 596L781 595M806 595L807 596L806 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M807 595L808 596L807 595M830 595L831 596L830 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M831 595L832 596L831 595M867 595L868 596L867 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M890 595L891 596L890 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M891 595L892 596L891 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M944 595L944 646L957 646L957 595L944 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1003 595L1003 606L1004 606L1003 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#f8fcfb",
      stroke: "none"
    },
    d: "M1015 595L1015 646L1029 646L1029 595L1015 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1029 595L1030 596L1029 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1055 595L1056 596L1055 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1056 595L1057 596L1056 595M1079 595L1080 596L1079 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1080 595L1081 596L1080 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1124 595L1125 596L1124 595M1145 595L1146 596L1145 595z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M167 596L168 597L167 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M184 596L185 597L184 596M204 596L205 597L204 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M205 596L206 597L205 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M232 596L233 597L232 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M305 596L306 597L305 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M306 596L307 597L306 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M333 596L334 597L333 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M392 596L393 597L392 596M415 596L416 597L415 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M447 596L448 597L447 596M462 596L463 597L462 596M559 596L560 597L559 596M583 596L584 597L583 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M640 596L641 597L640 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M641 596L642 597L641 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M668 596L669 597L668 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M720 596L721 597L720 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M737 596L738 597L737 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M770 596L771 597L770 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M779 596L780 597L779 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M805 596L806 597L805 596M833 596L834 597L833 596M865 596L866 597L865 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M892 596L893 597L892 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M957 596L958 597L957 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1029 596L1029 646L1030 646C1030 631.951 1034.41 608.889 1029 596M1053 596L1054 597L1053 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1054 596L1055 597L1054 596M1081 596L1082 597L1081 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1082 596L1083 597L1082 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1122 596L1123 597L1122 596z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1146 596L1147 597L1146 596M184 597L185 598L184 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M203 597L204 598L203 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M234 597L235 598L234 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M304 597L305 598L304 597M334 597L335 598L334 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M377 597L378 598L377 597M392 597L393 598L392 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M415 597L416 598L415 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M424 597L425 598L424 597M558 597L559 598L558 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M584 597L585 598L584 597M639 597L640 598L639 597M669 597L671 599L669 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M670 597L671 598L670 597M719 597L720 598L719 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M736 597L737 598L736 597M771 597L772 598L771 597M778 597L779 598L778 597M803 597L804 598L803 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M834 597L835 598L834 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M863 597L864 598L863 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M894 597L895 598L894 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M957.333 597.667L957.667 598.333L957.333 597.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1052 597L1053 598L1052 597M1083 597L1084 598L1083 597z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M168 598L169 599L168 598M185 598L186 599L185 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M202 598L203 599L202 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M235 598L236 599L235 598M302 598L303 599L302 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M335 598L336 599L335 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M414 598L415 599L414 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M424 598L425 599L424 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M446 598L447 599L446 598M461 598L462 599L461 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M585 598L586 599L585 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M637 598L638 599L637 598M671 598L672 599L671 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M719 598L720 599L719 598M735 598L736 599L735 598M772 598L773 599L772 598M776 598L777 599L776 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M802 598L803 599L802 598M836 598L837 599L836 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M862 598L863 599L862 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M895 598L896 599L895 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1051 598L1052 599L1051 598M1084 598L1085 599L1084 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1085 598L1086 599L1085 598z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M169 599L170 600L169 599M185 599L186 600L185 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M200 599L201 600L200 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M201 599L202 600L201 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M236 599L237 600L236 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M286 599L287 600L286 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M301 599L302 600L301 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M336 599L337 600L336 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M378 599L379 600L378 599M393 599L394 600L393 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M414 599L415 600L414 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M425 599L426 600L425 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M446 599L447 600L446 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M461 599L462 600L461 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M586 599L587 600L586 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M636 599L637 600L636 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M672 599L673 600L672 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M775 599L776 600L775 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M801 599L802 600L801 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M837 599L838 600L837 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M860 599L861 600L860 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M896 599L897 600L896 599M957 599L958 600L957 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1049 599L1050 600L1049 599M1086 599L1087 600L1086 599z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M185 600L186 601L185 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M199 600L200 601L199 600M237 600L238 601L237 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M300 600L301 601L300 600M337 600L338 601L337 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M378 600L379 601L378 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M393 600L394 601L393 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M413 600L414 601L413 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M425 600L426 601L425 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M445 600L446 601L445 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M460 600L461 601L460 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M587 600L588 601L587 600M635 600L636 601L635 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M672 600L673 601L672 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M718 600L719 601L718 600M734 600L735 601L734 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M773.667 600.333L774.333 600.667L773.667 600.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M800 600L801 601L800 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M838 600L839 601L838 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M859 600L860 601L859 600M897 600L898 601L897 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M957 600L958 601L957 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1048 600L1049 601L1048 600M1087 600L1088 601L1087 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1150 600L1151 601L1150 600z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M170 601L171 602L170 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M186 601L187 602L186 601M198 601L199 602L198 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M299 601L300 602L299 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M338 601L339 602L338 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M379 601L380 602L379 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M394 601L395 602L394 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M413 601L414 602L413 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M426 601L427 602L426 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M445 601L446 602L445 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M460 601L461 602L460 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M634 601L635 602L634 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M673 601L674 602L673 601M718 601L719 602L718 601M799 601L800 602L799 601M839 601L840 602L839 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M858 601L859 602L858 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M957 601L957 605L958 605L957 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1047 601L1048 602L1047 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1088 601L1089 602L1088 601M1151 601L1152 602L1151 601z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M170 602L171 603L170 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M186.333 602.667L186.667 603.333L186.333 602.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M197 602L198 603L197 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M238 602L239 603L238 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M298 602L299 603L298 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M339 602L340 603L339 602M379 602L380 603L379 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M394 602L395 603L394 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M426 602L427 603L426 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M444 602L445 603L444 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M459 602L460 603L459 602M588 602L589 603L588 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M633 602L634 603L633 602M674 602L675 603L674 602M733 602L734 603L733 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M798 602L799 603L798 602M840 602L841 603L840 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M857 602L858 603L857 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M898 602L899 603L898 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1046 602L1047 603L1046 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1089 602L1090 603L1089 602z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M171 603L172 604L171 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M196 603L197 604L196 603M239 603L240 604L239 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M297 603L298 604L297 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M339 603L340 604L339 603M380 603L381 604L380 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M412 603L413 604L412 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M427 603L428 604L427 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M444 603L445 604L444 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M459 603L460 604L459 603M589 603L590 604L589 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M632 603L633 604L632 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M674 603L675 604L674 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M717 603L718 604L717 603M733 603L734 604L733 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M797 603L798 604L797 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M841 603L842 604L841 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M899 603L900 604L899 603M1090 603L1091 604L1090 603z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1152 603L1153 604L1152 603M171 604L172 605L171 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M186.333 604.667L186.667 605.333L186.333 604.667M197 604L198 605L197 604M239 604L240 605L239 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M297 604L298 605L297 604M340 604L341 605L340 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M380 604L381 605L380 604M395 604L396 605L395 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M427 604L428 605L427 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M589 604L590 605L589 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M632 604L633 605L632 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M675 604L676 605L675 604M717.333 604.667L717.667 605.333L717.333 604.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M732 604L733 605L732 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M796 604L797 605L796 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M842 604L843 605L842 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M857 604L858 605L857 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M899 604L900 605L899 604z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M171 605L172 606L171 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M214.667 605.333L215.333 605.667L214.667 605.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M216 605L216 606L219 606L216 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M219.667 605.333L220.333 605.667L219.667 605.333M286 605L287 606L286 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M298 605L299 606L298 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M315 605L316 606L315 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M316 605L316 606L320 606L316 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M320.667 605.333L321.333 605.667L320.667 605.333M340 605L341 606L340 605M381 605L382 606L381 605M395 605L396 606L395 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M411 605L412 606L411 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M428 605L429 606L428 605M443 605L444 606L443 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M458 605L459 606L458 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M589 605L590 606L589 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M633 605L634 606L633 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M650.667 605.333L651.333 605.667L650.667 605.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M652 605L652 606L655 606L652 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M655.667 605.333L656.333 605.667L655.667 605.333M675 605L676 606L675 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M732.333 605.667L732.667 606.333L732.333 605.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M795 605L796 606L795 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M858 605L859 606L858 605M874.667 605.333L875.333 605.667L874.667 605.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M876 605L876 606L880 606L876 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M880 605L881 606L880 605M957 605L957 609L958 609L957 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1044 605L1045 606L1044 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1091 605L1092 606L1091 605z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1153 605L1154 606L1153 605M198 606L199 607L198 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M211 606L212 607L211 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M212 606L213 607L212 606M222 606L223 607L222 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M223 606L224 607L223 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M240 606L241 607L240 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M250 606L250 607L257 607L250 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M257 606L258 607L257 606M272 606L273 607L272 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M273 606L273 607L287 607L273 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M299 606L300 607L299 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M312 606L313 607L312 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M313 606L314 607L313 606M322 606L323 607L322 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M323 606L324 607L323 606M381 606L382 607L381 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M396 606L397 607L396 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M411 606L412 607L411 606M428 606L429 607L428 606M443 606L444 607L443 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M494 606L494 607L502 607L494 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M502 606L503 607L502 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M517 606L517 607L530 607L517 606M531 606L532 607L531 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M563 606L564 607L563 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M564 606L565 607L564 606M570 606L571 607L570 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M571 606L572 607L571 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M590 606L591 607L590 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M634 606L635 607L634 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M647 606L648 607L647 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M648 606L649 607L648 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M649 606L650 607L649 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M658 606L659 607L658 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M676 606L677 607L676 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M717 606L717 617L718 617L717 606M815 606L816 607L815 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M816 606L817 607L816 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M817 606L818 607L817 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M818 606.642C801.527 608.044 803.648 635.015 820 633.775C837.056 632.481 835.161 605.181 818 606.642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M820.667 606.333L821.333 606.667L820.667 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M822 606L823 607L822 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M823 606L824 607L823 606M843 606L844 607L843 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M872 606L873 607L872 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M882 606L883 607L882 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M883 606L884 607L883 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M900 606L901 607L900 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M966 606L966 607L974 607L966 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M974 606L974 631L975 631L974 606M988 606L989 607L988 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M989 606L989 607L1003 607L989 606M1043 606L1044 607L1043 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1063 606L1064 607L1063 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1064 606L1065 607L1064 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1065.67 606.333L1066.33 606.667L1065.67 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M1067 606.642C1050.2 608.065 1051.99 635.093 1069 633.775C1085.89 632.466 1083.77 605.221 1067 606.642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1069.67 606.333L1070.33 606.667L1069.67 606.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1071 606L1072 607L1071 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1072 606L1073 607L1072 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1092 606L1093 607L1092 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1126 606L1127 607L1126 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1127 606L1128 607L1127 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1133 606L1134 607L1133 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1134 606L1135 607L1134 606z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1153 606L1154 607L1153 606M172.333 607.667L172.667 608.333L172.333 607.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M187 607L187 616L188 616L187 607M199 607L200 608L199 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M210 607L211 608L210 607M224 607L225 608L224 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M240 607L241 608L240 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M272 607L272 628L273 628L272 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M300 607L301 608L300 607M310 607L311 608L310 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M311 607L312 608L311 607M324 607L325 608L324 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M325 607L326 608L325 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M341.333 607.667L341.667 608.333L341.333 607.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M396 607L397 608L396 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M410 607L411 608L410 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M429 607L430 608L429 607M442 607L443 608L442 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M457 607L458 608L457 607M502 607L502 631L503 631L502 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M516 607L516 628L517 628L516 607M561 607L562 608L561 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M572 607L573 608L572 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M590 607L591 608L590 607M635 607L636 608L635 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M645 607L646 608L645 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M646 607L647 608L646 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M660 607L661 608L660 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M676 607L677 608L676 607M794 607L795 608L794 607M813 607L814 608L813 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M824 607L825 608L824 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M825 607L826 608L825 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M844 607L845 608L844 607M859 607L860 608L859 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M870 607L871 608L870 607M884 607L885 608L884 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M900 607L901 608L900 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M988 607L988 627L989 627L988 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1043 607L1044 608L1043 607M1061 607L1062 608L1061 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1062 607L1063 608L1062 607M1073 607L1074 608L1073 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1074 607L1075 608L1074 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1125 607L1126 608L1125 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1136 607L1137 608L1136 607z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M200 608L201 609L200 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M208 608L209 609L208 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M225 608L226 609L225 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M301 608L302 609L301 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M309 608L310 609L309 608M382 608L383 609L382 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M397 608L398 609L397 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M410 608L411 609L410 608M429 608L430 609L429 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M442 608L443 609L442 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M457 608L458 609L457 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M560 608L561 609L560 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M573 608L574 609L573 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M590.333 608.667L590.667 609.333L590.333 608.667M636 608L637 609L636 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M644 608L645 609L644 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M661 608L662 609L661 608M676.333 608.667L676.667 609.333L676.333 608.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M811 608L812 609L811 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M826 608L827 609L826 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M844 608L845 609L844 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M860 608L861 609L860 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M868 608L869 609L868 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M885 608L886 609L885 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1042 608L1043 609L1042 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1060 608L1061 609L1060 608M1075 608L1076 609L1075 608M1093 608L1094 609L1093 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1124 608L1125 609L1124 608z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1137 608L1138 609L1137 608M172 609L172 614L173 614L172 609M201 609L202 610L201 609M207 609L208 610L207 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M226 609L227 610L226 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M241 609L242 610L241 609M301 609L302 610L301 609M308 609L309 610L308 609M326 609L327 610L326 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M341 609L342 610L341 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M382 609L383 610L382 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M397 609L398 610L397 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M409 609L410 610L409 609M430 609L431 610L430 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M456 609L457 610L456 609M559 609L560 610L559 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M574 609L575 610L574 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M643 609L644 610L643 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M661 609L662 610L661 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M793 609L794 610L793 609M810 609L811 610L810 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M828 609L829 610L828 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M845 609L846 610L845 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M861 609L862 610L861 609M867 609L868 610L867 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M886 609L887 610L886 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M901 609L902 610L901 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M957 609L957 639L958 639L957 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1042 609L1043 610L1042 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1059 609L1060 610L1059 609M1076 609L1077 610L1076 609M1123 609L1124 610L1123 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1138 609L1139 610L1138 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1154 609L1155 610L1154 609z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M202 610L203 611L202 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M206 610L207 611L206 610M226 610L227 611L226 610M241.333 610.667L241.667 611.333L241.333 610.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M302 610L303 611L302 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M306 610L307 611L306 610M327 610L328 611L327 610M383 610L384 611L383 610M409 610L410 611L409 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M430 610L431 611L430 610M441 610L442 611L441 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M456 610L457 611L456 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M558 610L559 611L558 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M575 610L576 611L575 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M637 610L638 611L637 610M642 610L643 611L642 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M662 610L663 611L662 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M677.333 610.667L677.667 611.333L677.333 610.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M731 610L732 611L731 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M809 610L810 611L809 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M829 610L830 611L829 610M845 610L846 611L845 610M862 610L863 611L862 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M866 610L867 611L866 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M886 610L887 611L886 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M901.333 610.667L901.667 611.333L901.333 610.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1041 610L1042 611L1041 610M1058 610L1059 611L1058 610M1077 610L1078 611L1077 610M1094 610L1095 611L1094 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1122 610L1123 611L1122 610M1154 610L1154 646L1155 646C1155 635.613 1158.01 619.559 1154 610z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M205 611L206 612L205 611M226 611L227 612L226 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M303 611L304 612L303 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M305 611L306 612L305 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M327 611L328 612L327 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M383 611L384 612L383 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M398 611L399 612L398 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M408 611L409 612L408 611M431 611L432 612L431 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M441 611L442 612L441 611M455 611L456 612L455 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M558 611L559 612L558 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M638 611L639 612L638 611M641 611L642 612L641 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M662 611L663 612L662 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M792 611L793 612L792 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M808 611L809 612L808 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M829 611L830 612L829 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M863 611L864 612L863 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M865 611L866 612L865 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1041 611L1042 612L1041 611M1057 611L1058 612L1057 611M1078 611L1079 612L1078 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1094 611L1095 612L1094 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1139 611L1140 612L1139 611z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M203.667 612.333L204.333 612.667L203.667 612.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M227 612L227 617L228 617L227 612M241 612L241 646L242 646L241 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M304 612L305 613L304 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M305 612L306 613L305 612M327.333 612.667L327.667 613.333L327.333 612.667M342 612L342 646L343 646L342 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M384 612L385 613L384 612M398 612L399 613L398 612M408 612L409 613L408 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M431 612L432 613L431 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M440 612L441 613L440 612M455 612L456 613L455 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M576 612L577 613L576 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M591 612L591 646L592 646L591 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M639 612L640 613L639 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M640 612L641 613L640 612M662 612L663 613L662 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M677 612L677 646L678 646L677 612M792 612L793 613L792 612M830 612L831 613L830 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M846 612L847 613L846 612M863.667 612.333L864.333 612.667L863.667 612.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M887 612L887 617L888 617L887 612M901 612L901 641L902 641L901 612M1041 612L1042 613L1041 612M1056 612L1057 613L1056 612M1079 612L1080 613L1079 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1121 612L1122 613L1121 612z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M384 613L385 614L384 613M399 613L400 614L399 613M407 613L408 614L407 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M440 613L441 614L440 613M454 613L455 614L454 613M557 613L557 646L558 646L557 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M576 613L577 614L576 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M792 613L793 614L792 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M807 613L808 614L807 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M831 613L832 614L831 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M846 613L847 614L846 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1079 613L1080 614L1079 613M1095 613L1096 614L1095 613M1121 613L1122 614L1121 613z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1140 613L1140 646L1141 646L1140 613M172.333 614.667L172.667 615.333L172.333 614.667M385 614L386 615L385 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M399 614L400 615L399 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M407 614L408 615L407 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M432 614L433 615L432 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M439 614L440 615L439 614M454 614L455 615L454 614M576 614L576 646L577 646L576 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M831 614L832 615L831 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M846 614L847 615L846 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1040 614L1041 615L1040 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1055 614L1056 615L1055 614M1080 614L1081 615L1080 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1095 614L1096 615L1095 614z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M385 615L386 616L385 615M406 615L407 616L406 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M439 615L440 616L439 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M791 615L792 616L791 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M806 615L807 616L806 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1040 615L1041 616L1040 615M1055 615L1056 616L1055 615M1080 615L1081 616L1080 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1095 615L1095 618L1096 618L1095 615z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1121 615L1122 616L1121 615M211 616L211 617L215 617L211 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M215 616L215 617L227 617L215 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M257 616L257 625L258 625L257 616M311 616L311 617L315 617L311 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M315 616L315 617L328 617L315 616M400 616L401 617L400 616M406 616L407 617L406 616M433 616L434 617L433 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M439 616L440 617L439 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M453 616L454 617L453 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M646 616L646 617L650 617L646 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M650 616L650 617L663 617L650 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M732 616L733 617L732 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M791 616L791 624L792 624L791 616M806 616L807 617L806 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M832 616L833 617L832 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M871 616L871 617L876 617L871 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M876 616L876 617L879 617L876 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M879 616L879 617L883 617L879 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M883 616L883 617L886 617L883 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M886 616L887 617L886 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1040 616L1040 624L1041 624L1040 616z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M171 617L172 618L171 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M186.333 617.667L186.667 618.333L186.333 617.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M206 617L207 618L206 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M207.667 617.333L208.333 617.667L207.667 617.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M306 617L307 618L306 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M307 617L308 618L307 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M308.667 617.333L309.333 617.667L308.667 617.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M386 617L387 618L386 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M400 617L401 618L400 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M438 617L439 618L438 617M641 617L642 618L641 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M642 617L643 618L642 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M643.667 617.333L644.333 617.667L643.667 617.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M717.333 617.667L717.667 618.333L717.333 617.667M732 617L733 618L732 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M806 617L807 618L806 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M832 617L832 623L833 623L832 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M847 617L847 624L848 624L847 617M866 617L867 618L866 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M867 617L868 618L867 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M868 617L869 618L868 617M1081 617L1081 623L1082 623L1081 617z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M171 618L172 619L171 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M203 618L204 619L203 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M204 618L205 619L204 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M304 618L305 619L304 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M305 618L306 619L305 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M401 618L402 619L401 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M405 618L406 619L405 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M419 618L421 620L419 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M420 618L421 619L420 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M434 618L435 619L434 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M438 618L439 619L438 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M452 618L453 619L452 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M638 618L639 619L638 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M639 618L640 619L639 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M640 618L641 619L640 618M732 618L733 619L732 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M863 618L864 619L863 618z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M864 618L865 619L864 618M1054 618L1054 623L1055 623L1054 618M171 619L172 620L171 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M186 619L187 620L186 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M201 619L202 620L201 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M202 619L203 620L202 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M302 619L303 620L302 619M387 619L388 620L387 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M401 619L402 620L401 619M405 619L406 620L405 619M418 619L419 620L418 619M434 619L435 620L434 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M437 619L438 620L437 619M452 619L453 620L452 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M637 619L638 620L637 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M717 619L718 620L717 619M861 619L862 620L861 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M862 619L863 620L862 619z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M170 620L171 621L170 620M186 620L187 621L186 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M200 620L201 621L200 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M300 620L301 621L300 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M301 620L302 621L301 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M404 620L405 621L404 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M418 620L419 621L418 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M421 620L422 621L421 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M435 620L436 621L435 620M437 620L438 621L437 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M451 620L452 621L451 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M635 620L636 621L635 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M636 620L637 621L636 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M733 620L734 621L733 620M860 620L861 621L860 620z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M170 621L171 622L170 621M199 621L200 622L199 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M299 621L300 622L299 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M388 621L389 622L388 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M402 621L404 623L402 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M404 621L405 622L404 621M417 621L418 622L417 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M421 621L422 622L421 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M435 621L436 622L435 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M451 621L452 622L451 621M634 621L635 622L634 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M718 621L719 622L718 621M733 621L734 622L733 621M859 621L860 622L859 621z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M169 622L170 623L169 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M185 622L186 623L185 622M198 622L199 623L198 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M298 622L299 623L298 622M388 622L389 623L388 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M402 622L403 623L402 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M417 622L418 623L417 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M422 622L423 623L422 622M436 622L437 623L436 622M450 622L451 623L450 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M633 622L634 623L633 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M718 622L719 623L718 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M734 622L735 623L734 622M773.667 622.333L774.333 622.667L773.667 622.333M806 622L807 623L806 622z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M858 622L859 623L858 622M1095 622L1095 625L1096 625L1095 622M169 623L170 624L169 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M185 623L186 624L185 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M197 623L198 624L197 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M297 623L298 624L297 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M389 623L390 624L389 623M416 623L417 624L416 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M422 623L423 624L422 623M450 623L451 624L450 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M543 623L544 624L543 623M633 623L634 624L633 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M718 623L719 624L718 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M734 623L735 624L734 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M775 623L776 624L775 623M806.333 623.667L806.667 624.333L806.333 623.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M832 623L833 624L832 623z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M857 623L858 624L857 623M168 624L169 625L168 624M196 624L197 625L196 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M297 624L298 625L297 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M389 624L390 625L389 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M416 624L417 625L416 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M423 624L424 625L423 624M449 624L450 625L449 624M632 624L633 625L632 624M719 624L720 625L719 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M735 624L736 625L735 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M772 624L773 625L772 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M776 624L777 625L776 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M791 624L792 625L791 624M856 624L857 625L856 624z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1040.33 624.667L1040.67 625.333L1040.33 624.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1055 624L1056 625L1055 624M1080 624L1081 625L1080 624M167 625L168 626L167 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M184 625L185 626L184 625M196 625L197 626L196 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M296 625L297 626L296 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M390 625L391 626L390 625M415 625L416 626L415 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M423 625L424 626L423 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M449 625L450 626L449 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M543 625L543 631L544 631L543 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M631 625L632 626L631 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M719 625L720 626L719 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M736 625L737 626L736 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M771 625L772 626L771 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M778 625L779 626L778 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M806 625L807 626L806 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M831 625L832 626L831 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M846.333 625.667L846.667 626.333L846.333 625.667M856 625L857 626L856 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1055 625L1056 626L1055 625M1080 625L1081 626L1080 625M1095 625L1096 626L1095 625z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M166 626L167 627L166 626M184 626L185 627L184 626M195 626L196 627L195 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M212 626L213 627L212 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M213 626L214 627L213 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M214 626L214 627L227 627L214 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M227 626L227 629L228 629L227 626M296 626L297 627L296 626M313 626L314 627L313 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M314 626L315 627L314 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M315 626L315 627L328 627L315 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M390 626L391 627L390 626M415 626L416 627L415 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M424 626L425 627L424 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M631 626L632 627L631 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M648 626L649 627L648 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M649 626L650 627L649 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M650 626L650 627L662 627L650 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M662 626L663 627L662 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M770 626L771 627L770 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M779 626L780 627L779 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M807 626L808 627L807 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M831 626L832 627L831 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M855 626L856 627L855 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M872 626L873 627L872 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M873 626L874 627L873 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M874 626L874 627L887 627L874 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M887 626L887 629L888 629L887 626z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1095 626L1096 627L1095 626M165 627L166 628L165 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M183 627L184 628L183 627M195.333 627.667L195.667 628.333L195.333 627.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M211 627L212 628L211 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M227 627L219 627.001C199.483 627.104 223.032 646.61 227 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M257.333 627.667L257.667 628.333L257.333 627.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M311 627L310 629L311 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M328 627L320 627C302.487 627.036 315.727 642.051 324.581 633.568C326.431 631.795 327.179 629.341 328 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M414 627L415 628L414 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M424 627L425 628L424 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M448 627L449 628L448 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M631 627L632 628L631 627M646 627L645 629L646 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M647 627L648 628L647 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M663 627L655 627.001C638.105 627.09 650.986 641.802 659.581 633.568C661.431 631.795 662.179 629.341 663 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M720 627L721 628L720 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M737 627L738 628L737 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M769 627L770 628L769 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M780 627L781 628L780 627M792 627L793 628L792 627M807 627L808 628L807 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M846 627L847 628L846 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M855.333 627.667L855.667 628.333L855.333 627.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M871 627L872 628L871 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0a2d25",
      stroke: "none"
    },
    d: "M887 627L879 627.001C859.576 627.104 882.954 647.039 887 627z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M988.333 627.667L988.667 628.333L988.333 627.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1056 627L1057 628L1056 627M1079 627L1080 628L1079 627M164 628L165 629L164 628M272 628L273 629L272 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M295 628L296 629L295 628M327 628L328 629L327 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M391 628L392 629L391 628M414 628L415 629L414 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M425 628L426 629L425 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M517.333 628.667L517.667 629.333L517.333 628.667M630 628L631 629L630 628M662.333 628.667L662.667 629.333L662.333 628.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M738 628L739 629L738 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M768 628L769 629L768 628M782 628L783 629L782 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M792 628L793 629L792 628M808 628L809 629L808 628z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M830 628L831 629L830 628M1041 628L1042 629L1041 628M1094 628L1095 629L1094 628M163 629L164 630L163 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M182 629L183 630L182 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M194 629L194 634L195 634L194 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M209.333 629.667L209.667 630.333L209.333 629.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M272 629L273 630L272 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M295.333 629.667L295.667 630.333L295.333 629.667M327 629L328 630L327 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M425 629L426 630L425 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M447 629L448 630L447 629M630 629L630 635L631 635L630 629M645 629L646 630L645 629M721 629L722 630L721 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M740 629L741 630L740 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M767 629L768 630L767 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M783 629L784 630L783 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M809 629L810 630L809 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M829 629L830 630L829 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M845 629L846 630L845 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M869.333 629.667L869.667 630.333L869.333 629.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1041 629L1042 630L1041 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1057 629L1058 630L1057 629M1078 629L1079 630L1078 629z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1094 629L1095 630L1094 629M161 630L162 631L161 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M181 630L182 631L181 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M226 630L227 631L226 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M327 630L328 631L327 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M392 630L393 631L392 630M413 630L414 631L413 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M426 630L427 631L426 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M447 630L448 631L447 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M517 630L518 631L517 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M662 630L663 631L662 630M722 630L723 631L722 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M741 630L742 631L741 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M766 630L767 631L766 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M784 630L785 631L784 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M793 630L794 631L793 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M810 630L811 631L810 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M828 630L829 631L828 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M845 630L846 631L845 630M886 630L887 631L886 630M989 630L990 631L989 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1058 630L1059 631L1058 630M1077 630L1078 631L1077 630z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M158 631L159 632L158 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M159 631L160 632L159 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M181 631L182 632L181 631M209 631L210 632L209 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M226 631L227 632L226 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M273 631L274 632L273 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M295.333 631.667L295.667 632.333L295.333 631.667M309 631L310 632L309 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M326 631L327 632L326 631M392 631L393 632L392 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M426 631L427 632L426 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M446 631L447 632L446 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M502.333 631.667L502.667 632.333L502.333 631.667M661 631L662 632L661 631M722 631L723 632L722 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M742 631L743 632L742 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M743 631L744 632L743 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M764 631L765 632L764 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M783 631L784 632L783 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M793 631L794 632L793 631M811 631L812 632L811 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M827 631L828 632L827 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M854 631L854 634L855 634L854 631M869 631L870 632L869 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M886 631L887 632L886 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M974.333 631.667L974.667 632.333L974.333 631.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M989 631L990 632L989 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1042 631L1043 632L1042 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1059 631L1060 632L1059 631M1076 631L1077 632L1076 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1093 631L1094 632L1093 631z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M154 632L155 633L154 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M155 632L156 633L155 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M156 632L157 633L156 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M180 632L181 633L180 632M209 632L210 633L209 632M225 632L226 633L225 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M258 632L259 633L258 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M274 632L275 633L274 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M326 632L327 633L326 632M393 632L394 633L393 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M412 632L413 633L412 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M427 632L428 633L427 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M446 632L447 633L446 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M518 632L519 633L518 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M645 632L646 633L645 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M661 632L662 633L661 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M723 632L724 633L723 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M744 632L745 633L744 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M745 632L746 633L745 632M762 632L763 633L762 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M783 632L784 633L783 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M794 632L795 633L794 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M812 632L813 633L812 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M825 632L826 633L825 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M826 632L827 633L826 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M844 632L845 633L844 632M869 632L870 633L869 632M885 632L886 633L885 632M990 632L991 633L990 632M1061 632L1062 633L1061 632M1074 632L1075 633L1074 632z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M141 633L141 634L152 634L141 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M179 633L180 634L179 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M209 633L210 634L209 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M224 633L225 634L224 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M258 633L259 634L258 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M275 633L276 634L275 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M276 633L277 634L276 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M295.333 633.667L295.667 634.333L295.333 633.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M310 633L311 634L310 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M325 633L326 634L325 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M393 633L394 634L393 633M427 633L428 634L427 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M445 633L446 634L445 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M520 633L521 634L520 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M521 633L522 634L521 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M645 633L646 634L645 633M660 633L661 634L660 633M724 633L725 634L724 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M747 633L748 634L747 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M748 633L749 634L748 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M749 633L750 634L749 633M758 633L759 634L758 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M759 633L760 634L759 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M760 633L761 634L760 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M782 633L783 634L782 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M794 633L795 634L794 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M814 633L815 634L814 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M815 633L816 634L815 633M822 633L823 634L822 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M823 633L824 634L823 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M824 633L825 634L824 633M843 633L844 634L843 633M869 633L870 634L869 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M884 633L885 634L884 633M974 633L975 634L974 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M991 633L992 634L991 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M992 633L993 634L992 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1043 633L1044 634L1043 633M1063 633L1064 634L1063 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1064 633L1065 634L1064 633M1071 633L1072 634L1071 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1072 633L1073 634L1072 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1073 633L1074 634L1073 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1092 633L1093 634L1092 633z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M178 634L179 635L178 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M210 634L211 635L210 634M223 634L224 635L223 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M258 634L259 635L258 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M277.667 634.333L278.333 634.667L277.667 634.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M279 634L279 635L285 635L279 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M285 634L285 635L288 635L285 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M288 634L287 647L288 647L288 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M310 634L311 635L310 634M324 634L325 635L324 634M394 634L395 635L394 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M411 634L412 635L411 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M428 634L429 635L428 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M445 634L446 635L445 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M503 634L504 635L503 634M522.667 634.333L523.333 634.667L522.667 634.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M524 634L524 635L530 635L524 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M530 634L530 635L533 635L530 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M533 634L533 646L534 646L533 634M646 634L647 635L646 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M659 634L660 635L659 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M725 634L726 635L725 634M753.667 634.333L754.333 634.667L753.667 634.333M781 634L782 635L781 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M795 634L796 635L795 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M818.667 634.333L819.333 634.667L818.667 634.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M843 634L844 635L843 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M870 634L871 635L870 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M883 634L884 635L883 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M994 634L995 635L994 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M995 634L995 635L1002 635L995 634z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1002 634L1002 635L1005 635L1002 634M1044 634L1045 635L1044 634M1067.67 634.333L1068.33 634.667L1067.67 634.333M1091 634L1092 635L1091 634M177 635L178 636L177 635M195 635L196 636L195 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M211 635L212 636L211 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M221 635L222 636L221 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M222 635L223 636L222 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M295 635L296 636L295 635M312 635L313 636L312 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M322 635L323 636L322 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M394 635L395 636L394 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M428 635L429 636L428 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M444 635L445 636L444 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M503 635L504 636L503 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M630 635L631 636L630 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M647 635L648 636L647 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M657 635L658 636L657 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M658 635L659 636L658 635M726 635L727 636L726 635M796 635L797 636L796 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M842 635L843 636L842 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M855 635L856 636L855 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M871 635L872 636L871 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M882 635L883 636L882 635M975 635L976 636L975 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1091 635L1092 636L1091 635z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M176 636L177 637L176 636M195 636L196 637L195 636M213 636L214 637L213 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M214.667 636.333L215.333 636.667L214.667 636.333M217.667 636.333L218.333 636.667L217.667 636.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M219 636L220 637L219 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M220 636L221 637L220 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M258 636L260 638L258 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M259 636L260 637L259 636M313 636L314 637L313 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M314 636L315 637L314 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M315 636L315 637L319 637L315 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M319.667 636.333L320.333 636.667L319.667 636.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M321 636L322 637L321 636M395 636L396 637L395 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M410 636L411 637L410 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M429 636L430 637L429 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M444 636L445 637L444 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M503 636L504 637L503 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M648 636L649 637L648 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M649 636L650 637L649 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M650 636L650 637L654 637L650 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M654.667 636.333L655.333 636.667L654.667 636.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M656 636L657 637L656 636M727 636L728 637L727 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M780 636L781 637L780 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M841 636L842 637L841 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M855 636L856 637L855 636M873 636L874 637L873 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M874 636L875 637L874 636M878 636L879 637L878 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M879 636L880 637L879 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M880 636L881 637L880 636z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M975 636L976 637L975 636M1045 636L1046 637L1045 636M1090 636L1091 637L1090 636M175 637L176 638L175 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M195 637L196 638L195 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M296 637L297 638L296 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M395 637L396 638L395 637M429 637L430 638L429 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M504 637L505 638L504 637M631 637L632 638L631 637M728 637L729 638L728 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M797 637L798 638L797 637M855 637L856 638L855 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1046 637L1047 638L1046 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1089 637L1090 638L1089 637z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M174 638L175 639L174 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M196 638L197 639L196 638M260 638L261 639L260 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M296 638L297 639L296 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M409 638L410 639L409 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M430 638L431 639L430 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M443 638L444 639L443 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M504 638L505 639L504 638M631 638L632 639L631 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M729 638L730 639L729 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M798 638L799 639L798 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M856 638L857 639L856 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M976 638L977 639L976 638z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1047 638L1048 639L1047 638M1088 638L1089 639L1088 638M172 639L173 640L172 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M196 639L197 640L196 639M260 639L261 640L260 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M297 639L298 640L297 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M396 639L397 640L396 639M430 639L431 640L430 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M505 639L506 640L505 639M632 639L633 640L632 639M730 639L731 640L730 639M776 639L777 640L776 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M799 639L800 640L799 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M856 639L857 640L856 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M957.333 639.667L957.667 640.333L957.333 639.667M977 639L978 640L977 639M1048 639L1049 640L1048 639M1087 639L1088 640L1087 639z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M171 640L172 641L171 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M197 640L198 641L197 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M261 640L262 641L261 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M297 640L298 641L297 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M408 640L409 641L408 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M431 640L432 641L431 640M442 640L443 641L442 640M633 640L634 641L633 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M731 640L732 641L731 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M775 640L776 641L775 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M800 640L801 641L800 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M837 640L838 641L837 640M857 640L858 641L857 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M977 640L978 641L977 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1004 640L1004 644L1005 644L1004 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1049 640L1050 641L1049 640M1086 640L1087 641L1086 640z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M169 641L170 642L169 641M198 641L199 642L198 641M262 641L263 642L262 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M298 641L299 642L298 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M397 641L398 642L397 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M431 641L432 642L431 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M442 641L443 642L442 641M506 641L507 642L506 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M543.333 641.667L543.667 642.333L543.333 641.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M633 641L634 642L633 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M664 641L664 646L665 646L664 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M732 641L733 642L732 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M733 641L734 642L733 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M774 641L775 642L774 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M801 641L802 642L801 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M836 641L837 642L836 641M858 641L859 642L858 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M901 641L902 642L901 641M957 641L957 645L958 645L957 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M978 641L979 642L978 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1050 641L1051 642L1050 641M1085 641L1086 642L1085 641z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M167 642L168 643L167 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M168 642L169 643L168 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M227 642L228 646L229 646L227 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M263 642L264 643L263 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M299 642L300 643L299 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M327 642L328 643L327 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M328 642L329 643L328 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M329.333 642.667L329.667 643.333L329.333 642.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M407 642L408 643L407 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M432 642L433 643L432 642M441 642L442 643L441 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M507 642L508 643L507 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M634 642L635 643L634 642M734 642L735 643L734 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M772 642L773 643L772 642M803 642L804 643L803 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M835 642L836 643L835 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M859 642L860 643L859 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M887 642L888 643L887 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M888 642L888 646L889 646L888 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M901 642L902 643L901 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M979 642L980 643L979 642M1051 642L1052 643L1051 642M1084 642L1085 643L1084 642z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M165 643L166 644L165 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M199 643L200 644L199 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M200 643L201 644L200 643M225 643L226 644L225 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M226 643L227 644L226 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M264 643L265 644L264 643M300 643L301 644L300 643M326 643L327 644L326 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M398 643L399 644L398 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M432 643L433 644L432 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M441 643L442 644L441 643M508 643L509 644L508 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M509 643L510 644L509 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M635 643L636 644L635 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M661 643L662 644L661 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M736 643L737 644L736 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M770 643L771 644L770 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M771 643L772 644L771 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M804 643L805 644L804 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M833 643L834 644L833 643M860 643L861 644L860 643M885 643L886 644L885 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M886 643L887 644L886 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M901 643L901 646L902 646L901 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M980 643L981 644L980 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1053 643L1054 644L1053 643M1082 643L1083 644L1082 643z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M161 644L162 645L161 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M162 644L163 645L162 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M163 644L164 645L163 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M201 644L202 645L201 644M224 644L225 645L224 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M265 644L266 645L265 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M266 644L267 645L266 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M301 644L302 645L301 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M302 644L303 645L302 644M324 644L325 645L324 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M325 644L326 645L325 644M398 644L399 645L398 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M406 644L407 645L406 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M433 644L434 645L433 644M440 644L441 645L440 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M510 644L511 645L510 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M543.333 644.667L543.667 645.333L543.333 644.667z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M636 644L637 645L636 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M637 644L638 645L637 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M660 644L661 645L660 644M738 644L739 645L738 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M768 644L769 645L768 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M769 644L770 645L769 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M806 644L807 645L806 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M831 644L832 645L831 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M832 644L833 645L832 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M861 644L862 645L861 644M884 644L885 645L884 644M982 644L983 645L982 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1054 644L1055 645L1054 644z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1055 644L1056 645L1055 644M1080 644L1081 645L1080 644M156.667 645.333L157.333 645.667L156.667 645.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M158.667 645.333L159.333 645.667L158.667 645.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M202 645L203 646L202 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M203 645L204 646L203 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M222 645L223 646L222 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M223 645L224 646L223 645M267 645L268 646L267 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M268 645L269 646L268 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M303 645L304 646L303 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M304 645L305 646L304 645M322 645L323 646L322 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M323 645L324 646L323 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M399 645L400 646L399 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M433 645L434 646L433 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M440 645L441 646L440 645M511 645L512 646L511 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M512 645L513 646L512 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M513 645L514 646L513 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M638 645L639 646L638 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M639 645L640 646L639 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M658 645L659 646L658 645M740 645L741 646L740 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M741 645L742 646L741 645M765 645L766 646L765 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M766 645L767 646L766 645M808 645L809 646L808 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M809 645L810 646L809 645M829 645L830 646L829 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M830 645L831 646L830 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M863 645L864 646L863 645M882 645L883 646L882 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M957 645L958 646L957 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M984 645L985 646L984 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1056 645L1057 646L1056 645z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1057 645L1058 646L1057 645M1078 645L1079 646L1078 645M205 646L206 647L205 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M206 646L207 647L206 646M218.667 646.333L219.333 646.667L218.667 646.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M220 646L221 647L220 646M228 646L228 647L242 647L228 646M269 646L270 647L269 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M270 646L271 647L270 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M271 646L272 647L271 646M285.667 646.333L286.333 646.667L285.667 646.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M288 646L289 647L288 646M305 646L306 647L305 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M306 646L307 647L306 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M307 646L308 647L307 646M319 646L320 647L319 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M320 646L321 647L320 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M321 646L322 647L321 646M329 646L329 647L342 647L329 646M399 646L400 647L399 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M405 646L406 647L405 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M439 646L440 647L439 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M471 646L471 647L486 647L471 646M514 646L515 647L514 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M515 646L516 647L515 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M516 646L517 647L516 646M530 646L531 647L530 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M531.667 646.333L532.333 646.667L531.667 646.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M543 646L543 647L553 647L543 646M554 646L555 647L554 646M556.667 646.333L557.333 646.667L556.667 646.333M577 646L577 647L591 647L577 646M640 646L641 647L640 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M641 646L642 647L641 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M642 646L643 647L642 646M654 646L655 647L654 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M655 646L656 647L655 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M656 646L657 647L656 646M664 646L664 647L678 647L664 646M743 646L744 647L743 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M744 646L745 647L744 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M745 646L746 647L745 646M761 646L762 647L761 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M762 646L763 647L762 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M763 646L764 647L763 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M811 646L812 647L811 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M812.667 646.333L813.333 646.667L812.667 646.333M825 646L826 647L825 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M826 646L827 647L826 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M827 646L828 647L827 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M865 646L866 647L865 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M866 646L867 647L866 646M878.667 646.333L879.333 646.667L878.667 646.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M880 646L881 647L880 646M889 646L889 647L901 647L889 646M943 646L943 647L957 647L943 646M986 646L987 647L986 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M987.667 646.333L988.333 646.667L987.667 646.333M1001.67 646.333L1002.33 646.667L1001.67 646.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1003 646L1004 647L1003 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1004 646L1005 647L1004 646M1015 646L1015 647L1029 647L1015 646M1059 646L1060 647L1059 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1060 646L1061 647L1060 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#96b3ad",
      stroke: "none"
    },
    d: "M1061 646L1062 647L1061 646M1074 646L1075 647L1074 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M1075 646L1076 647L1075 646z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M1076 646L1077 647L1076 646M1141 646L1141 647L1154 647L1141 646M208.667 647.333L209.333 647.667L208.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M210 647L210 648L216 648L210 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M216 647L217 648L216 647M274.667 647.333L275.333 647.667L274.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M276 647L276 648L282 648L276 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M282.667 647.333L283.333 647.667L282.667 647.333M309.667 647.333L310.333 647.667L309.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M311 647L311 648L316 648L311 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M316.667 647.333L317.333 647.667L316.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M400 647L400 648L405 648L400 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M434 647L435 648L434 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M435 647L435 648L439 648L435 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M439 647L440 648L439 647M518.667 647.333L519.333 647.667L518.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M520 647L520 648L527 648L520 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M527.667 647.333L528.333 647.667L527.667 647.333M644 647L645 648L644 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M645 647L645 648L652 648L645 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M652 647L653 648L652 647M748.667 647.333L749.333 647.667L748.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M750 647L750 648L757 648L750 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M757.667 647.333L758.333 647.667L757.667 647.333M815 647L815 648L819 648L815 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M819 647L820 648L819 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M820 647L820 648L823 648L820 647M869 647L870 648L869 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M870 647L871 648L870 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M871 647L872 648L871 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M872 647L872 648L876 648L872 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M876 647L877 648L876 647M990.667 647.333L991.333 647.667L990.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M992 647L993 648L992 647z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M993.667 647.333L994.333 647.667L993.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#7e9490",
      stroke: "none"
    },
    d: "M995.667 647.333L996.333 647.667L995.667 647.333z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#115c52",
      stroke: "none"
    },
    d: "M997 647L997 648L1000 648L997 647M1064 647L1064 648L1072 648L1064 647z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareDataWithCoalition);
export default __webpack_public_path__ + "static/media/share_data_with_coalition.29811249e2ff0168321ac8c44451af69.svg";
export { ForwardRef as ReactComponent };